export const RESET_PROFILE_PAGE = 'RESET_PROFILE_PAGE';
export const RESET_PROFILE_PAGE_REQUEST = 'RESET_PROFILE_PAGE_REQUEST';

export const FETCH_PUBLIC_USER_PROFILE = 'FETCH_PUBLIC_USER_PROFILE';
export const REQUEST_PUBLIC_USER_PROFILE = 'REQUEST_PUBLIC_USER_PROFILE';
export const RECEIVE_PUBLIC_USER_PROFILE = 'RECEIVE_PUBLIC_USER_PROFILE';
export const FAILED_PUBLIC_USER_PROFILE = 'FAILED_PUBLIC_USER_PROFILE';
export const RESET_PUBLIC_USER_PROFILE = 'RESET_PUBLIC_USER_PROFILE';
export const SET_SHOW_PROFILE_PAGE_GENERAL_ERROR = 'SET_SHOW_PROFILE_PAGE_GENERAL_ERROR';
export const SET_SOCIAL_LIMIT_ERROR_DIALOG = 'SET_SOCIAL_LIMIT_ERROR_DIALOG';

export const FETCH_DAILY_SUMMARY = 'FETCH_DAILY_SUMMARY';
export const REQUEST_DAILY_SUMMARY = 'REQUEST_DAILY_SUMMARY';
export const RECEIVE_DAILY_SUMMARY = 'RECEIVE_DAILY_SUMMARY';

export const FETCH_REGISTERED_DEVICES = 'FETCH_REGISTERED_DEVICES';
export const REQUEST_REGISTERED_DEVICES = 'REQUEST_REGISTERED_DEVICES';
export const RECEIVE_REGISTERED_DEVICES = 'RECEIVE_REGISTERED_DEVICES';

export const FETCH_VALIDATE_DAILY_SUMMARY = 'FETCH_VALIDATE_DAILY_SUMMARY';
export const REQUEST_VALIDATE_DAILY_SUMMARY = 'REQUEST_VALIDATE_DAILY_SUMMARY';
export const RECEIVE_VALIDATE_DAILY_SUMMARY = 'RECEIVE_VALIDATE_DAILY_SUMMARY';

export const FETCH_VALIDATE_DEVICE_EPOCH = 'FETCH_VALIDATE_DEVICE_EPOCH';
export const REQUEST_VALIDATE_DEVICE_EPOCH = 'REQUEST_VALIDATE_DEVICE_EPOCH';
export const RECEIVE_VALIDATE_DEVICE_EPOCH = 'RECEIVE_VALIDATE_DEVICE_EPOCH';

export const FETCH_VALIDATE_DEVICE_EPOCH_SUMMARY = 'FETCH_VALIDATE_DEVICE_EPOCH_SUMMARY';
export const REQUEST_VALIDATE_DEVICE_EPOCH_SUMMARY = 'REQUEST_VALIDATE_DEVICE_EPOCH_SUMMARY';
export const RECEIVE_VALIDATE_DEVICE_EPOCH_SUMMARY = 'RECEIVE_VALIDATE_DEVICE_EPOCH_SUMMARY';

export const FETCH_VALIDATE_DEVICE_HEART_RATE = 'FETCH_VALIDATE_DEVICE_HEART_RATE';
export const REQUEST_VALIDATE_DEVICE_HEART_RATE = 'REQUEST_VALIDATE_DEVICE_HEART_RATE';
export const RECEIVE_VALIDATE_DEVICE_HEART_RATE = 'RECEIVE_VALIDATE_DEVICE_HEART_RATE';

export const FETCH_VALIDATE_DEVICE_HEART_RATE_SUMMARY = 'FETCH_VALIDATE_DEVICE_HEART_RATE_SUMMARY';
export const REQUEST_VALIDATE_DEVICE_HEART_RATE_SUMMARY = 'REQUEST_VALIDATE_DEVICE_HEART_RATE_SUMMARY';
export const RECEIVE_VALIDATE_DEVICE_HEART_RATE_SUMMARY = 'RECEIVE_VALIDATE_DEVICE_HEART_RATE_SUMMARY';

export const SET_MAT_SUPPORT_FILTER = 'SET_MAT_SUPPORT_FILTER';
export const SET_MAT_SUPPORT_EXPANDED_DEVICE = 'SET_MAT_SUPPORT_EXPANDED_DEVICE';
export const SET_MAT_SUPPORT_REPORT_FILTER = 'SET_MAT_SUPPORT_REPORT_FILTER';

export const FETCH_USER_SOCIAL_PROFILE = 'FETCH_USER_SOCIAL_PROFILE';
export const FETCH_USER_SOCIAL_PROFILE_FETCHING = 'FETCH_USER_SOCIAL_PROFILE_FETCHING';
export const FETCH_USER_SOCIAL_PROFILE_SUCCESS = 'FETCH_USER_SOCIAL_PROFILE_SUCCESS';
export const FETCH_USER_SOCIAL_PROFILE_FAIL = 'FETCH_USER_SOCIAL_PROFILE_FAIL';
export const UPDATE_USER_SOCIAL_PROFILE = 'UPDATE_USER_SOCIAL_PROFILE';
export const UPDATE_USER_SOCIAL_PROFILE_UPDATING = 'UPDATE_USER_SOCIAL_PROFILE_UPDATING';
export const UPDATE_USER_SOCIAL_PROFILE_SUCCESS = 'UPDATE_USER_SOCIAL_PROFILE_SUCCESS';
export const UPDATE_USER_SOCIAL_PROFILE_FAIL = 'UPDATE_USER_SOCIAL_PROFILE_FAIL';

export const FETCH_PROFILE_USER_PRIVACY = 'FETCH_PROFILE_USER_PRIVACY';
export const REQUEST_USER_PRIVACY = 'REQUEST_USER_PRIVACY';
export const RECEIVE_USER_PRIVACY = 'RECEIVE_USER_PRIVACY';
export const UPDATE_USER_PRIVACY = 'UPDATE_USER_PRIVACY';
export const UPDATE_USER_SOCIAL_PRIVACY = 'UPDATE_USER_SOCIAL_PRIVACY';
export const FAILED_USER_PRIVACY = 'FAILED_USER_PRIVACY';
export const PROFILE_PAGE_REPORT_SET_REPORT_DIALOG = 'PROFILE_PAGE_REPORT_SET_REPORT_DIALOG';
export const PROFILE_PAGE_REPORT_USER_PROFILE_IMAGE = 'PROFILE_PAGE_REPORT_USER_PROFILE_IMAGE';

export const FETCH_SYSTEM_MESSAGE = 'FETCH_SYSTEM_MESSAGE';
export const RECEIVE_SYSTEM_MESSAGE = 'RECEIVE_SYSTEM_MESSAGE';

export const FETCH_SYSTEM_STATUS = 'FETCH_SYSTEM_STATUS';
export const RECEIVE_SYSTEM_STATUS = 'RECEIVE_SYSTEM_STATUS';

export const SET_PAGE_MESSAGE = 'SET_PAGE_MESSAGE';
export const REMOVE_PAGE_MESSAGE = 'REMOVE_PAGE_MESSAGE';

export const SET_BADGES_PAGE_VIEW = 'SET_BADGES_PAGE_VIEW';
export const RESET_BADGES_PAGE_VIEW = 'RESET_BADGES_PAGE_VIEW';
export const SET_BADGES_TYPE_FILTER = 'SET_BADGES_TYPE_FILTER';
export const SET_BADGES_POINTS_FILTER = 'SET_BADGES_POINTS_FILTER';
export const RESET_BADGES_FILTERS = 'RESET_BADGES_FILTERS';
export const RESET_BADGES = 'RESET_BADGES';

export const REQUEST_LATEST_EARNED_BADGES = 'REQUEST_LATEST_EARNED_BADGES';
export const RECEIVE_LATEST_EARNED_BADGES = 'RECEIVE_LATEST_EARNED_BADGES';
export const FAILED_LATEST_EARNED_BADGES = 'FAILED_LATEST_EARNED_BADGES';
export const REQUEST_BADGE_ATTRIBUTES = 'REQUEST_BADGE_ATTRIBUTES';
export const RECEIVE_BADGE_ATTRIBUTES = 'RECEIVE_BADGE_ATTRIBUTES';
export const FAILED_BADGE_ATTRIBUTES = 'FAILED_BADGE_ATTRIBUTES';
export const REQUEST_EARNED_BADGES = 'REQUEST_EARNED_BADGES';
export const RECEIVE_EARNED_BADGES = 'RECEIVE_EARNED_BADGES';
export const FAILED_EARNED_BADGES = 'FAILED_EARNED_BADGES';
export const REQUEST_AVAILABLE_BADGES = 'REQUEST_AVAILABLE_BADGES';
export const RECEIVE_AVAILABLE_BADGES = 'RECEIVE_AVAILABLE_BADGES';
export const FAILED_AVAILABLE_BADGES = 'FAILED_AVAILABLE_BADGES';
export const REQUEST_COMPARISON_BADGES = 'REQUEST_COMPARISON_BADGES';
export const RECEIVE_COMPARISON_BADGES = 'RECEIVE_COMPARISON_BADGES';
export const FAILED_COMPARISON_BADGES = 'FAILED_COMPARISON_BADGES';

export const FETCH_BADGES_LEADERBOARD = 'FETCH_BADGES_LEADERBOARD';
export const REQUEST_BADGES_LEADERBOARD = 'REQUEST_BADGES_LEADERBOARD';
export const RECEIVE_BADGES_LEADERBOARD = 'RECEIVE_BADGES_LEADERBOARD';
export const FAILED_BADGES_LEADERBOARD = 'FAILED_BADGES_LEADERBOARD';
export const RESET_BADGES_LEADERBOARD = 'RESET_BADGES_LEADERBOARD';

export const REQUEST_BADGE_DETAILS = 'REQUEST_BADGE_DETAILS';
export const RECEIVE_BADGE_DETAILS = 'RECEIVE_BADGE_DETAILS';
export const FAILED_BADGE_DETAILS = 'FAILED_BADGE_DETAILS';

export const UPDATE_VIEWED_BADGES = 'UPDATE_VIEWED_BADGES';
export const BADGE_MARKED_AS_SEEN = 'BADGE_MARKED_AS_SEEN';

export const REQUEST_CONNECTIONS_FOR_BADGE = 'REQUEST_CONNECTIONS_FOR_BADGE';
export const RECEIVE_CONNECTIONS_FOR_BADGE = 'RECEIVE_CONNECTIONS_FOR_BADGE';
export const REQUEST_REPEATABLE_BADGE_DETAILS = 'REQUEST_REPEATABLE_BADGE_DETAILS';
export const RECEIVE_REPEATABLE_BADGE_DETAILS = 'RECEIVE_REPEATABLE_BADGE_DETAILS';

export const REQUEST_ACTIVITY_BADGES = 'REQUEST_ACTIVITY_BADGES';
export const RECEIVE_ACTIVITY_BADGES = 'RECEIVE_ACTIVITY_BADGES';
export const FAILED_ACTIVITY_BADGES = 'FAILED_ACTIVITY_BADGES';

export const REQUEST_DAILY_SUMMARY_BADGES = 'REQUEST_DAILY_SUMMARY_BADGES';
export const RECEIVE_DAILY_SUMMARY_BADGES = 'RECEIVE_DAILY_SUMMARY_BADGES';
export const FAILED_DAILY_SUMMARY_BADGES = 'FAILED_DAILY_SUMMARY_BADGES';

export const UPDATE_BADGE_LEVELUP_VIEWED = 'UPDATE_BADGE_LEVELUP_VIEWED';

export const REQUEST_COMMENTS = 'REQUEST_COMMENTS';
export const RECEIVE_COMMENTS = 'RECEIVE_COMMENTS';
export const FAILED_COMMENTS = 'FAILED_COMMENTS';

export const ADD_CONVERSASION_COMMENT = 'ADD_CONVERSASION_COMMENT';
export const ADD_CONVERSASION_COMMENT_DONE = 'ADD_CONVERSASION_COMMENT_DONE';
export const ADD_COMMENT = 'ADD_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const EDIT_COMMENT_START = 'EDIT_COMMENT_START';
export const EDIT_COMMENT_DONE = 'EDIT_COMMENT_DONE';
export const EDIT_COMMENT_ERROR = 'EDIT_COMMENT_ERROR';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';

export const ADD_COMMENT_LIKE = 'ADD_COMMENT_LIKE';
export const REMOVE_COMMENT_LIKE = 'REMOVE_COMMENT_LIKE';
export const MANAGE_COMMENT_LIKES = 'MANAGE_COMMENT_LIKES';

export const RESET_COMMENTS = 'RESET_COMMENTS';
export const FETCH_COMMENTS = 'FETCH_COMMENTS';

export const FETCH_COMMENT_LIKES = 'FETCH_COMMENT_LIKES';
export const REQUEST_COMMENT_LIKES = 'REQUEST_COMMENT_LIKES';
export const RECEIVE_COMMENT_LIKES = 'RECEIVE_COMMENT_LIKES';
export const RESET_COMMENT_LIKES = 'RESET_COMMENT_LIKES';

export const FETCH_CONVERSATION = 'FETCH_CONVERSATION';
export const REQUEST_CONVERSATION = 'REQUEST_CONVERSATION';
export const POST_CONVERSATION = 'POST_CONVERSATION';
export const RECEIVE_CONVERSATION = 'RECEIVE_CONVERSATION';
export const MANAGE_COMMENTS = 'MANAGE_COMMENTS';
export const MANAGE_LIKES = 'MANAGE_LIKES';
export const REMOVE_PROFILE_PAGE_COMMENTS_PROFILE_IMAGE = 'REMOVE_PROFILE_PAGE_COMMENTS_PROFILE_IMAGE';
export const RESET_CONVERSATION = 'RESET_CONVERSATION';

export const REQUEST_CONVERSATION_LIKES = 'REQUEST_CONVERSATION_LIKES';
export const RECEIVE_CONVERSATION_LIKES = 'RECEIVE_CONVERSATION_LIKES';
export const RESET_CONVERSATION_LIKES = 'RESET_CONVERSATION_LIKES';

export const ADD_CONVERSATION_LIKE = 'ADD_CONVERSATION_LIKE';
export const REMOVE_CONVERSATION_LIKE = 'REMOVE_CONVERSATION_LIKE';
export const FETCH_CONVERSATION_LIKES = 'FETCH_CONVERSATION_LIKES';
export const FETCH_CONVERSATION_LIKES_FETCHING = 'FETCH_CONVERSATION_LIKES_FETCHING';
export const FETCH_CONVERSATION_LIKES_FINISHED = 'FETCH_CONVERSATION_LIKES_FINISHED';

export const RESET_MUTUAL_CONNECTIONS = 'RESET_MUTUAL_CONNECTIONS';
export const FETCH_MUTUAL_CONNECTIONS = 'FETCH_MUTUAL_CONNECTIONS';
export const FETCH_MUTUAL_CONNECTIONS_FETCHING = 'FETCH_MUTUAL_CONNECTIONS_FETCHING';
export const FETCH_MUTUAL_CONNECTIONS_SUCCESS = 'FETCH_MUTUAL_CONNECTIONS_SUCCESS';
export const FETCH_MUTUAL_CONNECTIONS_FAIL = 'FETCH_MUTUAL_CONNECTIONS_FAIL';

export const POST_GROUP_CONVERSATION = 'POST_GROUP_CONVERSATION';
export const FETCH_GROUP_CONVERSATION = 'FETCH_GROUP_CONVERSATION';
export const ADD_GROUP_CONVERSATION_LIKE = 'ADD_GROUP_CONVERSATION_LIKE';
export const REMOVE_GROUP_CONVERSATION_LIKE = 'REMOVE_GROUP_CONVERSATION_LIKE';
export const REQUEST_GROUP_CONVERSATION = 'REQUEST_GROUP_CONVERSATION';
export const RECEIVE_GROUP_CONVERSATION = 'RECEIVE_GROUP_CONVERSATION';
export const MANAGE_GROUP_COMMENTS = 'MANAGE_GROUP_COMMENTS';
export const MANAGE_GROUP_LIKES = 'MANAGE_GROUP_LIKES';

export const REQUEST_GROUP_CONVERSATION_LIKES = 'REQUEST_GROUP_CONVERSATION_LIKES';
export const RECEIVE_GROUP_CONVERSATION_LIKES = 'RECEIVE_GROUP_CONVERSATION_LIKES';

export const FETCH_GROUP_CONVERSATION_LIKES = 'FETCH_GROUP_CONVERSATION_LIKES';
export const FETCH_GROUP_CONVERSATION_LIKES_FETCHING = 'FETCH_GROUP_CONVERSATION_LIKES_FETCHING';
export const FETCH_GROUP_CONVERSATION_LIKES_FINISHED = 'FETCH_GROUP_CONVERSATION_LIKES_FINISHED';

export const ACCEPT_CONNECTION_REQUEST = 'ACCEPT_CONNECTION_REQUEST';
export const DECLINE_CONNECTION_REQUEST = 'DECLINE_CONNECTION_REQUEST';
export const CANCEL_CONNECTION_REQUEST = 'CANCEL_CONNECTION_REQUEST';
export const BLOCK_USER_REQUEST = 'BLOCK_USER_REQUEST';
export const UNBLOCK_USER_REQUEST = 'UNBLOCK_USER_REQUEST';

export const DISCONNECT_CONNECTION = 'DISCONNECT_CONNECTION';

export const FETCH_CONNECTION_PROFILE_STATUS = 'FETCH_CONNECTION_PROFILE_STATUS';
export const REQUEST_CONNECTION_PROFILE_STATUS = 'REQUEST_CONNECTION_PROFILE_STATUS';
export const RECEIVE_CONNECTION_PROFILE_STATUS = 'RECEIVE_CONNECTION_PROFILE_STATUS';
export const FAILED_CONNECTION_PROFILE_STATUS = 'FAILED_CONNECTION_PROFILE_STATUS';
export const RESET_CONNECTION_PROFILE_STATUS = 'RESET_CONNECTION_PROFILE_STATUS';
export const SAVE_SEND_CONNECTION_REQUEST = 'SAVE_SEND_CONNECTION_REQUEST';

export const FETCH_PROFILE_PENDING_CONNECTIONS = 'FETCH_PROFILE_PENDING_CONNECTIONS';
export const REQUEST_PENDING_CONNECTIONS = 'REQUEST_PENDING_CONNECTIONS';
export const RECEIVE_PENDING_CONNECTIONS = 'RECEIVE_PENDING_CONNECTIONS';
export const RESET_PENDING_CONNECTIONS = 'RESET_PENDING_CONNECTIONS';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const REQUEST_USER_PERSONAL_INFO = 'REQUEST_USER_PERSONAL_INFO';
export const RECEIVE_USER_PERSONAL_INFO = 'RECEIVE_USER_PERSONAL_INFO';
export const FAILED_USER_PERSONAL_INFO = 'FAILED_USER_PERSONAL_INFO';
export const RESET_USER_PERSONAL_INFO = 'RESET_USER_PERSONAL_INFO';
export const FETCH_USER_PERSONAL_INFO = 'FETCH_USER_PERSONAL_INFO';

export const REQUEST_USER_DAILY_STEPS = 'REQUEST_USER_DAILY_STEPS';
export const RECEIVE_USER_DAILY_STEPS = 'RECEIVE_USER_DAILY_STEPS';
export const FAILED_USER_DAILY_STEPS = 'FAILED_USER_DAILY_STEPS';
export const RESET_USER_DAILY_STEPS = 'RESET_USER_DAILY_STEPS';
export const FETCH_USER_DAILY_STEPS = 'FETCH_USER_DAILY_STEPS';

export const FETCH_USER_STATISTICS = 'FETCH_USER_STATISTICS';
export const REQUEST_USER_STATISTICS = 'REQUEST_USER_STATISTICS';
export const RECEIVE_USER_STATISTICS = 'RECEIVE_USER_STATISTICS';
export const RESET_USER_STATISTICS = 'RESET_USER_STATISTICS';

export const FETCH_FAVORITE_ACTIVITIES = 'FETCH_FAVORITE_ACTIVITIES';
export const REQUEST_FAVORITE_ACTIVITIES = 'REQUEST_FAVORITE_ACTIVITIES';
export const RECEIVE_FAVORITE_ACTIVITIES = 'RECEIVE_FAVORITE_ACTIVITIES';
export const RESET_FAVORITE_ACTIVITIES = 'RESET_FAVORITE_ACTIVITIES';

export const REQUEST_CALENDAR_PREFERENCES = 'REQUEST_CALENDAR_PREFERENCES';
export const RECEIVE_CALENDAR_PREFERENCES = 'RECEIVE_CALENDAR_PREFERENCES';
export const UPDATE_CALENDAR_PREFERENCES = 'UPDATE_CALENDAR_PREFERENCES';
export const FETCH_TRAINING_PLAN_CALENDAR_NOTE = 'FETCH_TRAINING_PLAN_CALENDAR_NOTE';
export const SET_MODAL_DISPATCHER = 'SET_MODAL_DISPATCHER';
export const RESET_MODAL_DISPATCHER = 'RESET_MODAL_DISPATCHER';
export const SHOW_ADD_MENU = 'SHOW_ADD_MENU';
export const HIDE_ADD_MENU = 'HIDE_ADD_MENU';
export const SET_CALENDAR_YEAR_AND_MONTH = 'SET_CALENDAR_YEAR_AND_MONTH';
export const REQUEST_CALENDAR_WEEK = 'REQUEST_CALENDAR_WEEK';
export const RECEIVE_CALENDAR_WEEK = 'RECEIVE_CALENDAR_WEEK';
export const REQUEST_CALENDAR_MONTH = 'REQUEST_CALENDAR_MONTH';
export const RECEIVE_CALENDAR_MONTH = 'RECEIVE_CALENDAR_MONTH';
export const REQUEST_CALENDAR_YEAR = 'REQUEST_CALENDAR_YEAR';
export const RECEIVE_CALENDAR_YEAR = 'RECEIVE_CALENDAR_YEAR';
export const UPDATE_CALENDAR_ITEMS = 'UPDATE_CALENDAR_ITEMS';
export const SET_CALENDAR_SNACKBAR = 'SET_CALENDAR_SNACKBAR';
export const SHOW_ADD_SIDEBAR = 'SHOW_ADD_SIDEBAR';
export const REFRESH_CALENDAR = 'REFRESH_CALENDAR';
export const HIDE_ADD_SIDEBAR = 'HIDE_ADD_SIDEBAR';
export const ADD_CALENDAR_NOTE = 'ADD_CALENDAR_NOTE';
export const UPDATE_CALENDAR_NOTE = 'UPDATE_CALENDAR_NOTE';
export const DELETE_CALENDAR_NOTE = 'DELETE_CALENDAR_NOTE';
export const REQUEST_CALENDAR_NOTE = 'REQUEST_CALENDAR_NOTE';
export const RECEIVE_CALENDAR_NOTE = 'RECEIVE_CALENDAR_NOTE';
export const UPDATE_CALENDAR_ITEM_DATE = 'UPDATE_CALENDAR_ITEM_DATE';
export const FETCH_CALENDAR_EVENT = 'FETCH_CALENDAR_EVENT';
export const ADD_CALENDAR_EVENT = 'ADD_CALENDAR_EVENT';
export const DELETE_CALENDAR_EVENT = 'DELETE_CALENDAR_EVENT';
export const SUBSCRIBE_TO_EVENT = 'SUBSCRIBE_TO_EVENT';
export const REMOVE_EVENT_FROM_CALENDAR = 'REMOVE_EVENT_FROM_CALENDAR';
export const UPDATE_EVENT_IMAGE = 'UPDATE_EVENT_IMAGE';
export const DELETE_EVENT_IMAGE = 'DELETE_EVENT_IMAGE';
export const UPDATE_CALENDAR_EVENT = 'UPDATE_CALENDAR_EVENT';
export const REQUEST_CALENDAR_EVENT = 'REQUEST_CALENDAR_EVENT';
export const RECEIVE_CALENDAR_EVENT = 'RECEIVE_CALENDAR_EVENT';
export const REQUEST_CALENDAR_EXPORT = 'REQUEST_CALENDAR_EXPORT';
export const RECEIVE_CALENDAR_EXPORT = 'RECEIVE_CALENDAR_EXPORT';
export const PUBLISH_CALENDAR_EXPORT = 'PUBLISH_CALENDAR_EXPORT';
export const UNPUBLISH_CALENDAR_EXPORT = 'UNPUBLISH_CALENDAR_EXPORT';
export const DISPLAY_CALENDAR_MESSAGE = 'DISPLAY_CALENDAR_MESSAGE';

export const SEND_CALENDAR_ITEMS_TO_DEVICE = 'SEND_CALENDAR_ITEMS_TO_DEVICE';
export const SEND_CALENDAR_ITEMS_TO_DEVICE_SUCCESS = 'SEND_CALENDAR_ITEMS_TO_DEVICE_SUCCESS';
export const SEND_CALENDAR_ITEMS_TO_DEVICE_ERROR = 'SEND_CALENDAR_ITEMS_TO_DEVICE_ERROR';
export const RESET_CALENDAR_ITMES_TO_DEVICE = 'RESET_CALENDAR_ITMES_TO_DEVICE';

export const REQUEST_TRAINING_PLANS_FOR_DATE = 'REQUEST_TRAINING_PLANS_FOR_DATE';
export const RECEIVE_TRAINING_PLANS_FOR_DATE = 'RECEIVE_TRAINING_PLANS_FOR_DATE';
export const FETCH_TRAINING_PLAN = 'FETCH_TRAINING_PLAN';
export const REQUEST_TRAINING_PLAN = 'REQUEST_TRAINING_PLAN';
export const RECEIVE_TRAINING_PLAN = 'RECEIVE_TRAINING_PLAN';
export const SCHEDULE_TRAINING_PLAN = 'SCHEDULE_TRAINING_PLAN';
export const ADD_WORKOUT_TO_TRAINING_PLAN = 'ADD_WORKOUT_TO_TRAINING_PLAN';
export const REMOVE_WORKOUT_FROM_TRAINING_PLAN = 'REMOVE_WORKOUT_FROM_TRAINING_PLAN';
export const UPDATE_TRAINING_PLAN_NOTE_DATE = 'UPDATE_TRAINING_PLAN_NOTE_DATE';
export const UPDATE_TRAINING_PLAN_WORKOUT_DATE = 'UPDATE_TRAINING_PLAN_WORKOUT_DATE';

export const ADD_WEIGHT = 'ADD_WEIGHT';
export const ADD_WEIGHT_REQUEST = 'ADD_WEIGHT_REQUEST';
export const DELETE_WEIGHT = 'DELETE_WEIGHT';
export const DELETE_WEIGHT_REQUEST = 'DELETE_WEIGHT_REQUEST';

export const REQUEST_ACTIVITY_TYPES = 'REQUEST_ACTIVITY_TYPES';
export const RECEIVE_ACTIVITY_TYPES = 'RECEIVE_ACTIVITY_TYPES';
export const ACTIVITY_TYPES_FAIL = 'ACTIVITY_TYPES_FAIL';

export const FETCH_ACTIVITY_HR_TIME_IN_ZONE = 'FETCH_ACTIVITY_HR_TIME_IN_ZONE';
export const REQUEST_ACTIVITY_HR_TIME_IN_ZONE = 'REQUEST_ACTIVITY_HR_TIME_IN_ZONE';
export const RECEIVE_ACTIVITY_HR_TIME_IN_ZONE = 'RECEIVE_ACTIVITY_HR_TIME_IN_ZONE';
export const ACTIVITY_HR_TIME_IN_ZONE_FAIL = 'ACTIVITY_HR_TIME_IN_ZONE_FAIL';

export const REQUEST_ACTIVITY_POWER_TIME_IN_ZONE = 'REQUEST_ACTIVITY_POWER_TIME_IN_ZONE';
export const RECEIVE_ACTIVITY_POWER_TIME_IN_ZONE = 'RECEIVE_ACTIVITY_POWER_TIME_IN_ZONE';
export const ACTIVITY_POWER_TIME_IN_ZONE_FAIL = 'ACTIVITY_POWER_TIME_IN_ZONE_FAIL';

export const CREATE_ACTIVITY = 'CREATE_ACTIVITY';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';

export const FETCH_ACTIVITY = 'FETCH_ACTIVITY';
export const REQUEST_ACTIVITY = 'REQUEST_ACTIVITY';
export const RECEIVE_ACTIVITY = 'RECEIVE_ACTIVITY';
export const RESET_ACTIVITY = 'RESET_ACTIVITY';
export const REQUEST_CHARTS_ORDER = 'REQUEST_CHARTS_ORDER';
export const FETCH_CHARTS_ORDER = 'FETCH_CHARTS_ORDER';

export const FETCH_GOALS = 'FETCH_GOALS';
export const FETCH_ALL_GOALS = 'FETCH_ALL_GOALS';
export const REQUEST_GOALS = 'REQUEST_GOALS';
export const RECEIVE_GOALS = 'RECEIVE_GOALS';
export const RECEIVE_ALL_GOALS = 'RECEIVE_ALL_GOALS';
export const DELETE_GOAL_REQUEST = 'DELETE_GOAL_REQUEST';
export const DELETE_GOAL = 'DELETE_GOAL';
export const CREATE_GOAL = 'CREATE_GOAL';
export const CREATE_GOAL_REQUEST = 'CREATE_GOAL_REQUEST';
export const CREATING_GOAL = 'CREATING_GOAL';
export const CREATE_GOAL_SUCCESS = 'CREATE_GOAL_SUCCESS';
export const CREATE_GOAL_FAIL = 'CREATE_GOAL_FAIL';
export const UPDATE_GOAL = 'UPDATE_GOAL';
export const UPDATING_GOAL = 'UPDATING_GOAL';
export const UPDATE_GOAL_SUCCESS = 'UPDATE_GOAL_SUCCESS';
export const UPDATE_GOAL_FAIL = 'UPDATE_GOAL_FAIL';

export const REQUEST_COURSES = 'REQUEST_COURSES';
export const RECEIVE_COURSES = 'RECEIVE_COURSES';
export const FETCH_THIRD_PARTY_CONSUMER_INFO = 'FETCH_THIRD_PARTY_CONSUMER_INFO';
export const RECEIVE_THIRD_PARTY_CONSUMER_INFO = 'RECEIVE_THIRD_PARTY_CONSUMER_INFO';

export const REQUEST_WEB_GATEWAY_COURSES = 'REQUEST_WEB_GATEWAY_COURSES';
export const RECEIVE_WEB_GATEWAY_COURSES = 'RECEIVE_WEB_GATEWAY_COURSES';
export const REQUEST_WEB_GATEWAY_COURSES_FOR_CHINA = 'REQUEST_WEB_GATEWAY_COURSES_FOR_CHINA';
export const RECEIVE_WEB_GATEWAY_COURSES_FOR_CHINA = 'RECEIVE_WEB_GATEWAY_COURSES_FOR_CHINA';

export const RESET_EDITABLE_COURSE_DATA = 'RESET_EDITABLE_COURSE_DATA';
export const RESET_EDITABLE_COURSE_DATA_ON_DRAWING_METHOD_CHANGED =
    'RESET_EDITABLE_COURSE_DATA_ON_DRAWING_METHOD_CHANGED';
export const RESET_EDITABLE_COURSE_DRAWING_DATA = 'RESET_EDITABLE_COURSE_DRAWING_DATA';
export const ADD_EDITABLE_COURSE_DATA = 'ADD_EDITABLE_COURSE_DATA';
export const ADD_EDITABLE_COURSE_DRAWING_DATA = 'ADD_EDITABLE_COURSE_DRAWING_DATA';
export const DELETE_COURSE_POINTS_RESTS = 'DELETE_COURSE_POINTS_RESTS';
export const DELETE_COURSE_POINTS_CUTOFFS = 'DELETE_COURSE_POINTS_CUTOFFS';
export const DELETE_COURSE_POINTS_NOTES = 'DELETE_COURSE_POINTS_NOTES';

export const ADD_IMPORTED_COURSE_DATA = 'ADD_IMPORTED_COURSE_DATA';
export const RESET_IMPORTED_COURSE_DATA = 'RESET_IMPORTED_COURSE_DATA';

export const CREATE_NEW_COURSE = 'CREATE_NEW_COURSE';
export const CREATE_NEW_COURSE_SUCCESS = 'CREATE_NEW_COURSE_SUCCESS';
export const CREATE_NEW_COURSE_ERROR = 'CREATE_NEW_COURSE_ERROR';
export const UPDATE_COURSE_DATA_SUCCESS = 'UPDATE_COURSE_DATA_SUCCESS';
export const UPDATE_COURSE_DATA_ERROR = 'UPDATE_COURSE_DATA_ERROR';
export const UPDATE_COURSE_DATA = 'UPDATE_COURSE_DATA';

export const UPDATE_COURSE_PRIVACY_SUCCESS = 'UPDATE_COURSE_PRIVACY_SUCCESS';
export const UPDATE_COURSE_PRIVACY_ERROR = 'UPDATE_COURSE_PRIVACY_ERROR';
export const UPDATE_COURSE_PRIVACY = 'UPDATE_COURSE_PRIVACY';

export const UNDO_COURSE_ROUTE_HISTORY = 'UNDO_COURSE_ROUTE_HISTORY';
export const REDO_COURSE_ROUTE_HISTORY = 'REDO_COURSE_ROUTE_HISTORY';

export const SET_COURSE_ELEVATION_CHART_EXPANDED_STATUS = 'SET_COURSE_ELEVATION_CHART_EXPANDED_STATUS';
export const RESET_COURSE_ELEVATION_CHART_EXPANDED_STATUS = 'RESET_COURSE_ELEVATION_CHART_EXPANDED_STATUS';

export const SET_CHART_SELECTED_AREA_START_END_VALUE = 'SET_CHART_SELECTED_AREA_START_END_VALUE';
export const RESET_CHART_SELECTED_AREA_START_END_VALUE = 'RESET_CHART_SELECTED_AREA_START_END_VALUE';

export const SET_ELEVATION_CHART_SELECTED_GEO_POINTS = 'SET_ELEVATION_CHART_SELECTED_GEO_POINTS';
export const RESET_ELEVATION_CHART_SELECTED_GEO_POINTS = 'RESET_ELEVATION_CHART_SELECTED_GEO_POINTS';

export const SET_COURSE_MARKER_DATA = 'SET_COURSE_MARKER_DATA';
export const RESET_COURSE_MARKER_DATA = 'RESET_COURSE_MARKER_DATA';

export const SET_COURSE_ROUTE_SEGMENT = 'SET_COURSE_ROUTE_SEGMENT';
export const SET_COURSE_ROUTE_SEGMENT_SUCCESS = 'SET_COURSE_ROUTE_SEGMENT_SUCCESS';
export const SET_COURSE_ROUTE_SEGMENT_ERROR = 'SET_COURSE_ROUTE_SEGMENT_ERROR';
export const GET_COURSE_ROUTE_SEGMENT = 'GET_COURSE_ROUTE_SEGMENT';
export const GET_COURSE_ROUTE_SEGMENT_SUCCESS = 'GET_COURSE_ROUTE_SEGMENT_SUCCESS';
export const GET_COURSE_ROUTE_SEGMENT_ERROR = 'GET_COURSE_ROUTE_SEGMENT_ERROR';

export const REQUEST_CLIMBS = 'REQUEST_CLIMBS';
export const RECEIVE_CLIMBS = 'RECEIVE_CLIMBS';
export const RECEIVE_CLIMBS_FAILED = 'RECEIVE_CLIMBS_FAILED';
export const RESET_CACHED_CLIMBS = 'RESET_CACHED_CLIMBS';
export const GET_CLIMBS_ON_COURSE = 'GET_CLIMBS_ON_COURSE';
export const REQUEST_CLIMBS_ON_ROUTE = 'REQUEST_CLIMBS_ON_ROUTE';
export const RECEIVE_CLIMBS_ON_ROUTE = 'RECEIVE_CLIMBS_ON_ROUTE';
export const REQUEST_CLIMBS_ON_COURSE = 'REQUEST_CLIMBS_ON_COURSE';
export const RECEIVE_CLIMBS_ON_COURSE = 'RECEIVE_CLIMBS_ON_COURSE';
export const REQUEST_SECONDARY_CLIMBS = 'REQUEST_SECONDARY_CLIMBS';
export const RECEIVE_SECONDARY_CLIMBS = 'RECEIVE_SECONDARY_CLIMBS';
export const RESET_SECONDARY_CLIMBS = 'RESET_SECONDARY_CLIMBS';
export const RESET_CLIMBS_ON_ROUTE_OR_COURSE = 'RESET_CLIMBS_ON_ROUTE_OR_COURSE';
export const REQUEST_HAZARDS = 'REQUEST_HAZARDS';
export const RECEIVE_HAZARDS = 'RECEIVE_HAZARDS';
export const RECEIVE_HAZARDS_FAILED = 'RECEIVE_HAZARDS_FAILED';
export const REQUEST_HAZARDS_ON_COURSE = 'REQUEST_HAZARDS_ON_COURSE';
export const RESET_HAZARDS = 'RESET_HAZARDS';

export const FETCH_WHEELCHAIR_WORKOUTS = 'FETCH_WHEELCHAIR_WORKOUTS';
export const FETCH_WHEELCHAIR_WORKOUTS_FETCHING = 'FETCH_WHEELCHAIR_WORKOUTS_FETCHING';
export const FETCH_WHEELCHAIR_WORKOUTS_FINISHED = 'FETCH_WHEELCHAIR_WORKOUTS_FINISHED';

export const FETCH_WORKOUTS = 'FETCH_WORKOUTS';
export const FETCH_WORKOUTS_FETCHING = 'FETCH_WORKOUTS_FETCHING';
export const FETCH_WORKOUTS_FINISHED = 'FETCH_WORKOUTS_FINISHED';

export const FETCH_PROVIDER_WORKOUTS = 'FETCH_PROVIDER_WORKOUTS';
export const FETCH_PROVIDER_WORKOUTS_FETCHING = 'FETCH_PROVIDER_WORKOUTS_FETCHING';
export const FETCH_PROVIDER_WORKOUTS_FINISHED = 'FETCH_PROVIDER_WORKOUTS_FINISHED';

export const FETCH_WORKOUT_BY_ID = 'FETCH_WORKOUT_BY_ID';
export const FETCH_WORKOUT_BY_ID_FETCHING = 'FETCH_WORKOUT_BY_ID_FETCHING';
export const FETCH_WORKOUT_BY_ID_FINISHED = 'FETCH_WORKOUT_BY_ID_FINISHED';

export const UPDATE_FILTERED_WORKOUTS = 'UPDATE_FILTERED_WORKOUTS';
export const UPDATE_WORKOUTS_FILTER = 'UPDATE_WORKOUTS_FILTER';
export const RESET_WORKOUTS_FILTER = 'RESET_WORKOUTS_FILTER';

export const RESCHEDULE_WORKOUT = 'RESCHEDULE_WORKOUT';
export const SCHEDULE_WORKOUT = 'SCHEDULE_WORKOUT';
export const SCHEDULE_WORKOUT_REQUEST = 'SCHEDULE_WORKOUT_REQUEST';
export const REMOVE_SCHEDULED_WORKOUT = 'REMOVE_SCHEDULED_WORKOUT';
export const REMOVE_SCHEDULED_WORKOUT_REQUEST = 'REMOVE_SCHEDULED_WORKOUT_REQUEST';

export const FETCH_WORKOUT_SCHEDULE = 'FETCH_WORKOUT_SCHEDULE';
export const REQUEST_WORKOUT_SCHEDULE = 'REQUEST_WORKOUT_SCHEDULE';
export const RECEIVE_WORKOUT_SCHEDULE = 'RECEIVE_WORKOUT_SCHEDULE';

export const COPY_WORKOUT = 'COPY_WORKOUT';
export const DELETE_WORKOUT = 'DELETE_WORKOUT';
export const UPLOAD_AUDIO_NOTE = 'UPLOAD_AUDIO_NOTE';
export const DELETE_AUDIO_NOTE = 'DELETE_AUDIO_NOTE';

export const FETCH_WORKOUTS_EXPORT = 'FETCH_WORKOUTS_EXPORT';
export const REQUEST_WORKOUTS_EXPORT = 'REQUEST_WORKOUTS_EXPORT';
export const RECEIVE_WORKOUTS_EXPORT = 'RECEIVE_WORKOUTS_EXPORT';

export const FETCH_WORKOUT_TYPES = 'FETCH_WORKOUT_TYPES';
export const FETCH_WORKOUT_TYPES_FETCHING = 'FETCH_WORKOUT_TYPES_FETCHING';
export const FETCH_WORKOUT_TYPES_SUCCESS = 'FETCH_WORKOUT_TYPES_SUCCESS';
export const FETCH_WORKOUT_TYPES_FAIL = 'FETCH_WORKOUT_TYPES_FAIL';

export const FETCH_WORKOUT_ALL_TYPES = 'FETCH_WORKOUT_ALL_TYPE';
export const FETCH_WORKOUT_ALL_TYPES_FETCHING = 'FETCH_WORKOUT_ALL_TYPE_FETCHING';
export const FETCH_WORKOUT_ALL_TYPES_SUCCESS = 'FETCH_WORKOUT_ALL_TYPE_SUCCESS';
export const FETCH_WORKOUT_ALL_TYPES_FAIL = 'FETCH_WORKOUT_ALL_TYPE_FAIL';

export const FETCH_EXERCISE_DATA = 'FETCH_EXERCISE_DATA';
export const FETCH_EXERCISE_DATA_FETCHING = 'FETCH_EXERCISE_DATA_FETCHING';
export const FETCH_EXERCISE_DATA_FINISHED = 'FETCH_EXERCISE_DATA_FINISHED';

export const FETCH_UPCOMING_EVENTS = 'FETCH_UPCOMING_EVENTS';
export const REQUEST_UPCOMING_EVENTS = 'REQUEST_UPCOMING_EVENTS';
export const RECEIVE_UPCOMING_EVENTS = 'RECEIVE_UPCOMING_EVENTS';
export const RESET_UPCOMING_EVENTS = 'RESET_UPCOMING_EVENTS';

export const FETCH_UPCOMING_CAL_EVENTS = 'FETCH_UPCOMING_CAL_EVENTS';
export const REQUEST_UPCOMING_CAL_EVENTS = 'REQUEST_UPCOMING_CAL_EVENTS';
export const RECEIVE_UPCOMING_CAL_EVENTS = 'RECEIVE_UPCOMING_CAL_EVENTS';
export const RESET_UPCOMING_CAL_EVENTS = 'RESET_UPCOMING_CAL_EVENTS';

export const SELECT_PROFILE_PAGE_TAB = 'SELECT_PROFILE_PAGE_TAB';

export const FETCH_MONTHLY_REPORT = 'FETCH_MONTHLY_REPORT';
export const REQUEST_MONTHLY_REPORT = 'REQUEST_MONTHLY_REPORT';
export const RECEIVE_MONTHLY_REPORT = 'RECEIVE_MONTHLY_REPORT';
export const RESET_MONTHLY_REPORT = 'RESET_MONTHLY_REPORT';

export const REQUEST_MONTHLY_STEPS_REPORT = 'REQUEST_MONTHLY_STEPS_REPORT';
export const RECEIVE_MONTHLY_STEPS_REPORT = 'RECEIVE_MONTHLY_STEPS_REPORT ';

export const FETCH_STEPS_REPORT = 'FETCH_STEPS_REPORT';
export const FETCH_DAILY_STEPS_REPORT = 'FETCH_DAILY_STEPS_REPORT';
export const REQUEST_DAILY_STEPS_REPORT = 'REQUEST_DAILY_STEPS_REPORT';
export const RECEIVE_DAILY_STEPS_REPORT = 'RECEIVE_DAILY_STEPS_REPORT';

export const REQUEST_LIFETIME_STEPS_REPORT = 'REQUEST_LIFETIME_DAILY_STEPS_REPORT';
export const RECEIVE_LIFETIME_STEPS_REPORT = 'RECEIVE_LIFETIME_DAILY_STEPS_REPORT';
export const RESET_STEPS_REPORT = 'RESET_STEPS_REPORT ';

export const FETCH_USER_PRIVACY = 'FETCH_USER_PRIVACY';
export const FETCH_USER_PRIVACY_START = 'FETCH_USER_PRIVACY_START';
export const FETCH_USER_PRIVACY_SUCCESS = 'FETCH_USER_PRIVACY_SUCCESS';
export const FETCH_USER_PRIVACY_ERROR = 'FETCH_USER_PRIVACY_ERROR';
export const SAVE_UPDATED_USER_PRIVACY = 'SAVE_UPDATED_USER_PRIVACY';
export const SET_USER_PRIVACY_START = 'SET_USER_PRIVACY_START';
export const SET_USER_PRIVACY_SUCCESS = 'SET_USER_PRIVACY_SUCCESS';
export const SET_USER_PRIVACY_ERROR = 'SET_USER_PRIVACY_ERROR';
export const FETCH_BULK_PRIVACY = 'FETCH_BULK_PRIVACY';
export const FETCH_BULK_PRIVACY_START = 'FETCH_BULK_PRIVACY_START';
export const FETCH_BULK_PRIVACY_SUCCESS = 'FETCH_BULK_PRIVACY_SUCCESS';
export const FETCH_BULK_PRIVACY_ERROR = 'FETCH_BULK_PRIVACY_ERROR';
export const SAVE_BULK_PRIVACY = 'SAVE_BULK_PRIVACY';
export const SET_BULK_PRIVACY_START = 'SET_BULK_PRIVACY_START';
export const SET_BULK_PRIVACY_SUCCESS = 'SET_BULK_PRIVACY_SUCCESS';
export const SET_BULK_PRIVACY_ERROR = 'SET_BULK_PRIVACY_ERROR';

export const FETCHING_POWER_GUIDANCE_START = 'FETCHING_POWER_GUIDANCE_START';
export const FETCHING_POWER_GUIDANCE_ERROR = 'FETCHING_POWER_GUIDANCE_ERROR';
export const FINISHED_FETCHING_POWER_GUIDANCE = 'FINISHED_FETCHING_POWER_GUIDANCE';

export const FETCH_POWER_GUIDE_BY_COURSE_ID = 'FETCH_POWER_GUIDE_BY_COURSE_ID';
export const FETCHING_POWER_GUIDE_BY_COURSE_ID_START = 'FETCHING_POWER_GUIDE_BY_COURSE_ID_START';
export const FINISHED_FETCHING_POWER_GUIDE_BY_COURSE_ID = 'FINISHED_FETCHING_POWER_GUIDE_BY_COURSE_ID';
export const FETCHING_POWER_GUIDE_BY_COURSE_ID_START_ERROR = 'FETCHING_POWER_GUIDE_BY_COURSE_ID_START_ERROR';

export const FETCH_POWER_GUIDANCE = 'FETCH_POWER_GUIDANCE';
export const SET_POWER_GUIDANCE_COURSE_NAME = 'SET_POWER_GUIDANCE_COURSE_NAME';
export const SET_POWER_GUIDANCE_EFFORT_LEVEL = 'SET_POWER_GUIDANCE_EFFORT_LEVEL';
export const DELETE_POWER_GUIDANCE = 'DELETE_POWER_GUIDANCE';
export const DELETE_POWER_GUIDANCE_SUCCESS = 'DELETE_POWER_GUIDANCE_SUCCESS';
export const SAVE_POWER_GUIDANCE = 'SAVE_POWER_GUIDANCE';
export const SEND_POWER_GUIDANCE_TO_DEVICE = 'SEND_POWER_GUIDANCE_TO_DEVICE';
export const FETCH_POWER_GUIDANCE_STRATEGY = 'FETCH_POWER_GUIDANCE_STRATEGY';
export const DUPLICATE_POWER_GUIDANCE_STRATEGY = 'DUPLICATE_POWER_GUIDANCE_STRATEGY';
export const SEND_POWER_GUIDANCE_TO_DEVICE_SUCCESS = 'SEND_POWER_GUIDANCE_TO_DEVICE_SUCCESS';
export const SEND_POWER_GUIDANCE_TO_DEVICE_ERROR = 'SEND_POWER_GUIDANCE_TO_DEVICE_ERROR';
export const DUPLICATE_POWER_GUIDANCE_ERROR = 'DUPLICATE_POWER_GUIDANCE_ERROR';
export const DELETE_POWER_GUIDANCE_ERROR = 'DELETE_POWER_GUIDANCE_ERROR';
export const FETCH_POWER_GUIDANCE_COURSE_DETAILS = 'FETCH_POWER_GUIDANCE_COURSE_DETAILS';
export const FETCH_POWER_GUIDANCE_COURSE_DETAILS_SUCCESS = 'FETCH_POWER_GUIDANCE_COURSE_DETAILS_SUCCESS';
export const FETCH_POWER_GUIDANCE_COURSE_DETAILS_FAIL = 'FETCH_POWER_GUIDANCE_COURSE_DETAILS_FAIL';
export const FETCH_POWER_GUIDANCE_DETAILS = 'FETCH_POWER_GUIDANCE_DETAILS';
export const SET_SPECIFIC_DATA_TO_POWER_GUIDE = 'SET_SPECIFIC_DATA_TO_POWER_GUIDE';
export const FETCH_POWER_GUIDANCE_DETAILS_SUCCESS = 'FETCH_POWER_GUIDANCE_DETAILS_SUCCESS';
export const FETCH_POWER_GUIDANCE_DETAILS_FAIL = 'FETCH_POWER_GUIDANCE_DETAILS_FAIL';
export const SET_POWER_GUIDANCE_SUMMARY_FROM_ALGORITHM_DATA = 'SET_POWER_GUIDANCE_SUMMARY_FROM_ALGORITHM_DATA';
export const SET_POWER_GUIDANCE_SPLITS_FROM_ALGORITHM_DATA = 'SET_POWER_GUIDANCE_SPLITS_FROM_ALGORITHM_DATA';
export const SAVE_POWER_GUIDANCE_SUCCESS = 'SAVE_POWER_GUIDANCE_SUCCESS';
export const SAVE_POWER_GUIDANCE_FAIL = 'SAVE_POWER_GUIDANCE_FAIL';
export const UPDATE_POWER_GUIDANCE = 'UPDATE_POWER_GUIDANCE';
export const UPDATE_POWER_GUIDANCE_FAIL = 'UPDATE_POWER_GUIDANCE_FAIL';
export const UPDATE_POWER_GUIDANCE_SUCCESS = 'UPDATE_POWER_GUIDANCE_SUCCESS';
export const FETCH_FITNESS_STATS_START = 'FETCH_FITNESS_STATS_START';
export const FETCH_FITNESS_STATS_SUCCESS = 'FETCH_FITNESS_STATS_SUCCESS';
export const FETCH_FITNESS_STATS_ERROR = 'FETCH_FITNESS_STATS_ERROR';
export const FETCH_FITNESS_STATS = 'FETCH_FITNESS_STATS';
export const RESET_POWER_GUIDANCE_DATA = 'RESET_POWER_GUIDANCE_DATA';
export const FETCH_LATEST_FUNCTIONAL_THRESHOLD = 'FETCH_LATEST_FUNCTIONAL_THRESHOLD';
export const FETCH_LATEST_FUNCTIONAL_THRESHOLD_START = 'FETCH_LATEST_FUNCTIONAL_THRESHOLD_START';
export const FETCH_LATEST_FUNCTIONAL_THRESHOLD_SUCCESS = 'FETCH_LATEST_FUNCTIONAL_THRESHOLD_SUCCESS';
export const FETCH_LATEST_FUNCTIONAL_THRESHOLD_ERROR = 'FETCH_LATEST_FUNCTIONAL_THRESHOLD_ERROR';
export const SAVE_POWER_ZONES_FROM_USER_INFO = 'SAVE_POWER_ZONES_FROM_USER_INFO';
export const SAVE_POWER_ZONES_FROM_USER_INFO_START = 'SAVE_POWER_ZONES_FROM_USER_INFO_START';
export const SAVE_POWER_ZONES_FROM_USER_INFO_SUCCESS = 'SAVE_POWER_ZONES_FROM_USER_INFO_SUCCESS';
export const SAVE_POWER_ZONES_FROM_USER_INFO_ERROR = 'SAVE_POWER_ZONES_FROM_USER_INFO_ERROR';
export const UPDATE_POWER_ZONES = 'UPDATE_POWER_ZONES';
export const UPDATE_POWER_ZONES_START = 'UPDATE_POWER_ZONES_START';
export const UPDATE_POWER_ZONES_SUCCESS = 'UPDATE_POWER_ZONES_SUCCESS';
export const UPDATE_POWER_ZONES_ERROR = ' UPDATE_POWER_ZONES_ERROR';

export const SET_NUTRITION_AND_HYDRATION_WEATHER_FORECAST_TYPE = 'SET_NUTRITION_AND_HYDRATION_WEATHER_FORECAST_TYPE';
export const SET_NUTRITION_AND_HYDRATION_CUSTOM_TEMPERATURE = 'SET_NUTRITION_AND_HYDRATION_CUSTOM_TEMPERATURE';
export const SET_NUTRITION_AND_HYDRATION_RECOMMENDATION_DATA = 'SET_NUTRITION_AND_HYDRATION_RECOMMENDATION_DATA';
export const SET_NUTRITION_AND_HYDRATION_TODAY_TEMPERATURE = 'SET_NUTRITION_AND_HYDRATION_TODAY_TEMPERATURE';
export const RESET_NUTRITION_AND_HYDRATION_DATA = 'RESET_NUTRITION_AND_HYDRATION_DATA';

export const REQUEST_SCORECARD_SUMMARY = 'REQUEST_SCORECARD_SUMMARY';
export const RECEIVE_SCORECARD_SUMMARY = 'RECEIVE_SCORECARD_SUMMARY';
export const RESET_SCORECARD_SUMMARY = 'RESET_SCORECARD_SUMMARY';

export const FETCH_ACTIVITIES = 'FETCH_ACTIVITIES';
export const REQUEST_ACTIVITIES = 'REQUEST_ACTIVITIES';
export const RECEIVE_ACTIVITIES = 'RECEIVE_ACTIVITIES';
export const FETCH_MULTIPLE_ACTIVITIES = 'FETCH_MULTIPLE_ACTIVITIES';
export const REQUEST_MULTIPLE_ACTIVITIES = 'REQUEST_MULTIPLE_ACTIVITIES';
export const RECEIVE_MULTIPLE_ACTIVITIES = 'RECEIVE_MULTIPLE_ACTIVITIES';
export const REMOVE_PROFILE_PAGE_ACTIVITIES_PROFILE_IMAGE = 'REMOVE_PROFILE_PAGE_ACTIVITIES_PROFILE_IMAGE';
export const RESET_ACTIVITIES = 'RESET_ACTIVITIES';

// Activity Details
export const FETCH_ACTIVITY_DETAILS = 'FETCH_ACTIVITY_DETAILS';
export const FETCH_ACTIVITY_DETAILS_BAIDU = 'FETCH_ACTIVITY_DETAILS_BAIDU';
export const FETCH_ACTIVITY_DETAILS_SUCCESS = 'FETCH_ACTIVITY_DETAILS_SUCCESS';
export const FETCH_ACTIVITY_DETAILS_FAIL = 'FETCH_ACTIVITY_DETAILS_FAIL';

export const FETCH_ACTIVITY_DETAILS_METRICS_FOR_UPDATE = 'FETCH_ACTIVITY_DETAILS_METRICS_FOR_UPDATE';
export const FETCH_ACTIVITY_DETAILS_BAIDU_METRICS_FOR_UPDATE = 'FETCH_ACTIVITY_DETAILS_BAIDU_METRICS_FOR_UPDATE';
export const FETCH_ACTIVITY_DETAILS_METRICS_FOR_UPDATE_SUCCESS = 'FETCH_ACTIVITY_DETAILS_METRICS_FOR_UPDATE_SUCCESS';

// Activity Weather
export const FETCH_ACTIVITY_WEATHER = 'FETCH_ACTIVITY_WEATHER';
export const FETCH_ACTIVITY_DETAILS_START = 'FETCH_ACTIVITY_DETAILS_START';
export const FETCH_ACTIVITY_WEATHER_SUCCESS = 'FETCH_ACTIVITY_WEATHER_SUCCESS';
export const FETCH_ACTIVITY_WEATHER_FAIL = 'FETCH_ACTIVITY_WEATHER_FAIL';
export const RESET_ACTIVITY_WEATHER = 'RESET_ACTIVITY_WEATHER';

// Surf Activity
export const SET_SELECTED_SURF_INDEX = 'SET_SELECTED_SURF_INDEX';

// Activity Polyline
export const FETCH_ACTIVITY_POLYLINE = 'FETCH_ACTIVITY_POLYLINE';
export const FETCH_ACTIVITY_POLYLINE_BAIDU = 'FETCH_ACTIVITY_POLYLINE_BAIDU';
export const REQUEST_ACTIVITY_POLYLINE = 'REQUEST_ACTIVITY_POLYLINE';
export const RECEIVE_ACTIVITY_POLYLINE = 'RECEIVE_ACTIVITY_POLYLINE';
export const RESET_ACTIVITY_POLYLINE = 'RESET_ACTIVITY_POLYLINE';

// Activity Map Details
export const FETCH_ACTIVITY_MAP_DETAILS = 'FETCH_ACTIVITY_MAP_DETAILS';
export const FETCH_ACTIVITY_MAP_DETAILS_DONE = 'FETCH_ACTIVITY_MAP_DETAILS_DONE';

export const FETCH_ACTIVITY_MAP_DETAILS_BAIDU = 'FETCH_ACTIVITY_MAP_DETAILS_BAIDU';
// Activity Map Details -- end

export const FETCH_GEAR = 'FETCH_GEAR';
export const REQUEST_GEAR = 'REQUEST_GEAR';
export const RECEIVE_GEAR = 'RECEIVE_GEAR';
export const RESET_GEAR = 'RESET_GEAR';

export const FETCH_ACTIVITIES_365_REPORT = 'FETCH_ACTIVITIES_365_REPORT';
export const REQUEST_ACTIVITIES_365_REPORT = 'REQUEST_ACTIVITIES_365_REPORT';
export const RECEIVE_ACTIVITIES_365_REPORT = 'RECEIVE_ACTIVITIES_365_REPORT';
export const RESET_ACTIVITIES_365_REPORT = 'RESET_ACTIVITIES_365_REPORT';

export const SET_USER_PREFERENCE = 'SET_USER_PREFERENCE';
export const RECEIVE_USER_PREFERENCE = 'RECEIVE_USER_PREFERENCE';
export const REQUEST_USER_PREFERENCE = 'REQUEST_USER_PREFERENCE';
export const FETCH_USER_PREFERENCE_DEP = 'FETCH_USER_PREFERENCE_DEP';
export const SET_USER_PREFERENCE_DEP = 'SET_USER_PREFERENCE_DEP';

export const FETCH_ACTIVITIES_BY_SEARCH = 'FETCH_ACTIVITIES_BY_SEARCH';
export const RECEIVE_ACTIVITIES_BY_SEARCH = 'RECEIVE_ACTIVITIES_BY_SEARCH';
export const REQUEST_ACTIVITIES_BY_SEARCH = 'REQUEST_ACTIVITIES_BY_SEARCH';
export const RECEIVE_ACTIVITIES_BY_SEARCH_ERROR = 'RECEIVE_ACTIVITIES_BY_SEARCH_ERROR';
export const RESET_ACTIVITIES_BY_SEARCH = 'RESET_ACTIVITIES_BY_SEARCH';

export const FAVORITE_ACTIVITY = 'FAVORITE_ACTIVITY';
export const RECEIVE_FAVORITE_ACTIVITY = 'RECEIVE_FAVORITE_ACTIVITY';

export const DELETE_ACTIVITY_BY_SEARCH = 'DELETE_ACTIVITY_BY_SEARCH';
export const RECEIVE_DELETE_ACTIVITY_BY_SEARCH = 'RECEIVE_DELETE_ACTIVITY_BY_SEARCH';

export const SET_SELECTED_DIVE = 'SET_SELECTED_DIVE';

export const SET_GOLF_STATS_PAGE_STATE = 'SET_GOLF_STATS_PAGE_STATE';

export const REQUEST_SEGMENT_TYPES = 'REQUEST_SEGMENT_TYPES';
export const RECEIVE_SEGMENT_TYPES = 'RECEIVE_SEGMENT_TYPES';

export const REQUEST_SURFACE_TYPES = 'REQUEST_SURFACE_TYPES';
export const RECEIVE_SURFACE_TYPES = 'RECEIVE_SURFACE_TYPES';

export const UPDATE_SEGMENT = 'UPDATE_SEGMENT';
export const RECEIVE_ACTIVITY_POLYLINE_FOR_SEGMENT = 'RECEIVE_ACTIVITY_POLYLINE_FOR_SEGMENT';
export const REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT = 'REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT';
export const REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT_FAIL = 'REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT_FAIL';
export const REQUEST_ACTIVITY_POLYLINE_FOR_BAIDU_CONVERT = 'REQUEST_ACTIVITY_POLYLINE_FOR_BAIDU_CONVERT';
export const RECEIVE_ACTIVITY_POLYLINE_FOR_BAIDU_CONVERT = 'RECEIVE_ACTIVITY_POLYLINE_FOR_BAIDU_CONVERT';

export const SAVE_SEGMENT = 'SAVE_SEGMENT';
export const SELECT_SEGMENTS_TAB = 'SELECT_SEGMENTS_TAB';
export const REQUEST_SEGMENTS = 'REQUEST_SEGMENTS';
export const RECEIVE_SEGMENTS = 'RECEIVE_SEGMENTS';
export const RECEIVE_SEGMENTS_ERROR = 'RECEIVE_SEGMENTS_ERROR';

export const TOGGLE_FAVORITE_SEGMENT = 'TOGGLE_FAVORITE_SEGMENT';
export const TOGGLE_FAVORITE_SEGMENT_IN_SEGMENT_DETAILS = 'TOGGLE_FAVORITE_SEGMENT_IN_SEGMENT_DETAILS';
export const ADD_SEGMENT_TO_FAVOURITES = 'ADD_SEGMENT_TO_FAVOURITES';
export const REMOVE_SEGMENT_FROM_FAVOURITES = 'REMOVE_SEGMENT_FROM_FAVOURITES';

export const REQUEST_GROUP_COURSES = 'REQUEST_GROUP_COURSES';
export const RECEIVE_GROUP_COURSES = 'RECEIVE_GROUP_COURSES';
export const RESET_CALENDAR_PAGE = 'RESET_CALENDAR_PAGE';

export const FETCH_ACTIVITY_SUMMARY = 'FETCH_ACTIVITY_SUMMARY';
export const FETCH_ACTIVITY_SUMMARY_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_GROUPED = 'FETCH_ACTIVITY_SUMMARY_GROUPED';
export const FETCH_ACTIVITY_SUMMARY_GROUPED_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_GROUPED_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_WEEKLY = 'FETCH_ACTIVITY_SUMMARY_WEEKLY';
export const FETCH_ACTIVITY_SUMMARY_WEEKLY_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_WEEKLY_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_WEEKLY_GROUPED = 'FETCH_ACTIVITY_SUMMARY_WEEKLY_GROUPED';
export const FETCH_ACTIVITY_SUMMARY_WEEKLY_GROUPED_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_WEEKLY_GROUPED_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_MONTHLY = 'FETCH_ACTIVITY_SUMMARY_MONTHLY';
export const FETCH_ACTIVITY_SUMMARY_MONTHLY_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_MONTHLY_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED = 'FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED';
export const FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_YEARLY = 'FETCH_ACTIVITY_SUMMARY_YEARLY';
export const FETCH_ACTIVITY_SUMMARY_YEARLY_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_YEARLY_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_YEARLY_GROUPED = 'FETCH_ACTIVITY_SUMMARY_YEARLY_GROUPED';
export const FETCH_ACTIVITY_SUMMARY_YEARLY_GROUPED_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_YEARLY_GROUPED_SUCCESS';

export const FETCH_ACTIVITY_SUMMARY_STATS = 'FETCH_ACTIVITY_SUMMARY_STATS';
export const FETCH_ACTIVITY_SUMMARY_STATS_ACTIVITY_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_STATS_ACTIVITY_SUCCESS';
export const FETCH_ACTIVITY_SUMMARY_STATS_EVENT_SUCCESS = 'FETCH_ACTIVITY_SUMMARY_STATS_EVENT_SUCCESS';

export const FETCH_ADAPTIVE_PLAN = 'FETCH_ADAPTIVE_PLAN';
export const FETCH_ADAPTIVE_PLAN_SUCCESS = 'FETCH_ADAPTIVE_PLAN_SUCCESS';
export const FETCH_ADAPTIVE_PLAN_ERROR = 'FETCH_ADAPTIVE_PLAN_ERROR';

export const FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT = 'FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT';
export const FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_SUCCESS = 'FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_SUCCESS';
export const FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_ERROR = 'FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_ERROR';
export const RESET_ADAPTIVE_PLAN_NEXT_WORKOUT = 'RESET_ADAPTIVE_PLAN_NEXT_WORKOUT';
export const FETCHING_ADAPTIVE_PLAN_NEXT_WORKOUT = 'FETCHING_ADAPTIVE_PLAN_NEXT_WORKOUT';

export const UPDATE_ADAPTIVE_PLAN_STATUS = 'UPDATE_ADAPTIVE_PLAN_STATUS';
export const UPDATE_ADAPTIVE_PLAN_STATUS_SUCCESS = 'UPDATE_ADAPTIVE_PLAN_STATUS_SUCCESS';
export const UPDATE_ADAPTIVE_PLAN_STATUS_ERROR = 'UPDATE_ADAPTIVE_PLAN_STATUS_ERROR';

export const REMOVE_ATP_WORKOUT = 'REMOVE_ATP_WORKOUT';

export const FETCH_ADAPTIVE_PLAN_CALENDAR = 'FETCH_ADAPTIVE_PLAN_CALENDAR';
export const FETCH_ADAPTIVE_PLAN_CALENDAR_SUCCESS = 'FETCH_ADAPTIVE_PLAN_CALENDAR_SUCCESS';
export const FETCH_ADAPTIVE_PLAN_CALENDAR_ERROR = 'FETCH_ADAPTIVE_PLAN_CALENDAR_ERROR';
export const FETCHING_ADAPTIVE_PLAN_CALENDAR = 'FETCHING_ADAPTIVE_PLAN_CALENDAR';

export const ENABLE_CONFIRMATION_BUTTON = 'ENABLE_CONFIRMATION_BUTTON';
export const DISABLE_CONFIRMATION_BUTTON = 'DISABLE_CONFIRMATION_BUTTON';

export const FETCH_RESCHEDULE_DAYS = 'FETCH_RESCHEDULE_DAYS';
export const FETCH_RESCHEDULE_DAYS_SUCCESS = 'FETCH_RESCHEDULE_DAYS_SUCCESS';

export const FETCH_SYSTEM_PREFERENCE = 'FETCH_SYSTEM_PREFERENCE';
export const REQUEST_SYSTEM_PREFERENCE = 'REQUEST_SYSTEM_PREFERENCE';
export const RECEIVE_SYSTEM_PREFERENCE = 'RECEIVE_SYSTEM_PREFERENCE';

export const FETCH_USAGE_INDICATORS = 'FETCH_USAGE_INDICATORS';
export const REQUEST_USAGE_INDICATORS = 'REQUEST_USAGE_INDICATORS';
export const RECEIVE_USAGE_INDICATORS = 'RECEIVE_USAGE_INDICATORS';
export const RECEIVE_USAGE_INDICATORS_ERROR = 'RECEIVE_USAGE_INDICATORS_ERROR';

export const FETCH_PLAYER_GOLF_STATS = 'FETCH_PLAYER_GOLF_STATS';
export const FETCH_PLAYER_GOLF_STATS_SUCCESS = 'FETCH_PLAYER_GOLF_STATS_SUCCESS';
export const FETCH_PLAYER_GOLF_STATS_FAIL = 'FETCH_PLAYER_GOLF_STATS_FAIL';

export const FETCH_ALL_DRIVE_GOLF_STATS = 'FETCH_ALLDRIVE_GOLF_STATS';
export const FETCH_ALL_DRIVE_GOLF_STATS_SUCCESS = 'FETCH_ALLDRIVE_GOLF_STATS_SUCCESS';
export const FETCH_FILTERED_DRIVE_GOLF_STATS = 'FETCH_FILTERED_DRIVE_GOLF_STATS';
export const FETCH_FILTERED_DRIVE_GOLF_STATS_SUCCESS = 'FETCH_FILTERED_DRIVE_GOLF_STATS_SUCCESS';

export const FETCH_ALL_APPROACH_GOLF_STATS = 'FETCH_ALL_APPROACH_GOLF_STATS';
export const FETCH_ALL_APPROACH_GOLF_STATS_SUCCESS = 'FETCH_ALL_APPROACH_GOLF_STATS_SUCCESS';
export const FETCH_FILTERED_APPROACH_GOLF_STATS = 'FETCH_FILTERED_APPROACH_GOLF_STATS';
export const FETCH_FILTERED_APPROACH_GOLF_STATS_SUCCESS = 'FETCH_FILTERED_APPROACH_GOLF_STATS_SUCCESS';

export const SET_APPROACH_GOLF_STATS_FILTER = 'SET_APPROACH_GOLF_STATS_FILTER';
export const SET_DRIVE_GOLF_STATS_FILTER = 'SET_DRIVE_GOLF_STATS_FILTER';
export const SET_CHIP_GOLF_STATS_FILTER = 'SET_CHIP_GOLF_STATS_FILTER';
export const SET_PUTT_GOLF_STATS_FILTER = 'SET_PUTT_GOLF_STATS_FILTER';

export const FETCH_GOLF_CLUBS = 'FETCH_GOLF_CLUBS';
export const FETCH_GOLF_CLUBS_SUCCESS = 'FETCH_GOLF_CLUBS_SUCCESS';
export const FETCH_GOLF_CLUB_TYPES = 'FETCH_GOLF_CLUB_TYPES';
export const FETCH_GOLF_CLUB_TYPES_SUCCESS = 'FETCH_GOLF_CLUB_TYPES_SUCCESS';
export const FETCH_GOLF_CLUB_FLEX_TYPES = 'FETCH_GOLF_CLUB_FLEX_TYPES';
export const FETCH_GOLF_CLUB_FLEX_TYPES_SUCCESS = 'FETCH_GOLF_CLUB_FLEX_TYPES_SUCCESS';

export const FETCH_ALL_CHIP_GOLF_STATS = 'FETCH_ALL_CHIP_GOLF_STATS';
export const FETCH_ALL_CHIP_GOLF_STATS_SUCCESS = 'FETCH_ALL_CHIP_GOLF_STATS_SUCCESS';
export const FETCH_FILTERED_CHIP_GOLF_STATS = 'FETCH_FILTERED_CHIP_GOLF_STATS';
export const FETCH_FILTERED_CHIP_GOLF_STATS_SUCCESS = 'FETCH_FILTERED_CHIP_GOLF_STATS_SUCCESS';

export const FETCH_ALL_PUTT_GOLF_STATS = 'FETCH_ALL_PUTT_GOLF_STATS';
export const FETCH_ALL_PUTT_GOLF_STATS_SUCCESS = 'FETCH_ALL_PUTT_GOLF_STATS_SUCCESS';
export const RECEIVE_SEGMENT_DETAILS = 'RECEIVE_SEGMENT_DETAILS';
export const REQUEST_SEGMENT_DETAILS = 'REQUEST_SEGMENT_DETAILS';

export const RESET_SEGMENT_INFO = 'RESET_SEGMENT_INFO';

export const RECEIVE_SEGMENT_LEADERBOARD = 'RECEIVE_SEGMENT_LEADERBOARD';
export const REQUEST_SEGMENT_LEADERBOARD = 'REQUEST_SEGMENT_LEADERBOARD';

export const RECEIVE_SEGMENT_LEADERBOARD_ONLY_ME = 'RECEIVE_SEGMENT_LEADERBOARD_ONLY_ME';
export const REQUEST_SEGMENT_LEADERBOARD_ONLY_ME = 'REQUEST_SEGMENT_LEADERBOARD_ONLY_ME';
export const REQUEST_SEGMENT_LEADERBOARD_ONLY_ME_FAIL = 'REQUEST_SEGMENT_LEADERBOARD_ONLY_ME_FAIL';

export const FETCH_GROUPS = 'FETCH_GROUPS';
export const FETCH_GROUPS_START = 'FETCH_GROUPS_START';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAIL = 'FETCH_GROUPS_FAIL';

export const FETCH_ADMINISTERED_GROUPS = 'FETCH_ADMINISTERED_GROUPS';
export const FETCH_ADMINISTERED_GROUPS_START = 'FETCH_ADMINISTERED_GROUPS_START';
export const FETCH_ADMINISTERED_GROUPS_SUCCESS = 'FETCH_ADMINISTERED_GROUPS_SUCCESS';
export const FETCH_ADMINISTERED_GROUPS_FAIL = 'FETCH_ADMINISTERED_GROUPS_FAIL';

export const FETCH_GROUP_REQUESTS = 'FETCH_GROUP_REQUESTS';
export const FETCH_GROUP_REQUESTS_START = 'FETCH_GROUP_REQUESTS_START';
export const FETCH_GROUP_REQUESTS_SUCCESS = 'FETCH_GROUP_REQUESTS_SUCCESS';
export const FETCH_GROUP_REQUESTS_FAIL = 'FETCH_GROUP_REQUESTS_FAIL';

export const FETCH_UNHANDLED_GROUP_REQUESTS = 'FETCH_UNHANDLED_GROUP_REQUESTS';
export const FETCH_UNHANDLED_GROUP_REQUESTS_SUCCESS = 'FETCH_UNHANDLED_GROUP_REQUESTS_SUCCESS';
export const FETCH_UNHANDLED_GROUP_REQUESTS_FAIL = 'FETCH_UNHANDLED_GROUP_REQUESTS_FAIL';

export const LEAVE_GROUP = 'LEAVE_GROUP';
export const LEAVE_GROUP_START = 'LEAVE_GROUP_START';
export const LEAVE_GROUP_SUCCESS = 'LEAVE_GROUP_SUCCESS';
export const LEAVE_GROUP_FAIL = 'LEAVE_GROUP_FAIL';
export const DELETE_GROUP = 'DELETE_GROUP';
export const DELETE_GROUP_START = 'DELETE_GROUP_START';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_FAIL = 'DELETE_GROUP_FAIL';

export const SEARCH_GROUP = 'SEARCH_GROUP';
export const SEARCH_GROUP_START = 'SEARCH_GROUP_START';
export const SEARCH_GROUP_SUCCESS = 'SEARCH_GROUP_SUCCESS';
export const SEARCH_GROUP_FAIL = 'SEARCH_GROUP_FAIL';

export const UPDATE_GROUP_SEARCH_KEYWORD = 'UPDATE_GROUP_SEARCH_KEYWORD';

export const JOIN_GROUP = 'JOIN_GROUP';
export const JOIN_GROUP_START = 'JOIN_GROUP_START';
export const JOIN_GROUP_SUCCESS = 'JOIN_GROUP_SUCCESS';
export const JOIN_GROUP_FAIL = 'JOIN_GROUP_FAIL';

export const CANCEL_REQUEST_JOIN_GROUP = 'CANCEL_REQUEST_JOIN_GROUP';
export const CANCEL_REQUEST_JOIN_GROUP_SUCCESS = 'CANCEL_REQUEST_JOIN_GROUP_SUCCESS';
export const CANCEL_REQUEST_JOIN_GROUP_FAIL = 'CANCEL_REQUEST_JOIN_GROUP_FAIL';

export const SET_GROUP_LIST_PAGE_TAB = 'SET_GROUP_LIST_PAGE_TAB';

export const RESET_GROUPS = 'RESET_GROUPS';

/** group page actions */
export const FETCH_GROUP = 'FETCH_GROUP';
export const FETCH_GROUP_SUCCESS = 'FETCH_GROUP_SUCCESS';
export const FETCH_GROUP_FAIL = 'FETCH_GROUP_FAIL';
export const SET_GROUP_PAGE_TAB = 'SET_GROUP_PAGE_TAB';
export const SET_GROUP_PAGE_FEED_TAB = 'SET_GROUP_PAGE_FEED_TAB';
export const SET_GROUP_PAGE_FEED_TAB_START = 'SET_GROUP_PAGE_FEED_TAB_START';
export const SAVE_GROUP_ANNOUNCEMENT = 'SAVE_GROUP_ANNOUNCEMENT';
export const SAVE_GROUP_ANNOUNCEMENT_SUCCESS = 'SAVE_GROUP_ANNOUNCEMENT_SUCCESS';
export const SAVE_GROUP_ANNOUNCEMENT_FAILED = 'SAVE_GROUP_ANNOUNCEMENT_FAILED';
export const DELETE_GROUP_ANNOUNCEMENT = 'DELETE_GROUP_ANNOUNCEMENT';
export const DELETE_GROUP_ANNOUNCEMENT_SUCCESS = 'DELETE_GROUP_ANNOUNCEMENT_SUCCESS';
export const DELETE_GROUP_ANNOUNCEMENT_FAILED = 'DELETE_GROUP_ANNOUNCEMENT_FAILED';
export const OPEN_DELETE_CONFIRM_DIALOG = 'OPEN_DELETE_CONFIRM_DIALOG';
export const CLOSE_DELETE_CONFIRM_DIALOG = 'CLOSE_DELETE_CONFIRM_DIALOG';
export const CONFIRM_DELETE_CONFIRM_DIALOG = 'CONFIRM_DELETE_CONFIRM_DIALOG';
export const SAVE_GROUP_POST = 'SAVE_GROUP_POST';
export const SAVE_GROUP_POST_SUCCESS = 'SAVE_GROUP_POST_SUCCESS';
export const SAVE_GROUP_POST_FAILED = 'SAVE_GROUP_POST_FAILED';
export const DELETE_GROUP_POST = 'DELETE_GROUP_POST';
export const DELETE_GROUP_POST_SUCCESS = 'DELETE_GROUP_POST_SUCCESS';
export const DELETE_GROUP_POST_FAILED = 'DELETE_GROUP_POST_FAILED';
export const REMOVE_IMAGE_FROM_GROUP_POST = 'REMOVE_IMAGE_FROM_GROUP_POST';
export const REMOVE_IMAGE_FROM_GROUP_POST_START = 'REMOVE_IMAGE_FROM_GROUP_POST_START';
export const REMOVE_IMAGE_FROM_GROUP_POST_END = 'REMOVE_IMAGE_FROM_GROUP_POST_END';
export const REMOVE_GROUP_PROFILE_IMAGE = 'REMOVE_GROUP_PROFILE_IMAGE';
export const REMOVE_IMAGE_FROM_GROUP_ACTIVITY_FEED = 'REMOVE_IMAGE_FROM_GROUP_ACTIVITY_FEED';
export const FETCH_GROUP_CONVERSATION_LIKERS = 'FETCH_GROUP_CONVERSATION_LIKERS';
export const FETCH_GROUP_CONVERSATION_LIKERS_DONE = 'FETCH_GROUP_CONVERSATION_LIKERS_DONE';
export const UPDATE_GROUP_CONVERSATION_LIKE = 'UPDATE_GROUP_CONVERSATION_LIKE';
export const UPDATE_GROUP_CONVERSATION_LIKE_START = 'UPDATE_GROUP_CONVERSATION_LIKE_START';
export const UPDATE_GROUP_CONVERSATION_LIKE_DONE = 'UPDATE_GROUP_CONVERSATION_LIKE_DONE';
export const FETCH_GROUP_POSTS = 'FETCH_GROUP_POSTS';
export const FETCH_GROUP_POSTS_SUCCESS = 'FETCH_GROUP_POSTS_SUCCESS';
export const FETCH_GROUP_POSTS_FAILED = 'FETCH_GROUP_POSTS_FAILED';
export const FETCH_GROUP_POST = 'FETCH_GROUP_POST';
export const FETCH_GROUP_POST_START = 'FETCH_GROUP_POST_START';
export const FETCH_GROUP_POST_SUCCESS = 'FETCH_GROUP_POST_SUCCESS';
export const FETCH_GROUP_POST_FAILED = 'FETCH_GROUP_POST_FAILED';

// group page actions - comments
export const FETCH_GROUP_COMMENTS = 'FETCH_GROUP_COMMENTS';
export const FETCH_GROUP_COMMENTS_SUCCESS = 'FETCH_GROUP_COMMENTS_SUCCESS';
export const FETCH_GROUP_COMMENTS_FAILED = 'FETCH_GROUP_COMMENTS_FAILED';
export const SAVE_GROUP_COMMENT = 'SAVE_GROUP_COMMENT';
export const SAVE_GROUP_COMMENT_SUCCESS = 'SAVE_GROUP_COMMENT_SUCCESS';
export const SAVE_GROUP_COMMENT_FAILED = 'SAVE_GROUP_COMMENT_FAILED';
export const DELETE_GROUP_COMMENT = 'DELETE_GROUP_COMMENT';
export const DELETE_GROUP_COMMENT_SUCCESS = 'DELETE_GROUP_COMMENT_SUCCESS';
export const DELETE_GROUP_COMMENT_FAILED = 'DELETE_GROUP_COMMENT_FAILED';
export const EDIT_GROUP_COMMENT = 'EDIT_GROUP_COMMENT';
export const EDIT_GROUP_COMMENT_START = 'EDIT_GROUP_COMMENT_START';
export const EDIT_GROUP_COMMENT_SUCCESS = 'EDIT_GROUP_COMMENT_SUCCESS';
export const EDIT_GROUP_COMMENT_FAILED = 'EDIT_GROUP_COMMENT_FAILED';

export const FETCH_GROUP_COMMENT_LIKERS = 'FETCH_GROUP_COMMENT_LIKERS';
export const FETCH_GROUP_COMMENT_LIKERS_DONE = 'FETCH_GROUP_COMMENT_LIKERS_DONE';
export const UPDATE_GROUP_COMMENT_LIKE = 'UPDATE_GROUP_COMMENT_LIKE';
export const UPDATE_GROUP_COMMENT_LIKE_START = 'UPDATE_GROUP_COMMENT_LIKE_START';
export const UPDATE_GROUP_COMMENT_LIKE_DONE = 'UPDATE_GROUP_COMMENT_LIKE_DONE';
export const CONFIRM_LEAVE_GROUP = 'CONFIRM_LEAVE_GROUP';
export const INIT_GROUP_LEADERBOARD = 'INIT_GROUP_LEADERBOARD';
export const SET_GROUP_LEADERBOARD_TYPE = 'SET_GROUP_LEADERBOARD_TYPE';
export const SET_GROUP_LEADERBOARD_VIEW_PREVIOUS = 'SET_GROUP_LEADERBOARD_VIEW_PREVIOUS';
export const FETCH_GROUP_LEADERBOARD = 'FETCH_GROUP_LEADERBOARD';
export const FETCH_GROUP_LEADERBOARD_SUCCESS = 'FETCH_GROUP_LEADERBOARD_SUCCESS';
export const FETCH_GROUP_LEADERBOARD_FAILED = 'FETCH_GROUP_LEADERBOARD_FAILED';

export const INITIALIZE_GROUP_SINGLE_PAGE = 'INITIALIZE_GROUP_SINGLE_PAGE';
export const INITIALIZE_GROUP_SINGLE_PAGE_SUCCESS = 'INITIALIZE_GROUP_SINGLE_PAGE_SUCCESS';
export const INITIALIZE_GROUP_SINGLE_PAGE_FAILED = 'INITIALIZE_GROUP_SINGLE_PAGE_FAILED';

export const FETCH_GROUP_ALL_FEEDS = 'FETCH_GROUP_ALL_FEEDS';
export const FETCH_GROUP_ALL_FEEDS_START = 'FETCH_GROUP_ALL_FEEDS_START';
export const FETCH_GROUP_ALL_FEEDS_SUCCESS = 'FETCH_GROUP_ALL_FEEDS_SUCCESS';
export const FETCH_GROUP_ALL_FEEDS_FAILED = 'FETCH_GROUP_ALL_FEEDS_FAILED';

export const FETCH_GROUP_ACTIVITY_FEEDS = 'FETCH_GROUP_ACTIVITY_FEEDS';
export const FETCH_GROUP_ACTIVITY_FEEDS_SUCCESS = 'FETCH_GROUP_ACTIVITY_FEEDS_SUCCESS';
export const FETCH_GROUP_ACTIVITY_FEEDS_FAILED = 'FETCH_GROUP_ACTIVITY_FEEDS_FAILED';
export const FETCH_GROUP_ACTIVITY_FEED = 'FETCH_GROUP_ACTIVITY_FEED';
export const FETCH_GROUP_ACTIVITY_FEED_START = 'FETCH_GROUP_ACTIVITY_FEED_START';
export const FETCH_GROUP_ACTIVITY_FEED_SUCCESS = 'FETCH_GROUP_ACTIVITY_FEED_SUCCESS';
export const FETCH_GROUP_ACTIVITY_FEED_FAILED = 'FETCH_GROUP_ACTIVITY_FEED_FAILED';

export const RESET_GROUP_SHOW_ERROR_ALERT = 'RESET_GROUP_SHOW_ERROR_ALERT';
export const RESET_GROUP_POST_ERROR = 'RESET_GROUP_POST_ERROR';
export const RESET_GROUP_ANNOUNCEMENT_ERROR = 'RESET_GROUP_ANNOUNCEMENT_ERROR';
export const RESET_GROUP_FEED_ANIMATE_STATE = 'RESET_GROUP_FEED_ANIMATE_STATE';
export const RESET_GROUP_COMMENT_FOCUS = 'RESET_GROUP_COMMENT_FOCUS';

// Group post images
export const UPLOAD_POST_IMAGE = 'UPLOAD_POST_IMAGE';
export const UPLOAD_POST_IMAGE_START = 'UPLOAD_POST_IMAGE_START';
export const UPLOAD_POST_IMAGE_SUCCESS = 'UPLOAD_POST_IMAGE_SUCCESS';
export const UPLOAD_POST_IMAGE_FAILED = 'UPLOAD_POST_IMAGE_FAILED';
export const REMOVE_POST_IMAGE = 'REMOVE_POST_IMAGE'; // this is for removing an image from redux store
export const REMOVE_POST_IMAGES = 'REMOVE_POST_IMAGES';
export const UPDATE_POST_IMAGES = 'UPDATE_POST_IMAGES';
export const UPDATE_POST_IMAGES_LIMIT_ERROR = 'UPDATE_POST_IMAGES_LIMIT_ERROR';
export const RESET_POST_IMAGES_UPLOAD_RETRY_HINT = 'RESET_POST_IMAGES_UPLOAD_RETRY_HINT';
export const DELETE_POST_IMAGE = 'DELETE_POST_IMAGE'; // this is for removing an image from server
export const DELETE_POST_IMAGE_SUCCESS = 'DELETE_POST_IMAGE_SUCCESS';
export const DELETE_POST_IMAGE_FAILED = 'DELETE_POST_IMAGE_FAILED';

// Group Challenges
export const FETCH_GROUP_CHALLENGES = 'FETCH_GROUP_CHALLENGES';
export const FETCH_GROUP_CHALLENGES_START = 'FETCH_GROUP_CHALLENGES_START';
export const FETCH_GROUP_CHALLENGES_SUCCESS = 'FETCH_GROUP_CHALLENGES_SUCCESS';
export const FETCH_GROUP_CHALLENGES_FAILED = 'FETCH_GROUP_CHALLENGES_FAILED';
export const UPDATE_GROUP_CHALLENGE = 'UPDATE_GROUP_CHALLENGE';
export const UPDATE_GROUP_CHALLENGE_START = 'UPDATE_GROUP_CHALLENGE_START';
export const UPDATE_GROUP_CHALLENGE_SUCCESS = 'UPDATE_GROUP_CHALLENGE_SUCCESS';
export const UPDATE_GROUP_CHALLENGE_FAILED = 'UPDATE_GROUP_CHALLENGE_FAILED';
export const DELETE_GROUP_CHALLENGE = 'DELETE_GROUP_CHALLENGE';
export const DELETE_GROUP_CHALLENGE_START = 'DELETE_GROUP_CHALLENGE_START';
export const DELETE_GROUP_CHALLENGE_SUCCESS = 'DELETE_GROUP_CHALLENGE_SUCCESS';
export const DELETE_GROUP_CHALLENGE_FAILED = 'DELETE_GROUP_CHALLENGE_FAILED';
export const UPDATE_GROUP_CHALLENGE_UUID = 'UPDATE_GROUP_CHALLENGE_UUID';
export const UPDATE_GROUP_CHALLENGE_VIEW = 'UPDATE_GROUP_CHALLENGE_VIEW';
export const FETCH_GROUP_CHALLENGE_LEADERBOARD = 'FETCH_GROUP_CHALLENGE_LEADERBOARD';
export const FETCH_GROUP_CHALLENGE_LEADERBOARD_START = 'FETCH_GROUP_CHALLENGE_LEADERBOARD_START';
export const FETCH_GROUP_CHALLENGE_LEADERBOARD_SUCCESS = 'FETCH_GROUP_CHALLENGE_LEADERBOARD_SUCCESS';
export const FETCH_GROUP_CHALLENGE_LEADERBOARD_FAILED = 'FETCH_GROUP_CHALLENGE_LEADERBOARD_FAILED';

export const GROUP_PAGE_JOIN_GROUP = 'GROUP_PAGE_JOIN_GROUP';
export const GROUP_PAGE_JOIN_GROUP_SUCCESS = 'GROUP_PAGE_JOIN_GROUP_SUCCESS';
export const GROUP_PAGE_REQUEST_JOIN_GROUP = 'GROUP_PAGE_REQUEST_JOIN_GROUP';
export const GROUP_PAGE_CANCEL_REQUEST_JOIN_GROUP = 'GROUP_PAGE_CANCEL_REQUEST_JOIN_GROUP';
export const GROUP_PAGE_ACCEPT_INVITATION = 'GROUP_PAGE_ACCEPT_INVITATION';
export const GROUP_PAGE_ACCEPT_INVITATION_SUCCESS = 'GROUP_PAGE_ACCEPT_INVITATION_SUCCESS';
export const UPDATE_GROUP_MEMBER_REQUEST = 'UPDATE_GROUP_MEMBER_REQUEST';
export const UPDATE_GROUP_MEMBERS = 'UPDATE_GROUP_MEMBERS';
export const SORT_GROUP_MEMBERS = 'SORT_GROUP_MEMBERS';
export const UPDATE_GROUP_INVITES = 'UPDATE_GROUP_INVITES';
export const UPDATE_GROUP_USER_CONNECTIONS = 'UPDATE_GROUP_USER_CONNECTIONS';
export const UPDATE_GROUP_USER_CONNECTION = 'UPDATE_GROUP_USER_CONNECTION';
export const UPDATE_GROUP_USER_CONNECTION_DONE = 'UPDATE_GROUP_USER_CONNECTION_DONE';
export const GROUP_PAGE_SEARCH_USER = 'GROUP_PAGE_SEARCH_USER';
export const UPDATE_GROUP_SEARCH_USER_CONNECTION_STATUS = 'UPDATE_GROUP_SEARCH_USER_CONNECTION_STATUS';
export const GROUP_PAGE_SEARCH_USER_DONE = 'GROUP_PAGE_SEARCH_USER_DONE';
export const GROUP_PAGE_UNBLOCK_USER = 'GROUP_PAGE_UNBLOCK_USER';
export const GROUP_PAGE_UNBLOCK_USER_DONE = 'GROUP_PAGE_UNBLOCK_USER_DONE';
export const GROUP_PAGE_CANCEL_INVITE_USER = 'GROUP_PAGE_CANCEL_INVITE_USER';
export const GROUP_PAGE_CANCEL_INVITE_USER_DONE = 'GROUP_PAGE_CANCEL_INVITE_USER_DONE';
export const GROUP_PAGE_INVITE_USER = 'GROUP_PAGE_INVITE_USER';
export const GROUP_PAGE_INVITE_USER_DONE = 'GROUP_PAGE_INVITE_USER_DONE';
export const GROUP_PAGE_SET_INVITE_ERROR_DIALOG_STATE = 'GROUP_PAGE_SET_INVITE_ERROR_DIALOG_STATE';

// group page join group / request join group error
export const UPDATE_GROUP_PAGE_SHOW_ERROR_ALERT = 'UPDATE_GROUP_PAGE_SHOW_ERROR_ALERT';

// group page course tab
export const GROUP_PAGE_INIT_COURSE_TAB = 'GROUP_PAGE_INIT_COURSE_TAB';
export const GROUP_PAGE_INIT_COURSE_TAB_DONE = 'GROUP_PAGE_INIT_COURSE_TAB_DONE';
export const GROUP_PAGE_FETCH_COURSE_DETAIL = 'GROUP_PAGE_FETCH_COURSE_DETAIL';
export const GROUP_PAGE_FETCH_COURSE_DETAIL_DONE = 'GROUP_PAGE_FETCH_COURSE_DETAIL_DONE';
export const GROUP_PAGE_ADD_GROUP_COURSE = 'GROUP_PAGE_ADD_GROUP_COURSE';
export const GROUP_PAGE_ADD_GROUP_COURSE_DONE = 'GROUP_PAGE_ADD_GROUP_COURSE_DONE';
export const GROUP_PAGE_DELETE_GROUP_COURSE = 'GROUP_PAGE_DELETE_GROUP_COURSE';
export const GROUP_PAGE_DELETE_GROUP_COURSE_DONE = 'GROUP_PAGE_DELETE_GROUP_COURSE_DONE';
export const GROUP_PAGE_CLEAR_LAST_DELETE_COURSE_NAME = 'GROUP_PAGE_CLEAR_LAST_DELETE_COURSE_NAME';
export const GROUP_PAGE_CLOSE_DELETE_COURSE_ERROR_DIALOG = 'GROUP_PAGE_CLOSE_DELETE_COURSE_ERROR_DIALOG';

export const RESET_GROUP_PAGE = 'RESET_GROUP_PAGE';

export const REMOVE_GROUP_MEMBER = 'REMOVE_GROUP_MEMBER';
export const REMOVE_GROUP_MEMBER_SUCCESS = 'REMOVE_GROUP_MEMBER_SUCCESS';
export const REMOVE_GROUP_MEMBER_FAILED = 'REMOVE_GROUP_MEMBER_FAILED';
export const UPDATE_GROUP_MEMBER_ROLE = 'UPDATE_GROUP_MEMBER_ROLE';
export const UPDATE_GROUP_MEMBER_ROLE_SUCCESS = 'UPDATE_GROUP_MEMBER_ROLE_SUCCESS';
export const UPDATE_GROUP_MEMBER_ROLE_FAILED = 'UPDATE_GROUP_MEMBER_ROLE_FAILED';
export const TRANSFER_GROUP_OWNERSHIP = 'TRANSFER_GROUP_OWNERSHIP';
export const TRANSFER_GROUP_OWNERSHIP_SUCCESS = 'TRANSFER_GROUP_OWNERSHIP_SUCCESS';
export const TRANSFER_GROUP_OWNERSHIP_FAILED = 'TRANSFER_GROUP_OWNERSHIP_FAILED';

export const GROUP_PAGE_OPEN_REPORT_GROUP_PHOTO_DIALOG = 'GROUP_PAGE_OPEN_REPORT_GROUP_PHOTO_DIALOG';
export const GROUP_PAGE_CLOSE_REPORT_GROUP_PHOTO_DIALOG = 'GROUP_PAGE_CLOSE_REPORT_GROUP_PHOTO_DIALOG';
export const GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO = 'GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO';
export const GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO_DONE = 'GROUP_PAGE_SUBMIT_REPORT_GROUP_PHOTO_DONE';

export const GROUP_PAGE_UPDATE_GROUP_SETTING = 'GROUP_PAGE_UPDATE_GROUP_SETTING';
export const GROUP_PAGE_RESET_SHOW_CHANGES_SAVED = 'GROUP_PAGE_RESET_SHOW_CHANGES_SAVED';

export const GROUP_PAGE_SET_LIMIT_ERROR_DIALOG = 'GROUP_PAGE_SET_LIMIT_ERROR_DIALOG';
/** group page actions */

export const DELETE_SEGMENT = 'DELETE_SEGMENT';
export const DELETED_SEGMENT = 'DELETED_SEGMENT';
export const FETCH_GROUP_MEMBER = 'FETCH_GROUP_MEMBER';
export const START_FETCHING_GROUP_MEMBER = 'START_FETCHING_GROUP_MEMBER';
export const FETCH_GROUP_MEMBER_ERROR = 'FETCH_GROUP_MEMBER_ERROR';
export const RECEIVED_GROUP_MEMBER_DATA = 'RECEIVED_GROUP_MEMBER_DATA';
export const REQUEST_FAVORITE_GROUP_SEGMENT = 'REQUEST_FAVORITE_GROUP_SEGMENT';
export const RECEIVE_FAVORITE_GROUP_SEGMENT = 'RECEIVE_FAVORITE_GROUP_SEGMENT';
export const RESET_FAVORITE_GROUP_SEGMENT = 'RESET_FAVORITE_GROUP_SEGMENT';
export const DELETE_FAVORITE_GROUP_SEGMENT = 'DELETE_FAVORITE_GROUP_SEGMENT';
export const UPDATE_FAVORITE_GROUP_SEGMENT = 'UPDATE_FAVORITE_GROUP_SEGMENT';

export const SET_OPENED_FILTER = 'SET_OPENED_FILTER';
export const RESET_OPENED_FILTER = 'RESET_OPENED_FILTER';
export const SET_SEGMENTS_FILTERS = 'SET_SEGMENTS_FILTERS';

export const RESET_SEGMENT_PAGE = 'RESET_SEGMENT_PAGE';

export const RECEIVE_SEGMENT_ACTIVITY = 'RECEIVE_SEGMENT_ACTIVITY';

export const FETCH_ADAPTIVE_PLAN_FEED = 'FETCH_ADAPTIVE_PLAN_FEED';
export const FETCHING_ADAPTIVE_PLAN_FEED = 'FETCHING_ADAPTIVE_PLAN_FEED';
export const FETCH_ADAPTIVE_PLAN_FEED_SUCCESS = 'FETCH_ADAPTIVE_PLAN_FEED_SUCCESS';
export const FETCH_ADAPTIVE_PLAN_FEED_ERROR = 'FETCH_ADAPTIVE_PLAN_FEED_ERROR';

export const FETCH_CONTENTFUL_DATA_ARTICLE = 'FETCH_CONTENTFUL_DATA_ARTICLE';
export const FETCH_CONTENTFUL_DATA_ARTICLE_SUCCESS = 'FETCH_CONTENTFUL_DATA_ARTICLE_SUCCESS';
export const FETCH_CONTENTFUL_DATA_ARTICLE_FAILED = 'FETCH_CONTENTFUL_DATA_ARTICLE_FAILED';
export const FETCHING_CONTENTFUL_DATA_ARTICLE = 'FETCHING_CONTENTFUL_DATA_ARTICLE';

export const CONTENTFUL_LOAD_CLIENT_PARTIAL = 'CONTENTFUL_LOAD_CLIENT_PARTIAL';
export const CONTENTFUL_LOAD_CLIENT_PARTIAL_SUCCESS = 'CONTENTFUL_LOAD_CLIENT_PARTIAL_SUCCESS';
export const CONTENTFUL_LOAD_CLIENT_PARTIAL_FAILED = 'CONTENTFUL_LOAD_CLIENT_PARTIAL_FAILED';
export const FETCHING_CONTENTFUL_LOAD_CLIENT_PARTIAL = 'FETCHING_CONTENTFUL_LOAD_CLIENT_PARTIAL';

export const FETCH_CONTENTFUL_VIDEO = 'FETCH_CONTENTFUL_VIDEO';
export const FETCH_CONTENTFUL_VIDEO_SUCCESS = 'FETCH_CONTENTFUL_VIDEO_SUCCESS';
export const FETCH_CONTENTFUL_VIDEO_FAILED = 'FETCH_CONTENTFUL_VIDEO_FAILED';
export const FETCHING_CONTENTFUL_VIDEO = 'FETCHING_CONTENTFUL_VIDEO';

export const SUBMIT_ACTIVITY_FEEDBACK = 'SUBMIT_ACTIVITY_FEEDBACK';
export const SUBMIT_ACTIVITY_FEEDBACK_SUCCESS = 'SUBMIT_ACTIVITY_FEEDBACK_SUCCESS';

export const FETCH_ATP_ACTIVITY_AND_POLYLINE = 'FETCH_ATP_ACTIVITY_AND_POLYLINE';
export const FETCH_ATP_ACTIVITY_AND_POLYLINE_SUCCESS = 'FETCH_ATP_ACTIVITY_AND_POLYLINE_SUCCESS';

export const REQUEST_ATP_TYPES = 'REQUEST_ATP_TYPES';
export const REQUEST_ATP_TYPES_SUCCESS = 'REQUEST_ATP_TYPES_SUCCESS';

export const REQUEST_ATP_ACTIVE = 'REQUEST_ATP_ACTIVE';
export const REQUEST_ATP_ACTIVE_SUCCESS = 'REQUEST_ATP_ACTIVE_SUCCESS';
export const REQUEST_ATP_ACTIVE_FETCHING = 'REQUEST_ATP_ACTIVE_FETCHING';
export const REQUEST_ATP_ACTIVE_FAIL = 'REQUEST_ATP_ACTIVE_FAIL';

export const REQUEST_ATP_COMPLETED = 'REQUEST_ATP_COMPLETED';
export const REQUEST_ATP_COMPLETED_SUCCESS = 'REQUEST_ATP_COMPLETED_SUCCESS';

export const FETCH_SYSTEM_PREFERENCE_WITH_OPTIONS = 'FETCH_SYSTEM_PREFERENCE_WITH_OPTIONS';

export const UPDATE_WORKOUT_SCHEDULE_DATE = 'UPDATE_WORKOUT_DATE';
export const UPDATE_WORKOUT_SCHEDULE_DATE_SUCCESS = 'UPDATE_WORKOUT_SCHEDULE_DATE_SUCCESS';
export const FETCH_COACH_PLAN = 'FETCH_COACH_PLAN';
export const FETCH_COACH_PLAN_SUCCESS = 'FETCH_COACH_PLAN_SUCCESS';
export const FETCH_COACH_PLAN_ERROR = 'FETCH_COACH_PLAN_ERROR';

export const DELETE_SCORECARD = 'DELETE_SCORECARD';
export const DELETE_SCORECARD_SUCCESS = 'DELETE_SCORECARD_SUCCESS';
export const DELETE_SCORECARD_FAIL = 'DELETE_SCORECARD_FAIL';

export const FETCH_GDPR_FEATURE = 'FETCH_GDPR_FEATURE';
export const FETCH_GDPR_FEATURE_RESET = 'FETCH_GDPR_FEATURE_RESET';
export const FETCH_GDPR_FEATURE_SUCCESS = 'FETCH_GDPR_FEATURE_SUCCESS';
export const FETCH_GDPR_FEATURE_FAIL = 'FETCH_GDPR_FEATURE_FAIL';
export const FETCH_GDPR_FEATURE_STATE_RESET = 'FETCH_GDPR_FEATURE_STATE_RESET';
export const POST_GDPR_FEATURE_OPT_IN = 'POST_GDPR_FEATURE_OPT_IN';
export const POST_GDPR_FEATURE_OPT_OUT = 'POST_GDPR_FEATURE_OPT_OUT';
export const FETCH_GDPR_CONSENT_TEXT = 'FETCH_GDPR_CONSENT_TEXT';
export const FETCH_GDPR_CONSENT_TEXT_SUCCESS = 'FETCH_GDPR_CONSENT_TEXT_SUCCESS';
export const FETCH_GDPR_CONSENT_TEXT_FAIL = 'FETCH_GDPR_CONSENT_TEXT_FAIL';
export const FETCH_GDPR_REVOKE_CONSENT = 'FETCH_GDPR_REVOKE_CONSENT';
export const FETCH_GDPR_REVOKE_CONSENT_SUCCESS = 'FETCH_GDPR_REVOKE_CONSENT_SUCCESS';
export const FETCH_GDPR_REVOKE_CONSENT_FAIL = 'FETCH_GDPR_REVOKE_CONSENT_FAIL';
export const FETCH_GDPR_GRANT_CONSENT = 'FETCH_GDPR_GRANT_CONSENT';
export const FETCH_GDPR_GRANT_CONSENT_SUCCESS = 'FETCH_GDPR_GRANT_CONSENT_SUCCESS';
export const RESET_GDPR_GRANT_CONSENT = 'RESET_GDPR_GRANT_CONSENT';
export const FETCH_GDPR_GRANT_CONSENT_FAIL = 'FETCH_GDPR_GRANT_CONSENT_FAIL';
export const SET_GDPR_FEATURE_ALERT = 'SET_GDPR_FEATURE_ALERT';
export const FETCH_COACH_INFO = 'FETCH_COACH_INFO';
export const FETCH_COACH_INFO_SUCCESS = 'FETCH_COACH_INFO_SUCCESS';
export const FETCH_COACH_INFO_FAILED = 'FETCH_COACH_INFO_FAILED';
export const FETCHING_COACH_INFO = 'FETCHING_COACH_INFO';

export const FETCH_PULSE_OX_ACCLIMATION = 'FETCH_PULSE_OX_ACCLIMATION';
export const FETCH_PULSE_OX_ACCLIMATION_SUCCESS = 'FETCH_PULSE_OX_ACCLIMATION_SUCCESS';
export const FETCH_PULSE_OX_ACCLIMATION_FAIL = 'FETCH_PULSE_OX_ACCLIMATION_FAIL';

export const FETCH_ACTIVITIES_FOR_DAILY_SUMMARY = 'FETCH_ACTIVITIES_FOR_DAILY_SUMMARY';
export const FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FETCHING = 'FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FETCHING';
export const FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_SUCCESS = 'FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_SUCCESS';
export const FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FAIL = 'FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FAIL';

export const FETCH_ACTIVITIES_LIST = 'FETCH_ACTIVITIES_LIST';
export const FETCH_ACTIVITIES_LIST_SUCCESS = 'FETCH_ACTIVITIES_LIST_SUCCESS';
export const FETCH_ACTIVITIES_LIST_FETCHING = 'FETCH_ACTIVITIES_LIST_FETCHING';
export const FETCH_ACTIVITIES_LIST_FAIL = 'FETCH_ACTIVITIES_LIST_FAIL';

export const FETCH_MERGED_SUMMARY = 'FETCH_MERGED_SUMMARY';
export const FETCH_MERGED_SUMMARY_FETCHING = 'FETCH_MERGED_SUMMARY_FETCHING';
export const FETCH_MERGED_SUMMARY_SUCCESS = 'FETCH_MERGED_SUMMARY_SUCCESS';
export const FETCH_MERGED_SUMMARY_FAIL = 'FETCH_MERGED_SUMMARY_FAIL';
export const SAVE_MERGED_SUMMARY = 'SAVE_MERGED_SUMMARY';
export const SAVE_MERGED_SUMMARY_SUCCESS = 'SAVE_MERGED_SUMMARY_SUCCESS';

export const FETCH_MERGED_SUMMARY_COUNT = 'FETCH_MERGED_SUMMARY_COUNT';
export const FETCH_MERGED_SUMMARY_COUNT_SUCCESS = 'FETCH_MERGED_SUMMARY_COUNT_SUCCESS';
export const FETCH_MERGED_SUMMARY_COUNT_FAIL = 'FETCH_MERGED_SUMMARY_COUNT_FAIL';

export const FETCH_WELLNESS_DAILY_SLEEP_DATA = 'FETCH_WELLNESS_DAILY_SLEEP_DATA';
export const FETCH_WELLNESS_DAILY_SLEEP_DATA_FETCHING = 'FETCH_WELLNESS_DAILY_SLEEP_DATA_FETCHING';
export const FETCH_WELLNESS_DAILY_SLEEP_DATA_SUCCESS = 'FETCH_WELLNESS_DAILY_SLEEP_DATA_SUCCESS';
export const FETCH_WELLNESS_DAILY_SLEEP_DATA_FAIL = 'FETCH_WELLNESS_DAILY_SLEEP_DATA_FAIL';

export const UPDATE_SLEEP_DTO = 'UPDATE_SLEEP_DTO';
export const UPDATE_SLEEP_DTO_SUCCESS = 'UPDATE_SLEEP_DTO_SUCCESS';
export const UPDATE_SLEEP_DTO_FAIL = 'UPDATE_SLEEP_DTO_FAIL';

export const UPDATE_WELLNESS_SLEEP_NOTE = 'UPDATE_WELLNESS_SLEEP_NOTE';
export const UPDATE_WELLNESS_SLEEP_NOTE_START = 'UPDATE_WELLNESS_SLEEP_NOTE_START';
export const UPDATE_WELLNESS_SLEEP_NOTE_SUCCESS = 'UPDATE_WELLNESS_SLEEP_NOTE_SUCCESS';
export const UPDATE_WELLNESS_SLEEP_NOTE_FAIL = 'UPDATE_WELLNESS_SLEEP_NOTE_FAIL';

export const UPDATE_WELLNESS_SLEEP_WINDOW = 'UPDATE_WELLNESS_SLEEP_WINDOW';
export const UPDATE_WELLNESS_SLEEP_WINDOW_SUCCESS = 'UPDATE_WELLNESS_SLEEP_WINDOW_SUCCESS';
export const UPDATE_WELLNESS_SLEEP_WINDOW_FAIL = 'UPDATE_WELLNESS_SLEEP_WINDOW_FAIL';

export const FETCH_DAILY_MOVEMENT = 'FETCH_DAILY_MOVEMENT';
export const FETCH_DAILY_MOVEMENT_FETCHING = 'FETCH_DAILY_MOVEMENT_FETCHING';
export const FETCH_DAILY_MOVEMENT_SUCCESS = 'FETCH_DAILY_MOVEMENT_SUCCESS';
export const FETCH_DAILY_MOVEMENT_FAIL = 'FETCH_DAILY_MOVEMENT_FAIL';

export const FETCH_DAILY_HEART_RATE = 'FETCH_DAILY_HEART_RATE';
export const FETCH_DAILY_HEART_RATE_SUCCESS = 'FETCH_DAILY_HEART_RATE_SUCCESS';
export const FETCH_DAILY_HEART_RATE_FAIL = 'FETCH_DAILY_HEART_RATE_FAIL';

export const FETCH_HEART_RATE_ZONES = 'FETCH_HEART_RATE_ZONES';
export const FETCH_HEART_RATE_ZONES_SUCCESS = 'FETCH_HEART_RATE_ZONES_SUCCESS';
export const FETCH_HEART_RATE_ZONES_FAIL = 'FETCH_HEART_RATE_ZONES_FAIL';

export const FETCH_BIOMETRIC_POWER_ZONES = 'FETCH_BIOMETRIC_POWER_ZONES';
export const FETCH_BIOMETRIC_POWER_ZONES_SUCCESS = 'FETCH_BIOMETRIC_POWER_ZONES_SUCCESS';
export const FETCH_BIOMETRIC_POWER_ZONES_FAIL = 'FETCH_BIOMETRIC_POWER_ZONES_FAIL';

export const FETCH_DAILY_MOVE_IQ_EVENTS = 'FETCH_DAILY_MOVE_IQ_EVENTS';
export const FETCH_DAILY_MOVE_IQ_EVENTS_FETCHING = 'FETCH_DAILY_MOVE_IQ_EVENTS_FETCHING';
export const FETCH_DAILY_MOVE_IQ_EVENTS_SUCCESS = 'FETCH_DAILY_MOVE_IQ_EVENTS_SUCCESS';
export const FETCH_DAILY_MOVE_IQ_EVENTS_FAIL = 'FETCH_DAILY_MOVE_IQ_EVENTS_FAIL';

export const DELETE_MOVE_IQ_EVENT = 'DELETE_MOVE_IQ_EVENT';
export const DELETE_MOVE_IQ_EVENT_SUCCESS = 'DELETE_MOVE_IQ_EVENT_SUCCESS';
export const DELETE_MOVE_IQ_EVENT_FAIL = 'DELETE_MOVE_IQ_EVENT_FAIL';
export const FETCH_LAST_SYNC_TIMESTAMP = 'FETCH_LAST_SYNC_TIMESTAMP';
export const FETCH_LAST_SYNC_TIMESTAMP_SUCCESS = 'FETCH_LAST_SYNC_TIMESTAMP_SUCCESS';
export const FETCH_LAST_SYNC_TIMESTAMP_FAIL = 'FETCH_LAST_SYNC_TIMESTAMP_FAIL';

export const SET_PULSE_OX_ACCLIMATION_PAGE_STATE = 'SET_PULSE_OX_ACCLIMATION_PAGE_STATE';

export const SET_PAGE_STATUS = 'SET_PAGE_STATUS';

export const FETCH_AUTO_DETECTED_EVENTS = 'FETCH_AUTO_DETECTED_EVENTS';
export const FETCH_AUTO_DETECTED_EVENTS_SUCCESS = 'FETCH_AUTO_DETECTED_EVENTS_SUCCESS';
export const FETCH_AUTO_DETECTED_EVENTS_FAIL = 'FETCH_AUTO_DETECTED_EVENTS_FAIL';

export const FETCH_WELLNESS_DAILY_STRESS_DATA = 'FETCH_WELLNESS_DAILY_STRESS_DATA';
export const FETCH_WELLNESS_DAILY_STRESS_DATA_SUCCESS = 'FETCH_WELLNESS_DAILY_STRESS_DATA_SUCCESS';
export const FETCH_WELLNESS_DAILY_STRESS_DATA_FAIL = 'FETCH_WELLNESS_DAILY_STRESS_DATA_FAIL';

export const FETCH_DEVICE_LIST = 'FETCH_DEVICE_LIST';
export const FETCH_DEVICE_LIST_SUCCESS = 'FETCH_DEVICE_LIST_SUCCESS';
export const FETCH_DEVICE_LIST_FAIL = 'FETCH_DEVICE_LIST_FAIL';

export const FETCH_REGISTERED_DEVICE_LIST = 'FETCH_REGISTERED_DEVICE_LIST';
export const FETCH_REGISTERED_DEVICE_LIST_FETCHING = 'FETCH_REGISTERED_DEVICE_LIST_FETCHING';
export const FETCH_REGISTERED_DEVICE_LIST_SUCCESS = 'FETCH_REGISTERED_DEVICE_LIST_SUCCESS';
export const FETCH_REGISTERED_DEVICE_LIST_FAIL = 'FETCH_REGISTERED_DEVICE_LIST_FAIL';

export const FETCH_HISTORICAL_DEVICE_LIST = 'FETCH_HISTORICAL_DEVICE_LIST';
export const FETCH_HISTORICAL_DEVICE_LIST_FETCHING = 'FETCH_HISTORICAL_DEVICE_LIST_FETCHING';
export const FETCH_HISTORICAL_DEVICE_LIST_SUCCESS = 'FETCH_HISTORICAL_DEVICE_LIST_SUCCESS';
export const FETCH_HISTORICAL_DEVICE_LIST_FAIL = 'FETCH_HISTORICAL_DEVICE_LIST_FAIL';

export const FETCH_DEVICE_BETA_SOFTWARE_INFO = 'FETCH_DEVICE_BETA_SOFTWARE_INFO';
export const FETCH_DEVICE_BETA_SOFTWARE_INFO_FETCHING = 'FETCH_DEVICE_BETA_SOFTWARE_INFO_FETCHING';
export const FETCH_DEVICE_BETA_SOFTWARE_INFO_SUCCESS = 'FETCH_DEVICE_BETA_SOFTWARE_INFO_SUCCESS';
export const FETCH_DEVICE_BETA_SOFTWARE_INFO_FAIL = 'FETCH_DEVICE_BETA_SOFTWARE_INFO_FAIL';

export const FETCH_DEVICE_INFO = 'FETCH_DEVICE_INFO';
export const FETCH_DEVICE_INFO_START = 'FETCH_DEVICE_INFO_START';
export const FETCH_DEVICE_INFO_SUCCESS = 'FETCH_DEVICE_INFO_SUCCESS';
export const FETCH_DEVICE_INFO_FAIL = 'FETCH_DEVICE_INFO_FAIL';

export const FETCH_USER_DEVICE_INFO = 'FETCH_USER_DEVICE_INFO';
export const FETCH_USER_DEVICE_INFO_START = 'FETCH_USER_DEVICE_INFO_START';
export const FETCH_USER_DEVICE_INFO_SUCCESS = 'FETCH_USER_DEVICE_INFO_SUCCESS';
export const FETCH_USER_DEVICE_INFO_FAIL = 'FETCH_USER_DEVICE_INFO_FAIL';

export const FETCH_DEVICE_INFO_BY_PART_NUMBER = 'FETCH_DEVICE_INFO_BY_PART_NUMBER';
export const FETCH_DEVICE_INFO_BY_PART_NUMBER_START = 'FETCH_DEVICE_INFO_BY_PART_NUMBER_START';
export const FETCH_DEVICE_INFO_BY_PART_NUMBER_SUCCESS = 'FETCH_DEVICE_INFO_BY_PART_NUMBER_SUCCESS';
export const FETCH_DEVICE_INFO_BY_PART_NUMBER_FAIL = 'FETCH_DEVICE_INFO_BY_PART_NUMBER_FAIL';

export const FETCH_DEVICE_BY_HEALTH_DEVICE_ID = 'FETCH_DEVICE_BY_HEALTH_DEVICE_ID';
export const FETCH_DEVICE_BY_HEALTH_DEVICE_ID_START = 'FETCH_DEVICE_BY_HEALTH_DEVICE_ID_START';
export const FETCH_DEVICE_BY_HEALTH_DEVICE_ID_SUCCESS = 'FETCH_DEVICE_BY_HEALTH_DEVICE_ID_SUCCESS';
export const FETCH_DEVICE_BY_HEALTH_DEVICE_ID_FAIL = 'FETCH_DEVICE_BY_HEALTH_DEVICE_ID_FAIL';

export const FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK = 'FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK';
export const FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_START = 'FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_START';
export const FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_SUCCESS = 'FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_SUCCESS';
export const FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_FAIL = 'FETCH_DEVICE_INFO_BY_DEVICE_VERSION_PK_FAIL';

export const FETCH_HYDRATION_DATA = 'FETCH_HYDRATION_DATA';
export const FETCH_HYDRATION_DATA_FETCHING = 'FETCH_HYDRATION_DATA_FETCHING';
export const FETCH_HYDRATION_DATA_SUCCESS = 'FETCH_HYDRATION_DATA_SUCCESS';
export const FETCH_HYDRATION_DATA_FAIL = 'FETCH_HYDRATION_DATA_FAIL';

export const UPDATE_HYDRATION_LEVEL = 'UPDATE_HYDRATION_LEVEL';
export const UPDATE_HYDRATION_LEVEL_UPDATING = 'UPDATE_HYDRATION_LEVEL_UPDATING';
export const UPDATE_HYDRATION_LEVEL_SUCCESS = 'UPDATE_HYDRATION_LEVEL_SUCCESS';
export const UPDATE_HYDRATION_LEVEL_ERROR = 'UPDATE_HYDRATION_LEVEL_ERROR';
export const RESET_HYDRATION = 'RESET_HYDRATION';
export const RESET_HYDRATION_UPDATE = 'RESET_HYDRATION_UPDATE';

export const UPDATE_HYDRATION_ALL_DATA = 'UPDATE_HYDRATION_ALL_DATA';
export const UPDATE_HYDRATION_ALL_DATA_UPDATING = 'UPDATE_HYDRATION_ALL_DATA_UPDATING';
export const UPDATE_HYDRATION_ALL_DATA_SUCCESS = 'UPDATE_HYDRATION_ALL_DATA_SUCCESS';
export const UPDATE_HYDRATION_ALL_DATA_ERROR = 'UPDATE_HYDRATION_ALL_DATA_ERROR';

export const FETCH_USER_SETTINGS = 'FETCH_USER_SETTINGS';
export const FETCH_USER_SETTINGS_FETCHING = 'FETCH_USER_SETTINGS_FETCHING';
export const FETCH_USER_SETTINGS_SUCCESS = 'FETCH_USER_SETTINGS_SUCCESS';
export const FETCH_USER_SETTINGS_FAIL = 'FETCH_USER_SETTINGS_FAIL';
export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS';
export const UPDATE_USER_SETTINGS_UPDATING = 'UPDATE_USER_SETTINGS_UPDATING';
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS';
export const UPDATE_USER_SETTINGS_ERROR = 'UPDATE_USER_SETTINGS_ERROR';
export const UPDATE_USER_SETTINGS_MCT = 'UPDATE_USER_SETTINGS_MCT';
export const UPDATE_USER_SETTINGS_MCT_SUCCESS = 'UPDATE_USER_SETTINGS_MCT_SUCCESS';
export const UPDATE_USER_SETTINGS_MCT_ERROR = 'UPDATE_USER_SETTINGS_MCT_ERROR';
export const RESET_USER_SETTINGS = 'RESET_USER_SETTINGS';
export const RESET_USER_SETTINGS_UPDATE = 'RESET_USER_SETTINGS_UPDATE';
export const FETCH_USER_SETTINGS_DSW = 'FETCH_USER_SETTINGS_DSW';
export const FETCH_USER_SETTINGS_DSW_FETCHING = 'FETCH_USER_SETTINGS_DSW_FETCHING';
export const FETCH_USER_SETTINGS_DSW_SUCCESS = 'FETCH_USER_SETTINGS_DSW_SUCCESS';
export const FETCH_USER_SETTINGS_DSW_FAIL = 'FETCH_USER_SETTINGS_DSW_FAIL';
export const UPDATE_USER_SETTINGS_DSW = 'UPDATE_USER_SETTINGS_DSW';
export const UPDATE_USER_SETTINGS_DSW_UPDATING = 'UPDATE_USER_SETTINGS_DSW_UPDATING';
export const UPDATE_USER_SETTINGS_DSW_SUCCESS = 'UPDATE_USER_SETTINGS_DSW_SUCCESS';
export const UPDATE_USER_SETTINGS_DSW_ERROR = 'UPDATE_USER_SETTINGS_DSW_ERROR';
export const UPDATE_REDUX_USER_PUBLIC_PROFILE_IMAGE = 'UPDATE_REDUX_USER_PUBLIC_PROFILE_IMAGE';

export const FETCH_USER_PROFILE_BASE = 'FETCH_USER_PROFILE_BASE';
export const FETCH_USER_PROFILE_BASE_FETCHING = 'FETCH_USER_PROFILE_BASE_FETCHING';
export const FETCH_USER_PROFILE_BASE_SUCCESS = 'FETCH_USER_PROFILE_BASE_SUCCESS';
export const FETCH_USER_PROFILE_BASE_FAIL = 'FETCH_USER_PROFILE_BASE_FAIL';
export const UPDATE_VIEWER_PUBLIC_PROFILE_GC_PLUS = 'UPDATE_VIEWER_PUBLIC_PROFILE_GC_PLUS';
export const FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER = 'FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER';
export const FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER_DONE = 'FETCH_USER_SOCIAL_PROFILE_IMAGE_VIEWER_DONE';
export const FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE = 'FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE';
export const FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_START = 'FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_START';
export const FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_DONE = 'FETCH_MULTIPLE_USER_SOCIAL_PROFILE_IMAGE_DONE';
export const REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE = 'REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE';
export const REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE_DONE = 'REMOVE_VIEWER_SOCIAL_PROFILE_IMAGE_DONE';

export const FETCH_VIEWER_USER_PREFERENCES = 'FETCH_VIEWER_USER_PREFERENCES';
export const FETCH_VIEWER_USER_PREFERENCES_FETCHING = 'FETCH_VIEWER_USER_PREFERENCES_FETCHING';
export const FETCH_VIEWER_USER_PREFERENCES_SUCCESS = 'FETCH_VIEWER_USER_PREFERENCES_SUCCESS';
export const FETCH_VIEWER_USER_PREFERENCES_FAIL = 'FETCH_VIEWER_USER_PREFERENCES_FAIL';
export const SET_VIEWER_USER_PREFERENCES = 'SET_VIEWER_USER_PREFERENCES';

export const UPDATE_VIEWER_USER_PREFERENCES = 'UPDATE_VIEWER_USER_PREFERENCES';
export const UPDATE_VIEWER_USER_PREFERENCES_UPDATING = 'UPDATE_VIEWER_USER_PREFERENCES_UPDATING';
export const UPDATE_VIEWER_USER_PREFERENCES_SUCCESS = 'UPDATE_VIEWER_USER_PREFERENCES_SUCCESS';
export const UPDATE_VIEWER_USER_PREFERENCES_FAIL = 'UPDATE_VIEWER_USER_PREFERENCES_FAIL';

export const FETCH_STRAVA_ACCESS = 'FETCH_STRAVA_ACCESS';
export const FETCH_STRAVA_ACCESS_FETCHING = 'FETCH_STRAVA_ACCESS_FETCHING';
export const FETCH_STRAVA_ACCESS_SUCCESS = 'FETCH_STRAVA_ACCESS_SUCCESS';
export const FETCH_STRAVA_ACCESS_FAIL = 'FETCH_STRAVA_ACCESS_FAIL';

export const UPDATE_STRAVA_ACCESS = 'UPDATE_STRAVA_ACCESS';
export const UPDATE_STRAVA_ACCESS_UPDATING = 'UPDATE_STRAVA_ACCESS_UPDATING';
export const UPDATE_STRAVA_ACCESS_SUCCESS = 'UPDATE_STRAVA_ACCESS_SUCCESS';
export const UPDATE_STRAVA_ACCESS_FAIL = 'UPDATE_STRAVA_ACCESS_FAIL';

export const FETCH_STRAVA_CONSUMER_DATA = 'FETCH_STRAVA_CONSUMER_DATA';
export const FETCH_STRAVA_CONSUMER_DATA_FETCHING = 'FETCH_STRAVA_CONSUMER_DATA_FETCHING';
export const FETCH_STRAVA_CONSUMER_DATA_SUCCESS = 'FETCH_STRAVA_CONSUMER_DATA_SUCCESS';
export const FETCH_STRAVA_CONSUMER_DATA_FAIL = 'FETCH_STRAVA_CONSUMER_DATA_FAIL';

export const FETCH_STRAVA_DEVICE_STATUS = 'FETCH_STRAVA_DEVICE_STATUS';
export const FETCH_STRAVA_DEVICE_STATUS_FETCHING = 'FETCH_STRAVA_DEVICE_STATUS_FETCHING';
export const FETCH_STRAVA_DEVICE_STATUS_SUCCESS = 'FETCH_STRAVA_DEVICE_STATUS_SUCCESS';
export const FETCH_STRAVA_DEVICE_STATUS_FAIL = 'FETCH_STRAVA_DEVICE_STATUS_FAIL';

export const FETCH_INSIGHTS_LIST = 'FETCH_INSIGHTS_LIST';
export const FETCH_INSIGHTS_LIST_FETCHING = 'FETCH_INSIGHTS_LIST_FETCHING';
export const FETCH_INSIGHTS_LIST_SUCCESS = 'FETCH_INSIGHTS_LIST_SUCCESS';
export const FETCH_INSIGHTS_LIST_FAIL = 'FETCH_INSIGHTS_LIST_FAIL';

export const FETCH_INSIGHT_DATA = 'FETCH_INSIGHT_DATA';
export const FETCH_INSIGHT_DATA_FETCHING = 'FETCH_INSIGHT_DATA_FETCHING';
export const FETCH_INSIGHT_DATA_SUCCESS = 'FETCH_INSIGHT_DATA_SUCCESS';
export const FETCH_INSIGHT_DATA_FAIL = 'FETCH_INSIGHT_DATA_FAIL';

export const UPDATE_INSIGHT_STATUS = 'UPDATE_INSIGHT_STATUS';
export const UPDATE_INSIGHT_STATUS_UPDATING = 'UPDATE_INSIGHT_STATUS_UPDATING';
export const UPDATE_INSIGHT_STATUS_SUCCESS = 'UPDATE_INSIGHT_STATUS_SUCCESS';
export const UPDATE_INSIGHT_STATUS_FAIL = 'UPDATE_INSIGHT_STATUS_FAIL';

export const FETCH_DEMOGRAPHIC_SELECTIONS = 'FETCH_DEMOGRAPHIC_SELECTIONS';
export const FETCH_DEMOGRAPHIC_SELECTIONS_FETCHING = 'FETCH_DEMOGRAPHIC_SELECTIONS_FETCHING';
export const FETCH_DEMOGRAPHIC_SELECTIONS_SUCCESS = 'FETCH_DEMOGRAPHIC_SELECTIONS_SUCCESS';
export const FETCH_DEMOGRAPHIC_SELECTIONS_FAIL = 'FETCH_DEMOGRAPHIC_SELECTIONS_FAIL';

export const FETCH_DEMOGRAPHIC_COMPARE = 'FETCH_DEMOGRAPHIC_COMPARE';
export const FETCH_DEMOGRAPHIC_COMPARE_FETCHING = 'FETCH_DEMOGRAPHIC_COMPARE_FETCHING';
export const FETCH_DEMOGRAPHIC_COMPARE_SUCCESS = 'FETCH_DEMOGRAPHIC_COMPARE_SUCCESS';
export const FETCH_DEMOGRAPHIC_COMPARE_FAIL = 'FETCH_DEMOGRAPHIC_COMPARE_FAIL';

export const FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES = 'FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES';
export const FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FETCHING = 'FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FETCHING';
export const FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS = 'FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS';
export const FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL = 'FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL';
export const UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES = 'UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES';
export const UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_UPDATING = 'UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_UPDATING';
export const UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS = 'UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS';
export const UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL = 'UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL';

export const FETCH_STEPS_LIFETIME_TOTALS = 'FETCH_STEPS_LIFETIME_TOTALS';
export const FETCH_STEPS_LIFETIME_TOTALS_SUCCESS = 'FETCH_STEPS_LIFETIME_TOTALS_SUCCESS';
export const FETCH_STEPS_LIFETIME_TOTALS_FAIL = 'FETCH_STEPS_LIFETIME_TOTALS_FAIL';

export const FETCH_FAVORITE_COURSES = 'FETCH_FAVORITE_COURSES';
export const SET_COURSE_TO_FAVORITE = 'SET_COURSE_TO_FAVORITE';
export const SET_COURSE_TO_FAVORITE_SUCCESS = 'SET_COURSE_TO_FAVORITE_SUCCESS';
export const SET_COURSE_TO_FAVORITE_FAIL = 'SET_COURSE_TO_FAVORITE_FAIL';
export const REMOVE_COURSE_FROM_FAVORITE = 'REMOVE_COURSE_FROM_FAVORITE';
export const REMOVE_COURSE_FROM_FAVORITE_SUCCESS = 'REMOVE_COURSE_FROM_FAVORITE_SUCCESS';
export const REMOVE_COURSE_FROM_FAVORITE_FAIL = 'REMOVE_COURSE_FROM_FAVORITE_FAIL';
export const RESET_CHANGING_FAVORITE_COURSE_STATUS_FAIL = 'RESET_CHANGING_FAVORITE_COURSE_STATUS_FAIL';
export const FETCH_FAVORITE_COURSES_SUCCESS = 'FETCH_FAVORITE_COURSES_SUCCESS';
export const FETCH_FAVORITE_COURSES_FAIL = 'FETCH_FAVORITE_COURSES_FAIL';
export const DELETE_COURSE_START = 'DELETE_COURSE_START';
export const DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS';
export const DELETE_COURSE_ERROR = 'DELETE_COURSE_ERROR';
export const RESET_DELETE_COURSE_ERROR_STATUS = 'RESET_DELETE_COURSE_ERROR_STATUS';
export const REQUEST_NEARBY_COURSES = 'REQUEST_NEARBY_COURSES';
export const FETCH_NEARBY_COURSES_SUCCESS = 'FETCH_NEARBY_COURSES_SUCCESS';
export const FETCH_NEARBY_COURSES_ERROR = 'FETCH_NEARBY_COURSES_ERROR';
export const RESET_NEARBY_COURSES = 'RESET_NEARBY_COURSES_ERROR';

export const DUPLICATE_COURSE = 'DUPLICATE_COURSE';
export const DUPLICATE_COURSE_START = 'DUPLICATE_COURSE_START';
export const DUPLICATE_COURSE_SUCCESS = 'DUPLICATE_COURSE_SUCCESS';
export const DUPLICATE_COURSE_ERROR = 'DUPLICATE_COURSE_ERROR';

export const CONVERT_ACTIVITY_TO_COURSE = 'CONVERT_ACTIVITY_TO_COURSE';
export const FETCH_GEOPOINTS_FOR_COURSES_MINIMAP = 'FETCH_GEOPOINTS_FOR_COURSES_MINIMAP';
export const FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_START = 'FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_START';
export const FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_SUCCESS = 'FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_SUCCESS';
export const FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_ERROR = 'FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_ERROR';
export const RESET_GEOPOINTS_FOR_COURSES_MINIMAP_LIST = 'RESET_GEOPOINTS_FOR_COURSES_MINIMAP_LIST';
export const REMOVE_CACHED_MINIMAP_ROUTE_BY_IDS = 'REMOVE_CACHED_MINIMAP_ROUTE_BY_IDS';
export const ENABLE_LAP_BY_COURSE_POINTS = 'ENABLE_LAP_BY_COURSE_POINTS';

export const SET_COURSES_LIST_SORT_VALUE = 'SET_COURSES_LIST_SORT_VALUE';
export const RESET_COURSES_LIST_SORT_VALUE = 'RESET_COURSES_LIST_SORT_VALUE';
export const SET_COURSES_LIST_FILTER_VALUE = 'SET_COURSES_LIST_FILTER_VALUE';
export const RESET_COURSES_LIST_FILTER_VALUE = 'RESET_COURSES_LIST_FILTER_VALUE';

export const SET_COMCOURSES_LIST_NEARBY_SORT_VALUE = 'SET_COMCOURSES_LIST_NEARBY_SORT_VALUE';
export const SET_COMCOURSES_LIST_SAVED_SORT_VALUE = 'SET_COMCOURSES_LIST_SAVED_SORT_VALUE';
export const SET_COMCOURSES_LIST_NEARBY_FILTER_VALUE = 'SET_COMCOURSES_LIST_NEARBY_FILTER_VALUE';
export const SET_COMCOURSES_LIST_SAVED_FILTER_VALUE = 'SET_COMCOURSES_LIST_SAVED_FILTER_VALUE';
export const SET_COMCOURSES_LIST_NEARBY = 'SET_COMCOURSES_LIST_NEARBY';
export const SET_COMCOURSES_LIST_SAVED = 'SET_COMCOURSES_LIST_SAVED';
export const ADD_COMCOURSE_TO_FAVORITES = 'ADD_COMCOURSE_TO_FAVORITES';
export const REMOVE_COMCOURSE_FROM_FAVORITES = 'REMOVE_COMCOURSE_FROM_FAVORITES';
export const RESET_FAVORITE_COMCOURSES = 'RESET_FAVORITE_COMCOURSES';
export const SET_FAVORITES_NOTIFICATION_DATA = 'SET_FAVORITES_NOTIFICATION_DATA';
export const SET_SUGGEST_EDIT_MODAL_STATUS = 'SET_SUGGEST_EDIT_MODAL_STATUS';
export const SET_REPORT_ISSUE_MODAL_STATUS = 'SET_REPORT_ISSUE_MODAL_STATUS';
export const SET_SUBMIT_REVIEW_MODAL_STATUS = 'SET_SUBMIT_REVIEW_MODAL_STATUS';
export const SET_STAR_RATING_VALUE = 'SET_STAR_RATING_VALUE';
export const SET_COMCOURSE_REVIEWS_SORT_VALUE = 'SET_COMCOURSE_REVIEWS_SORT_VALUE';
export const SET_SELECTED_COMCOURSE_REVIEW = 'SET_SELECTED_COMCOURSE_REVIEW';
export const SET_SUBMIT_REVIEW_PHOTOS = 'SET_SUBMIT_REVIEW_PHOTOS';
export const SET_CENTER_LOCATION = 'SET_CENTER_LOCATION';
export const SET_SEARCHED_LOCATION = 'SET_SEARCHED_LOCATION';
export const SET_SHARE_REVIEW_MODAL_STATUS = 'SET_SHARE_REVIEW_MODAL_STATUS';
export const SET_SEARCH_ADDITIONAL_DATA = 'SET_SEARCH_ADDITIONAL_DATA';
export const SET_ZOOM_LEVEL = 'SET_ZOOM_LEVEL';
export const SET_BOUNDING_BOX = 'SET_BOUNDING_BOX';
export const SET_COMCOURSE_ERROR = 'SET_COMCOURSE_ERROR';

export const CONFIRM_ELEVATION_WAS_UPDATED_BY_API_FOR_COURSE = 'CONFIRM_ELEVATION_WAS_UPDATED_BY_API_FOR_COURSE';

export const SET_PACEPRO_CREATE_COURSE = 'SET_PACEPRO_CREATE_COURSE';

export const SET_MAP_BOUNDING_BOX = 'SET_MAP_BOUNDING_BOX';
export const RESET_MAP_BOUNDING_BOX = 'RESET_MAP_BOUNDING_BOX';

export const SET_PACEPRO_CREATE_DISTANCE = 'SET_PACEPRO_CREATE_DISTANCE';

export const SET_PACEPRO_CREATE_COURSE_FROM_EVENT = 'SET_PACEPRO_CREATE_COURSE_FROM_EVENT';

export const REQUEST_COURSE_MAP_MATCH = 'REQUEST_COURSE_MAP_MATCH';
export const REQUEST_COURSE_MAP_MATCH_DONE = 'REQUEST_COURSE_MAP_MATCH_DONE';
export const RESET_COURSE_MAP_MATCH_STATUS = 'RESET_COURSE_MAP_MATCH_STATUS';

export const FETCH_USER_STATS_WELLNESS_DAILY = 'FETCH_USER_STATS_WELLNESS_DAILY';
export const FETCH_USER_STATS_WELLNESS_DAILY_FETCHING = 'FETCH_USER_STATS_WELLNESS_DAILY_FETCHING';
export const FETCH_USER_STATS_WELLNESS_DAILY_SUCCESS = 'FETCH_USER_STATS_WELLNESS_DAILY_SUCCESS';
export const FETCH_USER_STATS_WELLNESS_DAILY_FAIL = 'FETCH_USER_STATS_WELLNESS_DAILY_FAIL';

export const FETCH_USER_STATS_WELLNESS_WEEKLY = 'FETCH_USER_STATS_WELLNESS_WEEKLY';
export const FETCH_USER_STATS_WELLNESS_WEEKLY_FETCHING = 'FETCH_USER_STATS_WELLNESS_WEEKLY_FETCHING';
export const FETCH_USER_STATS_WELLNESS_WEEKLY_SUCCESS = 'FETCH_USER_STATS_WELLNESS_WEEKLY_SUCCESS';
export const FETCH_USER_STATS_WELLNESS_WEEKLY_FAIL = 'FETCH_USER_STATS_WELLNESS_WEEKLY_FAIL';

export const FETCH_USER_STATS_WELLNESS_MONTHLY = 'FETCH_USER_STATS_WELLNESS_MONTHLY';
export const FETCH_USER_STATS_WELLNESS_MONTHLY_FETCHING = 'FETCH_USER_STATS_WELLNESS_MONTHLY_FETCHING';
export const FETCH_USER_STATS_WELLNESS_MONTHLY_SUCCESS = 'FETCH_USER_STATS_WELLNESS_MONTHLY_SUCCESS';
export const FETCH_USER_STATS_WELLNESS_MONTHLY_FAIL = 'FETCH_USER_STATS_WELLNESS_MONTHLY_FAIL';

export const FETCH_WELLNESS_GOALS = 'FETCH_WELLNESS_GOALS';
export const FETCH_WELLNESS_GOALS_FETCHING = 'FETCH_WELLNESS_GOALS_FETCHING';
export const FETCH_WELLNESS_GOALS_SUCCESS = 'FETCH_WELLNESS_GOALS_SUCCESS';
export const FETCH_WELLNESS_GOALS_FAIL = 'FETCH_WELLNESS_GOALS_FAIL';

export const UPDATE_WELLNESS_GOALS = 'UPDATE_WELLNESS_GOALS';
export const UPDATE_WELLNESS_GOALS_UPDATING = 'UPDATE_WELLNESS_GOALS_UPDATING';
export const UPDATE_WELLNESS_GOALS_SUCCESS = 'UPDATE_WELLNESS_GOALS_SUCCESS';
export const UPDATE_WELLNESS_GOALS_FAIL = 'UPDATE_WELLNESS_GOALS_FAIL';
export const RESET_WELLNESS_GOALS_UPDATE = 'RESET_WELLNESS_GOALS_UPDATE';

export const FETCH_FLOORS_DATA = 'FETCH_FLOORS_DATA';
export const FETCH_FLOORS_DATA_FETCHING = 'FETCH_FLOORS_DATA_FETCHING';
export const FETCH_FLOORS_DATA_FAIL = 'FETCH_FLOORS_DATA_FAIL';
export const FETCH_FLOORS_DATA_SUCCESS = 'FETCH_FLOORS_DATA_SUCCESS';

export const GET_PACEPRO_CREATE = 'GET_PACEPRO_CREATE';
export const RESET_PACEPRO_CREATE = 'RESET_PACEPRO_CREATE';

export const FETCH_CONSOLIDATED_STEP_GOAL = 'FETCH_CONSOLIDATED_STEP_GOAL';
export const FETCH_CONSOLIDATED_STEP_GOAL_FETCHING = 'FETCH_CONSOLIDATED_STEP_GOAL_FETCHING';
export const FETCH_CONSOLIDATED_STEP_GOAL_SUCCESS = 'FETCH_CONSOLIDATED_STEP_GOAL_SUCCESS';
export const FETCH_CONSOLIDATED_STEP_GOAL_FAIL = 'FETCH_CONSOLIDATED_STEP_GOAL_FAIL';

export const FETCH_CONSOLIDATED_PUSHES_GOAL = 'FETCH_CONSOLIDATED_PUSHES_GOAL';
export const FETCH_CONSOLIDATED_PUSHES_GOAL_FETCHING = 'FETCH_CONSOLIDATED_PUSHES_GOAL_FETCHING';
export const FETCH_CONSOLIDATED_PUSHES_GOAL_SUCCESS = 'FETCH_CONSOLIDATED_PUSHES_GOAL_SUCCESS';
export const FETCH_CONSOLIDATED_PUSHES_GOAL_FAIL = 'FETCH_CONSOLIDATED_PUSHES_GOAL_FAIL';

export const UPDATE_CONSOLIDATED_STEP_GOAL = 'UPDATE_CONSOLIDATED_STEP_GOAL';
export const UPDATE_CONSOLIDATED_STEP_GOAL_SUCCESS = 'UPDATE_CONSOLIDATED_STEP_GOAL_SUCCESS';
export const UPDATE_CONSOLIDATED_STEP_GOAL_FAIL = 'UPDATE_CONSOLIDATED_STEP_GOAL_FAIL';
export const RESET_CONSOLIDATED_STEP_GOAL_UPDATE = 'RESET_CONSOLIDATED_STEP_GOAL_UPDATE';

export const UPDATE_CONSOLIDATED_PUSHES_GOAL = 'UPDATE_CONSOLIDATED_PUSHES_GOAL';
export const UPDATE_CONSOLIDATED_PUSHES_GOAL_SUCCESS = 'UPDATE_CONSOLIDATED_PUSHES_GOAL_SUCCESS';
export const UPDATE_CONSOLIDATED_PUSHES_GOAL_FAIL = 'UPDATE_CONSOLIDATED_PUSHES_GOAL_FAIL';
export const RESET_CONSOLIDATED_PUSHES_GOAL_UPDATE = 'RESET_CONSOLIDATED_PUSHES_GOAL_UPDATE';

export const FETCH_DAILY_STEPS = 'FETCH_DAILY_STEPS';
export const FETCH_DAILY_STEPS_FETCHING = 'FETCH_DAILY_STEPS_FETCHING';
export const FETCH_DAILY_STEPS_SUCCESS = 'FETCH_DAILY_STEPS_SUCCESS';
export const FETCH_DAILY_STEPS_FAIL = 'FETCH_DAILY_STEPS_FAIL';

export const FETCH_PUSHES_DAILY_AVERAGE = 'FETCH_PUSHES_DAILY_AVERAGE';
export const FETCH_PUSHES_DAILY_AVERAGE_FETCHING = 'FETCH_PUSHES_DAILY_AVERAGE_FETCHING';
export const FETCH_PUSHES_DAILY_AVERAGE_SUCCESS = 'FETCH_PUSHES_DAILY_AVERAGE_SUCCESS';
export const FETCH_PUSHES_DAILY_AVERAGE_FAIL = 'FETCH_PUSHES_DAILY_AVERAGE_FAIL';

export const FETCH_COURSE_DETAIL = 'FETCH_COURSE_DETAIL';
export const FETCH_COURSE_DETAILS_START = 'FETCH_COURSE_DETAILS_START';
export const FETCH_COURSE_DETAIL_SUCCESS = 'FETCH_COURSE_DETAIL_SUCCESS';
export const FETCH_COURSE_DETAIL_FAIL = 'FETCH_COURSE_DETAIL_FAIL';
export const UPDATE_COURSE = 'UPDATE_COURSE';

export const FETCH_COURSE_ROUND_TRIP_ROUTE = 'FETCH_COURSE_ROUND_TRIP_ROUTE';
export const FETCH_START_COURSE_ROUND_TRIP_ROUTE = 'FETCH_START_COURSE_ROUND_TRIP_ROUTE';
export const RECEIVE_COURSE_ROUND_TRIP_ROUTE = 'RECEIVE_COURSE_ROUND_TRIP_ROUTE';
export const RECEIVE_COURSE_ROUND_TRIP_ROUTE_ERROR = 'RECEIVE_COURSE_ROUND_TRIP_ROUTE_ERROR';

export const FETCH_COURSE_POPULAR_ROUTES = 'FETCH_COURSE_POPULAR_ROUTES';
export const FETCH_START_COURSE_POPULAR_ROUTES = 'FETCH_START_COURSE_POPULAR_ROUTES';
export const FETCH_COURSE_POPULAR_ROUTES_SUCCESS = 'FETCH_COURSE_POPULAR_ROUTES_SUCCESS';
export const FETCH_COURSE_POPULAR_ROUTES_ERROR = 'FETCH_COURSE_POPULAR_ROUTES_ERROR';
export const FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB = 'FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB';
export const FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_SUCCESS = 'FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_SUCCESS';
export const FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_ERROR = 'FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_ERROR';

export const FETCH_ELEVATION_DATA_FOR_COURSE_POINTS = 'FETCH_ELEVATION_DATA_FOR_COURSE_POINTS';
export const FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_START = 'FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_START';
export const FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ENDED = 'FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ENDED';
export const FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_SUCCESS = 'FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_SUCCESS';
export const FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ERROR = 'FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ERROR';
export const FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT =
    'FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT';
export const FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT_DONE =
    'FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT_DONE';

export const FETCH_COURSE_POINTS = 'FETCH_COURSE_POINTS';
export const FETCH_COURSE_POINTS_START = 'FETCH_COURSE_POINTS_START';
export const FETCH_COURSE_POINTS_SUCCESS = 'FETCH_COURSE_POINTS_SUCCESS';
export const FETCH_COURSE_POINTS_ERROR = 'FETCH_COURSE_POINTS_ERROR';

export const ELEVATION_CHART_HOVER = 'ELEVATION_CHART_HOVER';
export const RESET_ELEVATION_CHART_HOVER = 'RESET_ELEVATION_CHART_HOVER';

export const SET_COURSE_POINT_SELECTION = 'SET_COURSE_POINT_SELECTION';
export const RESET_COURSE_POINT_SELECTION = 'RESET_COURSE_POINT_SELECTION';

export const SET_PACEPRO_CREATE_STRATEGY = 'SET_PACEPRO_CREATE_STRATEGY';
export const SET_PACEPRO_CREATE_HILL_EFFORT = 'SET_PACEPRO_CREATE_HILL_EFFORT';
export const SET_PACEPRO_CREATE_ELEVATION_SEGMENT_MIN_LENGTH = 'SET_PACEPRO_CREATE_ELEVATION_SEGMENT_MIN_LENGTH';
export const SET_PACEPRO_CREATE_SPLITS = 'SET_PACEPRO_CREATE_SPLITS';
export const SET_PACEPRO_CREATE_GOALTIME = 'SET_PACEPRO_CREATE_GOALTIME';
export const SET_PACEPRO_CREATE_PACE_INTERVALS = 'SET_PACEPRO_CREATE_PACE_INTERVALS';

export const FETCH_MENSTRUAL_CYCLE_DAILY_VIEW = 'FETCH_MENSTRUAL_CYCLE_DAILY_VIEW';
export const FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FETCHING = 'FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FETCHING';
export const FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_SUCCESS = 'FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_SUCCESS';
export const FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FAIL = 'FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FAIL';
export const SET_MENSTRUAL_CYCLE_SYMPTOM = 'SET_MENSTRUAL_CYCLE_SYMPTOM';
export const RESET_MENSTRUAL_CYCLE_SYMPTOMS = 'RESET_MENSTRUAL_CYCLE_SYMPTOMS';
export const UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS = 'UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS';
export const UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_START = 'UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_START';
export const UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_SUCCESS = 'UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_SUCCESS';
export const UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_ERROR = 'UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_ERROR';
export const FETCH_MENSTRUAL_CYCLE_SYMPTOMS_ICONS = 'FETCH_MENSTRUAL_CYCLE_SYMPTOMS_ICONS';
export const MENSTRUAL_CYCLE_SYMPTOMS_ICONS_FETCHING = 'MENSTRUAL_CYCLE_SYMPTOMS_ICONS_FETCHING';
export const MENSTRUAL_CYCLE_SYMPTOMS_ICONS_SUCCESS = 'MENSTRUAL_CYCLE_SYMPTOMS_ICONS_SUCCESS';
export const MENSTRUAL_CYCLE_SYMPTOMS_ICONS_ERROR = 'MENSTRUAL_CYCLE_SYMPTOMS_ICONS_ERROR';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY = 'FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FETCHING = 'FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FETCHING';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_SUCCESS = 'FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_SUCCESS';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FAIL = 'FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FAIL';
export const RESET_MENSTRUAL_CYCLING_TRACKING_SUMMARY = 'RESET_MENSTRUAL_CYCLING_TRACKING_SUMMARY';

export const FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR = 'FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FETCHING = 'FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FETCHING';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_SUCCESS = 'FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_SUCCESS';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FAIL = 'FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FAIL';
export const ADD_OR_REMOVE_MENSTRUAL_DATE = 'ADD_OR_REMOVE_MENSTRUAL_DATE';
export const RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR = 'RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR';
export const ONLY_RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR = 'ONLY_RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR';
export const SAVE_MENSTRUAL_DATE_CHANGES_AND_UPDATE_DAY_VIEW_DATA =
    'SAVE_MENSTRUAL_DATE_CHANGES_AND_UPDATE_DAY_VIEW_DATA';
export const SAVE_MENSTRUAL_DATE_CHANGES = 'SAVE_MENSTRUAL_DATE_CHANGES';
export const SAVE_MENSTRUAL_DATE_CHANGES_START = 'SAVE_MENSTRUAL_DATE_CHANGES_START';
export const STARTED_CYCLE_UPDATE_FROM_CALENDAR = 'STARTED_CYCLE_UPDATE_FROM_CALENDAR';
export const ENDED_CYCLE_UPDATE_FROM_CALENDAR = 'ENDED_CYCLE_UPDATE_FROM_CALENDAR';
export const ENDED_CYCLE_UPDATE_FROM_CALENDAR_FAIL = 'ENDED_CYCLE_UPDATE_FROM_CALENDAR_FAIL';
export const SAVE_MENSTRUAL_DATE_CHANGES_SUCCESS = 'SAVE_MENSTRUAL_DATE_CHANGES_SUCCESS';
export const SAVE_MENSTRUAL_DATE_CHANGES_FAIL = 'SAVE_MENSTRUAL_DATE_CHANGES_FAIL';
export const SET_MCT_CALENDAR_MODAL_OPENED_STATE = 'SET_MCT_CALENDAR_MODAL_OPENED_STATE';
export const SET_MCT_CALENDAR_MODAL_OPENED_IN_EDIT_STATE = 'SET_MCT_CALENDAR_MODAL_OPENED_IN_EDIT_STATE';
export const SET_MCT_CALENDAR_SELECTED_DATES_TO_PRISTINE = 'SET_MCT_CALENDAR_SELECTED_DATES_TO_PRISTINE';
export const SET_CALENDAR_EDITABLE_UNTIL_DATE = 'SET_CALENDAR_EDITABLE_UNTIL_DATE';
export const RESET_CALENDAR_EDITABLE_UNTIL_DATE = 'RESET_CALENDAR_EDITABLE_UNTIL_DATE';
export const FETCH_MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT = 'FETCH_MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT';
export const MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_FETCHING = 'MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_FETCHING';
export const MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_SUCCESS = 'MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_SUCCESS';
export const MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_ERROR = 'MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_ERROR';

export const FETCH_USER_CAPABLE = 'FETCH_USER_CAPABLE';
export const FETCH_USER_CAPABLE_FETCHING = 'FETCH_USER_CAPABLE_FETCHING';
export const FETCH_USER_CAPABLE_SUCCESS = 'FETCH_USER_CAPABLE_SUCCESS';
export const FETCH_USER_CAPABLE_FAIL = 'FETCH_USER_CAPABLE_FAIL';

export const UPDATE_CALORIES_VIEW_STATE = 'UPDATE_CALORIES_VIEW_STATE';
export const UPDATE_CALORIES_FLAME_PERCENT = 'UPDATE_CALORIES_FLAME_PERCENT';

export const AUTHORIZE_MFP = 'AUTHORIZE_MFP';
export const AUTHORIZE_MFP_SUCCESS = 'AUTHORIZE_MFP_SUCCESS';
export const AUTHORIZE_MFP_FAIL = 'AUTHORIZE_MFP_FAIL';

export const DISCONNECT_FROM_MFP = 'DISCONNECT_FROM_MFP';

export const FETCH_MFP = 'FETCH_MFP';
export const FETCH_MFP_SUCCESS = 'FETCH_MFP_SUCCESS';
export const FETCH_MFP_FAIL = 'FETCH_MFP_FAIL';

export const FETCH_MFP_INFO = 'FETCH_MFP_INFO';
export const FETCH_MFP_INFO_SUCCESS = 'FETCH_MFP_INFO_SUCCESS';
export const FETCH_MFP_INFO_FAIL = 'FETCH_MFP_INFO_FAIL';

export const FETCH_BODY_BATTERY_TODAY = 'FETCH_BODY_BATTERY_TODAY';
export const FETCH_BODY_BATTERY_TODAY_SUCCESS = 'FETCH_BODY_BATTERY_TODAY_SUCCESS';
export const FETCH_BODY_BATTERY_TODAY_FAIL = 'FETCH_BODY_BATTERY_TODAY_FAIL';

export const FETCH_WEIGHT_LIST = 'FETCH_WEIGHT_LIST';
export const FETCH_WEIGHT_LIST_FETCHING = 'FETCH_WEIGHT_LIST_FETCHING';
export const FETCH_WEIGHT_LIST_SUCCESS = 'FETCH_WEIGHT_LIST_SUCCESS';
export const FETCH_WEIGHT_LIST_FAIL = 'FETCH_WEIGHT_LIST_FAIL';

export const FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS = 'FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FETCHING = 'FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FETCHING';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_SUCCESS = 'FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_SUCCESS';
export const FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FAIL = 'FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FAIL';
export const RESET_MENSTRUAL_CYCLING_TRACKING_REPORTS = 'RESET_MENSTRUAL_CYCLING_TRACKING_REPORTS';

export const SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP = 'SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP';
export const SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_START = 'SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_START';
export const SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_SUCCESS = 'SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_SUCCESS';
export const SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_FAIL = 'SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_FAIL';
export const RESET_MENSTRUAL_CYCLE_INITIAL_SETUP_SAVE_STATUS = 'RESET_MENSTRUAL_CYCLE_INITIAL_SETUP_SAVE_STATUS';
export const SET_MENSTRUAL_CYCLE_INITIAL_SETUP = 'SET_MENSTRUAL_CYCLE_INITIAL_SETUP';
export const UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP = 'UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP';
export const SET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1 = 'SET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1';
export const UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1 = 'UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1';
export const OPEN_MCT_INITIAL_SETUP_ALL_SET_MODAL = 'OPEN_MCT_INITIAL_SETUP_ALL_SET_MODAL';
export const CLOSE_MCT_INITIAL_SETUP_ALL_SET_MODAL = 'CLOSE_MCT_INITIAL_SETUP_ALL_SET_MODAL';

export const SET_PACEPRO_CREATE_NAME = 'SET_PACEPRO_CREATE_NAME';

export const FETCH_MFP_LAST_SYNC = 'FETCH_MFP_LAST_SYNC';
export const FETCH_MFP_LAST_SYNC_SUCCESS = 'FETCH_MFP_LAST_SYNC_SUCCESS';
export const FETCH_MFP_LAST_SYNC_FAIL = 'FETCH_MFP_LAST_SYNC_FAIL';

export const SYNC_MFP_NOW = 'SYNC_MFP_NOW';
export const SYNC_MFP_NOW_SUCCESS = 'SYNC_MFP_NOW_SUCCESS';
export const SYNC_MFP_NOW_FAIL = 'SYNC_MFP_NOW_FAIL';

export const FETCH_MFP_RECENT_CALORIES_GOAL = 'FETCH_MFP_RECENT_CALORIES_GOAL';
export const FETCH_MFP_RECENT_CALORIES_GOAL_DONE = 'FETCH_MFP_RECENT_CALORIES_GOAL_DONE';

export const SET_PACEPRO_CREATE = 'SET_PACEPRO_CREATE';

export const SAVE_OR_CONFIRM_SINGLE_CYCLE = 'SAVE_OR_CONFIRM_SINGLE_CYCLE';
export const SAVE_OR_CONFIRM_SINGLE_CYCLE_FAIL = 'SAVE_OR_CONFIRM_SINGLE_CYCLE_FAIL';
export const SAVE_OR_CONFIRM_SINGLE_CYCLE_START = 'SAVE_OR_CONFIRM_SINGLE_CYCLE_START';
export const SAVE_OR_CONFIRM_SINGLE_CYCLE_END = 'SAVE_OR_CONFIRM_SINGLE_CYCLE_END';

export const FETCH_WELLNESS_DAILY_PULSE_OX_DATA = 'FETCH_WELLNESS_DAILY_PULSE_OX_DATA';
export const FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FETCHING = 'FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FETCHING';
export const FETCH_WELLNESS_DAILY_PULSE_OX_DATA_SUCCESS = 'FETCH_WELLNESS_DAILY_PULSE_OX_DATA_SUCCESS';
export const FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FAIL = 'FETCH_WELLNESS_DAILY_PULSE_OX_DATA_FAIL';

export const FETCH_WELLNESS_DAILY_RESPIRATION_DATA = 'FETCH_WELLNESS_DAILY_RESPIRATION_DATA';
export const FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FETCHING = 'FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FETCHING';
export const FETCH_WELLNESS_DAILY_RESPIRATION_DATA_SUCCESS = 'FETCH_WELLNESS_DAILY_RESPIRATION_DATA_SUCCESS';
export const FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FAIL = 'FETCH_WELLNESS_DAILY_RESPIRATION_DATA_FAIL';

export const FETCH_RESPIRATION_REPORTS_DATA = 'FETCH_RESPIRATION_REPORTS_DATA';
export const FETCH_RESPIRATION_REPORTS_DATA_FETCHING = 'FETCH_RESPIRATION_REPORTS_DATA_FETCHING';
export const FETCH_RESPIRATION_REPORTS_DATA_SUCCESS = 'FETCH_RESPIRATION_REPORTS_DATA_SUCCESS';
export const FETCH_RESPIRATION_REPORTS_DATA_FAIL = 'FETCH_RESPIRATION_REPORTS_DATA_FAIL';

export const RESET_PACEPRO_CREATE_STRATEGY = 'RESET_PACEPRO_CREATE_STRATEGY';
export const RESET_PACEPRO_CREATE_HILL_EFFORT = 'RESET_PACEPRO_CREATE_HILL_EFFORT';
export const RESET_PACEPRO_CREATE_ELEVATION_SEGMENT_MIN_LENGTH = 'RESET_PACEPRO_CREATE_ELEVATION_SEGMENT_MIN_LENGTH;';

export const INITIALIZE_PACEPRO_CREATE = 'INITIALIZE_PACEPRO_CREATE';
export const SET_PACEPRO_CREATE_MANUAL_PACE = 'SET_PACEPRO_CREATE_MANUAL_PACE';

export const FETCH_PERSONAL_RECORDS = 'FETCH_PERSONAL_RECORDS';
export const FETCH_PERSONAL_RECORDS_FETCHING = 'FETCH_PERSONAL_RECORDS_FETCHING';
export const FETCH_PERSONAL_RECORDS_SUCCESS = 'FETCH_PERSONAL_RECORDS_SUCCESS';
export const FETCH_PERSONAL_RECORDS_FAIL = 'FETCH_PERSONAL_RECORDS_FAIL';

export const FETCH_PERSONAL_RECORD_CANDIDATES = 'FETCH_PERSONAL_RECORD_CANDIDATES';
export const FETCH_PERSONAL_RECORD_CANDIDATES_FETCHING = 'FETCH_PERSONAL_RECORD_CANDIDATES_FETCHING';
export const FETCH_PERSONAL_RECORD_CANDIDATES_SUCCESS = 'FETCH_PERSONAL_RECORD_CANDIDATES_SUCCESS';
export const FETCH_PERSONAL_RECORD_CANDIDATES_FAIL = 'FETCH_PERSONAL_RECORD_CANDIDATES_FAIL';

export const FETCH_PERSONAL_RECORD_TYPES = 'FETCH_PERSONAL_RECORD_TYPES';
export const FETCH_PERSONAL_RECORD_TYPES_FETCHING = 'FETCH_PERSONAL_RECORD_TYPES_FETCHING';
export const FETCH_PERSONAL_RECORD_TYPES_SUCCESS = 'FETCH_PERSONAL_RECORD_TYPES_SUCCESS';
export const FETCH_PERSONAL_RECORD_TYPES_FAIL = 'FETCH_PERSONAL_RECORD_TYPES_FAIL';

export const FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID = 'FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID';
export const FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FETCHING = 'FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FETCHING';
export const FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_SUCCESS = 'FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_SUCCESS';
export const FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FAIL = 'FETCH_PERSONAL_RECORD_BY_ACTIVITY_ID_FAIL';

export const FETCH_TRAINING_STATUS_AGGREGATED_DATA = 'FETCH_TRAINING_STATUS_AGGREGATED_DATA';
export const FETCH_TRAINING_STATUS_AGGREGATED_DATA_FETCHING = 'FETCH_TRAINING_STATUS_AGGREGATED_DATA_FETCHING';
export const FETCH_TRAINING_STATUS_AGGREGATED_DATA_SUCCESS = 'FETCH_TRAINING_STATUS_AGGREGATED_DATA_SUCCESS';
export const FETCH_TRAINING_STATUS_AGGREGATED_DATA_FAIL = 'FETCH_TRAINING_STATUS_AGGREGATED_DATA_FAIL';
export const FETCH_TRAINING_STATUS_MOST_RECENT_DATA = 'FETCH_TRAINING_STATUS_MOST_RECENT_DATA';
export const FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FETCHING = 'FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FETCHING';
export const FETCH_TRAINING_STATUS_MOST_RECENT_DATA_SUCCESS = 'FETCH_TRAINING_STATUS_MOST_RECENT_DATA_SUCCESS';
export const FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FAIL = 'FETCH_TRAINING_STATUS_MOST_RECENT_DATA_FAIL';

export const FETCH_TRAINING_STATUS_WEEKLY_DATA = 'FETCH_TRAINING_STATUS_WEEKLY_DATA';
export const FETCH_TRAINING_STATUS_WEEKLY_DATA_FETCHING = 'FETCH_TRAINING_STATUS_WEEKLY_DATA_FETCHING';
export const FETCH_TRAINING_STATUS_WEEKLY_DATA_SUCCESS = 'FETCH_TRAINING_STATUS_WEEKLY_DATA_SUCCESS';
export const FETCH_TRAINING_STATUS_WEEKLY_DATA_FAIL = 'FETCH_TRAINING_STATUS_WEEKLY_DATA_FAIL';

export const FETCH_SELF_EVALUATION_ICONS = 'FETCH_SELF_EVALUATION_ICONS';
export const SELF_EVALUATION_ICONS_FETCHING = 'SELF_EVALUATION_ICONS_FETCHING';
export const SELF_EVALUATION_ICONS_SUCCESS = 'SELF_EVALUATION_ICONS_SUCCESS';
export const SELF_EVALUATION_ICONS_ERROR = 'SELF_EVALUATION_ICONS_ERROR';

export const FETCH_CHALLENGE = 'FETCH_CHALLENGE';
export const FETCH_CHALLENGE_SUCCESS = 'FETCH_CHALLENGE_SUCCESS';
export const FETCH_CHALLENGE_FAIL = 'FETCH_CHALLENGE_FAIL';
export const BADGE_CHALLENGE_DETAIL_OPT_IN_AUTO_CHALLENGE = 'BADGE_CHALLENGE_DETAIL_OPT_IN_AUTO_CHALLENGE';
export const BADGE_CHALLENGE_DETAIL_UPDATE_AUTO_CHALLENGE = 'BADGE_CHALLENGE_DETAIL_UPDATE_AUTO_CHALLENGE';

export const CLEAN_BADGE_CHALLENGE_PAGE = 'CLEAN_BADGE_CHALLENGE_PAGE';

export const JOIN_CHALLENGE = 'JOIN_CHALLENGE';
export const JOIN_CHALLENGE_SUCCESS = 'JOIN_CHALLENGE_SUCCESS';
export const JOIN_CHALLENGE_FAIL = 'JOIN_CHALLENGE_FAIL';

export const CLOSE_JOIN_CHALLENGE_MODAL = 'CLOSE_JOIN_CHALLENGE_MODAL';

export const LEAVE_CHALLENGE = 'LEAVE_CHALLENGE';
export const LEAVE_CHALLENGE_SUCCESS = 'LEAVE_CHALLENGE_SUCCESS';
export const LEAVE_CHALLENGE_FAIL = 'LEAVE_CHALLENGE_FAIL';

export const RESET_TRAINING_PLAN_SETUP_DATA = 'RESET_TRAINING_PLAN_SETUP_DATA';
export const FETCH_TRAINING_PLAN_FOR_SETUP = 'FETCH_TRAINING_PLAN_FOR_SETUP';
export const FETCH_USER_CURRENT_TRAINING_DATA = 'FETCH_USER_CURRENT_TRAINING_DATA';
export const FETCHING_USER_CURRENT_TRAINING_DATA = 'FETCHING_USER_CURRENT_TRAINING_DATA';
export const FETCH_USER_CURRENT_TRAINING_DATA_SUCCESS = 'FETCH_USER_CURRENT_TRAINING_DATA_SUCCESS';
export const FETCH_USER_CURRENT_TRAINING_DATA_ERROR = 'FETCH_USER_CURRENT_TRAINING_DATA_ERROR';
export const FETCH_TRAINING_PLAN_BY_ID = 'FETCH_TRAINING_PLAN_BY_ID';
export const GET_WORKOUT_SCHEDULE_BY_PERIOD = 'GET_WORKOUT_SCHEDULE_BY_PERIOD';
export const FETCHING_WORKOUT_SCHEDULE_BY_PERIOD = 'FETCHING_WORKOUT_SCHEDULE_BY_PERIOD';
export const FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_SUCCESS = 'FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_SUCCESS';
export const FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_ERROR = 'FETCHING_WORKOUT_SCHEDULE_BY_PERIOD_ERROR';
export const DELETE_TRAINING_PLAN = 'DELETE_TRAINING_PLAN';
export const DELETING_TRAINING_PLAN = 'DELETING_TRAINING_PLAN';
export const DELETE_TRAINING_PLAN_SUCCESS = 'DELETE_TRAINING_PLAN_SUCCESS';
export const DELETE_TRAINING_PLAN_FAIL = 'DELETE_TRAINING_PLAN_FAIL';
export const DELETE_TRAINING_PLAN_BY_IDS = 'DELETE_TRAINING_PLAN_BY_IDS';
export const DELETING_TRAINING_PLAN_BY_IDS = 'DELETING_TRAINING_PLAN_BY_IDS';
export const DELETE_TRAINING_PLAN_SUCCESS_BY_IDS = 'DELETE_TRAINING_PLAN_SUCCESS_BY_IDS';
export const DELETE_TRAINING_PLAN_FAIL_BY_IDS = 'DELETE_TRAINING_PLAN_FAIL_BY_IDS';
export const RESET_TRAINING_PLAN_BY_ID_DATA = 'RESET_TRAINING_PLAN_BY_ID_DATA';
export const FETCHING_TRAINING_PLAN = 'FETCHING_TRAINING_PLAN';
export const FETCHING_TRAINING_PLAN_SUCCESS = 'FETCHING_TRAINING_PLAN_SUCCESS';
export const FETCHING_TRAINING_PLAN_ERROR = 'FETCHING_TRAINING_PLAN_ERROR';
export const FETCHING_TRAINING_PLAN_FOR_SETUP = 'FETCHING_TRAINING_PLAN_FOR_SETUP';
export const FETCHING_TRAINING_PLAN_FOR_SETUP_SUCCESS = 'FETCHING_TRAINING_PLAN_FOR_SETUP_SUCCESS';
export const FETCHING_TRAINING_PLAN_FOR_SETUP_ERROR = 'FETCHING_TRAINING_PLAN_FOR_SETUP_ERROR';
export const SET_TRAINING_PLAN_SETUP_DATA = 'SET_TRAINING_PLAN_SETUP_DATA';
export const CREATE_PHASED_TRAINING_PLAN = 'CREATE_PHASED_TRAINING_PLAN';
export const CREATING_PHASED_TRAINING_PLAN = 'CREATING_PHASED_TRAINING_PLAN';
export const CREATE_PHASED_TRAINING_PLAN_ERROR = 'CREATE_PHASED_TRAINING_PLAN_ERROR';
export const CREATED_PHASED_TRAINING_PLAN = 'CREATED_PHASED_TRAINING_PLAN';
export const SKIP_RACE_DAY_STEP = 'SKIP_RACE_DAY_STEP';
export const RESET_SKIP_RACE_DAY_STEP = 'RESET_SKIP_RACE_DAY_STEP';
export const SET_TRAINING_PLAN_LEVEL_DATA = 'SET_TRAINING_PLAN_LEVEL_DATA';

export const FETCH_INTENSITY_MINUTES_DATA = 'FETCH_INTENSITY_MINUTES_DATA';
export const FETCH_INTENSITY_MINUTES_DATA_FETCHING = 'FETCH_INTENSITY_MINUTES_DATA_FETCHING';
export const FETCH_INTENSITY_MINUTES_DATA_SUCCESS = 'FETCH_INTENSITY_MINUTES_DATA_SUCCESS';
export const FETCH_INTENSITY_MINUTES_DATA_FAIL = 'FETCH_INTENSITY_MINUTES_DATA_FAIL';

export const FETCH_INTENSITY_MINUTES_DAILY_DATA = 'FETCH_INTENSITY_MINUTES_DAILY_DATA';
export const FETCH_INTENSITY_MINUTES_DAILY_DATA_FETCHING = 'FETCH_INTENSITY_MINUTES_DAILY_DATA_FETCHING';
export const FETCH_INTENSITY_MINUTES_DAILY_DATA_SUCCESS = 'FETCH_INTENSITY_MINUTES_DAILY_DATA_SUCCESS';
export const FETCH_INTENSITY_MINUTES_DAILY_DATA_FAIL = 'FETCH_INTENSITY_MINUTES_DAILY_DATA_FAIL';

export const FETCH_INTENSITY_MINUTES_WEEKLY_DATA = 'FETCH_INTENSITY_MINUTES_WEEKLY_DATA';
export const FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FETCHING = 'FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FETCHING';
export const FETCH_INTENSITY_MINUTES_WEEKLY_DATA_SUCCESS = 'FETCH_INTENSITY_MINUTES_WEEKLY_DATA_SUCCESS';
export const FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FAIL = 'FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FAIL';

export const FETCH_INTENSITY_MINUTES_HOURLY_DATA = 'FETCH_INTENSITY_MINUTES_HOURLY_DATA';
export const FETCH_INTENSITY_MINUTES_HOURLY_DATA_DONE = 'FETCH_INTENSITY_MINUTES_HOURLY_DATA_DONE';

export const CREATE_EPOCH_DATA_RELOAD = 'CREATE_EPOCH_DATA_RELOAD';
export const CREATE_EPOCH_DATA_RELOAD_FETCHING = 'CREATE_EPOCH_DATA_RELOAD_FETCHING';
export const CREATE_EPOCH_DATA_RELOAD_SUCCESS = 'CREATE_EPOCH_DATA_RELOAD_SUCCESS';
export const CREATE_EPOCH_DATA_RELOAD_FAIL = 'CREATE_EPOCH_DATA_RELOAD_FAIL';

export const FETCH_USER_SUMMARY_MONTHLY = 'FETCH_USER_SUMMARY_MONTHLY';
export const FETCH_USER_SUMMARY_MONTHLY_FETCHING = 'FETCH_USER_SUMMARY_MONTHLY_FETCHING';
export const FETCH_USER_SUMMARY_MONTHLY_SUCCESS = 'FETCH_USER_SUMMARY_MONTHLY_SUCCESS';
export const FETCH_USER_SUMMARY_MONTHLY_FAIL = 'FETCH_USER_SUMMARY_MONTHLY_FAIL';

export const FETCH_FITNESS_AGE_DATA = 'FETCH_FITNESS_AGE_DATA';
export const FETCH_FITNESS_AGE_DATA_FETCHING = 'FETCH_FITNESS_AGE_DATA_FETCHING';
export const FETCH_FITNESS_AGE_DATA_SUCCESS = 'FETCH_FITNESS_AGE_DATA_SUCCESS';
export const FETCH_FITNESS_AGE_DATA_FAIL = 'FETCH_FITNESS_AGE_DATA_FAIL';

export const FETCH_TYPED_SPLITS = 'FETCH_TYPED_SPLITS';
export const FETCH_TYPED_SPLITS_SUCCESS = 'FETCH_TYPED_SPLITS_SUCCESS';
export const FETCH_TYPED_SPLITS_FAIL = 'FETCH_TYPED_SPLITS_FAIL';

export const FETCH_TIMEZONES = 'FETCH_TIMEZONES';
export const FETCH_TIMEZONES_FETCHING = 'FETCH_TIMEZONES_FETCHING';
export const FETCH_TIMEZONES_SUCCESS = 'FETCH_TIMEZONES_SUCCESS';
export const FETCH_TIMEZONES_FAIL = 'FETCH_TIMEZONES_FAIL';

export const FETCH_SUBSCRIBER_EVENT_DETAILS = 'FETCH_SUBSCRIBER_EVENT_DETAILS';
export const FETCH_SUBSCRIBER_EVENT_DETAILS_FETCHING = 'FETCH_SUBSCRIBER_EVENT_DETAILS_FETCHING';
export const FETCH_SUBSCRIBER_EVENT_DETAILS_SUCCESS = 'FETCH_SUBSCRIBER_EVENT_DETAILS_SUCCESS';
export const FETCH_SUBSCRIBER_EVENT_DETAILS_FAIL = 'FETCH_SUBSCRIBER_EVENT_DETAILS_FAIL';
export const FETCH_BENCHMARK_EXERCISES_DATA = 'FETCH_BENCHMARK_EXERCISES_DATA';
export const FETCH_BENCHMARK_EXERCISES_DATA_FETCHING = 'FETCH_BENCHMARK_EXERCISES_DATA_FETCHING';
export const FETCH_BENCHMARK_EXERCISES_DATA_SUCCESS = 'FETCH_BENCHMARK_EXERCISES_DATA_SUCCESS';
export const FETCH_BENCHMARK_EXERCISES_DATA_FAIL = 'FETCH_BENCHMARK_EXERCISES_DATA_FAIL';
export const RESET_SUBSCRIBER_EVENT_DETAILS = 'RESET_SUBSCRIBER_EVENT_DETAILS';

export const FETCH_EXERCISE_TYPES = 'FETCH_EXERCISE_TYPES';
export const FETCH_EXERCISE_TYPES_FETCHING = 'FETCH_EXERCISE_TYPES_FETCHING';
export const FETCH_EXERCISE_TYPES_SUCCESS = 'FETCH_EXERCISE_TYPES_SUCCESS';
export const FETCH_EXERCISE_TYPES_FAIL = 'FETCH_EXERCISE_TYPES_FAIL';

export const FETCH_EXERCISE_EQUIPMENTS = 'FETCH_EXERCISE_EQUIPMENTS';
export const FETCH_EXERCISE_EQUIPMENTS_FETCHING = 'FETCH_EXERCISE_EQUIPMENTS_FETCHING';
export const FETCH_EXERCISE_EQUIPMENTS_SUCCESS = 'FETCH_EXERCISE_EQUIPMENTS_SUCCESS';
export const FETCH_EXERCISE_EQUIPMENTS_FAIL = 'FETCH_EXERCISE_EQUIPMENTS_FAIL';

export const SAVE_BENCHMARK_EXERCISE_DATA = 'SAVE_BENCHMARK_EXERCISE_DATA';
export const SAVE_BENCHMARK_EXERCISE_DATA_START = 'SAVE_BENCHMARK_EXERCISE_DATA_START';
export const SAVE_BENCHMARK_EXERCISE_DATA_SUCCESS = 'SAVE_BENCHMARK_EXERCISE_DATA_SUCCESS';
export const SAVE_BENCHMARK_EXERCISE_DATA_FAIL = 'SAVE_BENCHMARK_EXERCISE_DATA_FAIL';

export const UPDATE_BENCHMARK_EXERCISE_DATA = 'UPDATE_BENCHMARK_EXERCISE_DATA';
export const UPDATE_BENCHMARK_EXERCISE_DATA_START = 'UPDATE_BENCHMARK_EXERCISE_DATA_START';
export const UPDATE_BENCHMARK_EXERCISE_DATA_SUCCESS = 'UPDATE_BENCHMARK_EXERCISE_DATA_SUCCESS';
export const UPDATE_BENCHMARK_EXERCISE_DATA_FAIL = 'UPDATE_BENCHMARK_EXERCISE_DATA_FAIL';

export const DELETE_BENCHMARK_EXERCISE_DATA = 'DELETE_BENCHMARK_EXERCISE_DATA';
export const DELETE_BENCHMARK_EXERCISE_DATA_DELETING = 'DELETE_BENCHMARK_EXERCISE_DATA_DELETING';
export const DELETE_BENCHMARK_EXERCISE_DATA_SUCCESS = 'DELETE_BENCHMARK_EXERCISE_DATA_SUCCESS';
export const DELETE_BENCHMARK_EXERCISE_DATA_FAIL = 'DELETE_BENCHMARK_EXERCISE_DATA_FAIL';

export const FETCH_MUSCLE_MAPPING_MODEL = 'FETCH_MUSCLE_MAPPING_MODEL';
export const FETCH_MUSCLE_MAPPING_MODEL_FETCHING = 'FETCH_MUSCLE_MAPPING_MODEL_FETCHING';
export const FETCH_MUSCLE_MAPPING_MODEL_SUCCESS = 'FETCH_MUSCLE_MAPPING_MODEL_SUCCESS';
export const FETCH_MUSCLE_MAPPING_MODEL_FAIL = 'FETCH_MUSCLE_MAPPING_MODEL_FAIL';

export const RESET_EXPORT_REPORT = 'RESET_EXPORT_REPORT';
export const FETCH_EXPORT_REPORT = 'FETCH_EXPORT_REPORT';
export const FETCH_EXPORT_REPORT_SUCCESS = 'FETCH_EXPORT_REPORT_SUCCESS';
export const FETCH_EXPORT_REPORT_FAIL = 'FETCH_EXPORT_REPORT_FAIL';
export const CREATE_EXPORT_REPORT = 'CREATE_EXPORT_REPORT';
export const CREATE_EXPORT_REPORT_SUCCESS = 'CREATE_EXPORT_REPORT_SUCCESS';
export const CREATE_EXPORT_REPORT_FAIL = 'CREATE_EXPORT_REPORT_FAIL';
export const CHECK_EXPORT_REPORT_STATUS = 'CHECK_EXPORT_REPORT_STATUS';
export const CHECK_EXPORT_REPORT_STATUS_SUCCESS = 'CHECK_EXPORT_REPORT_STATUS_SUCCESS';
export const CHECK_EXPORT_REPORT_STATUS_FAIL = 'CHECK_EXPORT_REPORT_STATUS_FAIL';

export const FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE = 'FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE';
export const FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_START = 'FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_START';
export const FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_SUCCESS = 'FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_SUCCESS';
export const FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_FAIL = 'FETCH_HEALTH_SNAPSHOT_LIST_BY_DATE_RANGE_FAIL';

export const FETCH_HEALTH_SNAPSHOT_LIST = 'FETCH_HEALTH_SNAPSHOT_LIST';
export const FETCH_HEALTH_SNAPSHOT_LIST_START = 'FETCH_HEALTH_SNAPSHOT_LIST_START';
export const FETCH_HEALTH_SNAPSHOT_LIST_SUCCESS = 'FETCH_HEALTH_SNAPSHOT_LIST_SUCCESS';
export const FETCH_HEALTH_SNAPSHOT_LIST_FAIL = 'FETCH_HEALTH_SNAPSHOT_LIST_FAIL';

export const DELETE_HEALTH_SNAPSHOT_LIST_ITEM = 'DELETE_HEALTH_SNAPSHOT_LIST_ITEM';
export const DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START = 'DELETE_HEALTH_SNAPSHOT_LIST_ITEM_START';
export const DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS = 'DELETE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS';
export const DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL = 'DELETE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL';

export const UPDATE_HEALTH_SNAPSHOT_LIST_ITEM = 'UPDATE_HEALTH_SNAPSHOT_LIST_ITEM';
export const UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START = 'UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_START';
export const UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS = 'UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_SUCCESS';
export const UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL = 'UPDATE_HEALTH_SNAPSHOT_LIST_ITEM_FAIL';

export const UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE = 'UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE';
export const UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_START = 'UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_START';
export const UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_SUCCESS = 'UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_SUCCESS';
export const UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_FAIL = 'UPDATE_HEALTH_SNAPSHOT_ITEM_NOTE_FAIL';

export const FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY = 'FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY';
export const FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_START = 'FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_START';
export const FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_SUCCESS = 'FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_SUCCESS';
export const FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_FAIL = 'FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_FAIL';

export const FETCH_HEALTH_SNAPSHOT_SUMMARY = 'FETCH_HEALTH_SNAPSHOT_SUMMARY';
export const FETCH_HEALTH_SNAPSHOT_SUMMARY_START = 'FETCH_HEALTH_SNAPSHOT_SUMMARY_START';
export const FETCH_HEALTH_SNAPSHOT_SUMMARY_SUCCESS = 'FETCH_HEALTH_SNAPSHOT_SUMMARY_SUCCESS';
export const FETCH_HEALTH_SNAPSHOT_SUMMARY_FAIL = 'FETCH_HEALTH_SNAPSHOT_SUMMARY_FAIL';

export const FETCH_HEALTH_SNAPSHOT_EPOCH_DATA = 'FETCH_HEALTH_SNAPSHOT_EPOCH_DATA';
export const FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_START = 'FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_START';
export const FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_SUCCESS = 'FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_SUCCESS';
export const FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_FAIL = 'FETCH_HEALTH_SNAPSHOT_EPOCH_DATA_FAIL';

export const FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES = 'FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES';
export const FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_START = 'FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_START';
export const FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_SUCCESS = 'FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_SUCCESS';
export const FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_FAIL = 'FETCH_HEALTH_SNAPSHOT_RELATIVE_ACTIVITIES_FAIL';

export const CREATE_NEW_DEVICE_MESSAGE = 'CREATE_NEW_DEVICE_MESSAGE';
export const REPORT_EVENT_IMAGE = 'REPORT_EVENT_IMAGE';

export const UPDATE_PERSONAL_RECORD_TYPE_FAIL = 'UPDATE_PERSONAL_RECORD_TYPE_FAIL';
export const UPDATE_PERSONAL_RECORD_TYPE = 'UPDATE_PERSONAL_RECORD_TYPE';
export const DELETE_PERSONAL_RECORD = 'DELETE_PERSONAL_RECORD';
export const DELETE_PERSONAL_RECORD_SUCCESS = 'DELETE_PERSONAL_RECORD_SUCCESS';
export const DELETE_PERSONAL_RECORD_FAIL = 'DELETE_PERSONAL_RECORD_FAIL';
export const DELETE_PERSONAL_RECORD_CANDIDATE = 'DELETE_PERSONAL_RECORD_CANDIDATE';
export const DELETE_PERSONAL_RECORD_CANDIDATE_SUCCESS = 'DELETE_PERSONAL_RECORD_CANDIDATE_SUCCESS';
export const DELETE_PERSONAL_RECORD_CANDIDATE_FAIL = 'DELETE_PERSONAL_RECORD_CANDIDATE_FAIL';
export const ADD_PERSONAL_RECORD = 'ADD_PERSONAL_RECORD';
export const ADD_PERSONAL_RECORD_SUCCESS = 'ADD_PERSONAL_RECORD_SUCCESS';
export const ADD_PERSONAL_RECORD_FAIL = 'ADD_PERSONAL_RECORD_FAIL';
export const UPDATE_PERSONAL_RECORD = 'UPDATE_PERSONAL_RECORD';
export const UPDATE_PERSONAL_RECORD_SUCCESS = 'UPDATE_PERSONAL_RECORD_SUCCESS';
export const UPDATE_PERSONAL_RECORD_FAIL = 'UPDATE_PERSONAL_RECORD_FAIL';
export const RESET_POWER_GUIDANCE_DELETE_ERROR = 'RESET_POWER_GUIDANCE_DELETE_ERROR';
export const RESET_POWER_GUIDANCE_DUPLICATE_ERROR = 'RESET_POWER_GUIDANCE_DUPLICATE_ERROR';

export const FETCH_LATEST_POWER_TO_WEIGHT = 'FETCH_LATEST_POWER_TO_WEIGHT';
export const FETCH_LATEST_POWER_TO_WEIGHT_FETCHING = 'FETCH_LATEST_POWER_TO_WEIGHT_FETCHING';
export const FETCH_LATEST_POWER_TO_WEIGHT_SUCCESS = 'FETCH_LATEST_POWER_TO_WEIGHT_SUCCESS';
export const FETCH_LATEST_POWER_TO_WEIGHT_FAIL = 'FETCH_LATEST_POWER_TO_WEIGHT_FAIL';

export const FETCH_POWER_BENCHMARKS = 'FETCH_POWER_BENCHMARKS';
export const FETCH_POWER_BENCHMARKS_SUCCESS = 'FETCH_POWER_BENCHMARKS_SUCCESS';

export const FETCH_FTP = 'FETCH_FTP';
export const FETCH_FTP_FETCHING = 'FETCH_FTP_FETCHING';
export const FETCH_FTP_SUCCESS = 'FETCH_FTP_SUCCESS';
export const FETCH_FTP_FAIL = 'FETCH_FTP_FAIL';

export const FETCH_POWER_TO_WEIGHT = 'FETCH_POWER_TO_WEIGHT';
export const FETCH_POWER_TO_WEIGHT_FETCHING = 'FETCH_POWER_TO_WEIGHT_FETCHING';
export const FETCH_POWER_TO_WEIGHT_SUCCESS = 'FETCH_POWER_TO_WEIGHT_SUCCESS';
export const FETCH_POWER_TO_WEIGHT_FAIL = 'FETCH_POWER_TO_WEIGHT_FAIL';

export const TOGGLE_SPORT = 'TOGGLE_SPORT';
export const SWITCH_POWER_TO_WEIGHT_FILTER = 'SWITCH_POWER_TO_WEIGHT_FILTER';

// news feed - activities
export const FETCH_NEWS_FEED_ACTIVITIES = 'FETCH_NEWS_FEED_ACTIVITIES';
export const FETCH_NEWS_FEED_ACTIVITIES_START = 'FETCH_NEWS_FEED_ACTIVITIES_START';
export const FETCH_NEWS_FEED_ACTIVITIES_SUCCESS = 'FETCH_NEWS_FEED_ACTIVITIES_SUCCESS';
export const FETCH_NEWS_FEED_ACTIVITIES_FAIL = 'FETCH_NEWS_FEED_ACTIVITIES_FAIL';
export const UPDATE_NEWS_FEED_ACTIVITY_COMMENT_COUNT = 'UPDATE_NEWS_FEED_ACTIVITY_COMMENT_COUNT';
export const UPDATE_NEWS_FEED_ACTIVITY_PRIVACY = 'UPDATE_NEWS_FEED_ACTIVITY_PRIVACY';
export const UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_START = 'UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_START';
export const UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_SUCCESS = 'UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_SUCCESS';
export const UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_FAIL = 'UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_FAIL';
export const UPDATE_NEWS_FEED_ERROR_STATE = 'UPDATE_NEWS_FEED_ERROR_STATE';
export const FILTER_NEWS_FEED_ACTIVITIES = 'FILTER_NEWS_FEED_ACTIVITIES';
export const FETCH_NEWS_FEED_ACTIVITY_AND_UPDATE_LIKES = 'FETCH_NEWS_FEED_ACTIVITY_AND_UPDATE_LIKES';
export const UPDATE_NEWS_FEED_ACTIVITY_LIKES = 'UPDATE_NEWS_FEED_ACTIVITY_LIKES';

// news feed - comments
export const FETCH_NEWS_FEED_COMMENTS = 'FETCH_NEWS_FEED_COMMENTS';
export const FETCH_NEWS_FEED_COMMENTS_START = 'FETCH_NEWS_FEED_COMMENTS_START';
export const FETCH_NEWS_FEED_COMMENTS_SUCCESS = 'FETCH_NEWS_FEED_COMMENTS_SUCCESS';
export const FETCH_NEWS_FEED_COMMENTS_FAIL = 'FETCH_NEWS_FEED_COMMENTS_FAIL';
export const ADD_NEWS_FEED_COMMENT = 'ADD_NEWS_FEED_COMMENT';
export const ADD_NEWS_FEED_COMMENT_START = 'ADD_NEWS_FEED_COMMENT_START';
export const ADD_NEWS_FEED_COMMENT_SUCCESS = 'ADD_NEWS_FEED_COMMENT_SUCCESS';
export const ADD_NEWS_FEED_COMMENT_FAIL = 'ADD_NEWS_FEED_COMMENT_FAIL';
export const EDIT_NEWS_FEED_COMMENT = 'EDIT_NEWS_FEED_COMMENT';
export const EDIT_NEWS_FEED_COMMENT_START = 'EDIT_NEWS_FEED_COMMENT_START';
export const EDIT_NEWS_FEED_COMMENT_SUCCESS = 'EDIT_NEWS_FEED_COMMENT_SUCCESS';
export const EDIT_NEWS_FEED_COMMENT_FAIL = 'EDIT_NEWS_FEED_COMMENT_FAIL';
export const ADD_NEWS_FEED_HIGHLIGHTED_COMMENTS = 'ADD_NEWS_FEED_HIGHLIGHTED_COMMENTS';
export const REMOVE_NEWS_FEED_COMMENT = 'REMOVE_NEWS_FEED_COMMENT';
export const REMOVE_NEWS_FEED_COMMENT_START = 'REMOVE_NEWS_FEED_COMMENT_START';
export const REMOVE_NEWS_FEED_COMMENT_SUCCESS = 'REMOVE_NEWS_FEED_COMMENT_SUCCESS';
export const REMOVE_NEWS_FEED_COMMENT_FAIL = 'REMOVE_NEWS_FEED_COMMENT_FAIL';
export const UPDATE_NEWS_FEED_COMMENT_LIKED_BY_USER = 'UPDATE_NEWS_FEED_COMMENT_LIKED_BY_USER';
export const FETCH_NEWS_FEED_COMMENT_LIKERS = 'FETCH_NEWS_FEED_COMMENT_LIKERS';
export const FETCH_NEWS_FEED_COMMENT_LIKERS_SUCCESS = 'FETCH_NEWS_FEED_COMMENT_LIKERS_SUCCESS';
export const FETCH_NEWS_FEED_COMMENT_LIKERS_FAIL = 'FETCH_NEWS_FEED_COMMENT_LIKERS_FAIL';
export const UPDATE_NEWS_FEED_COMMENT_LIKERS = 'UPDATE_NEWS_FEED_COMMENT_LIKERS';

// news feed - comment likes
export const FETCH_NEWS_FEED_COMMENT_LIKES = 'FETCH_NEWS_FEED_COMMENT_LIKES';
export const FETCH_NEWS_FEED_COMMENT_LIKES_START = 'FETCH_NEWS_FEED_COMMENT_LIKES_START';
export const FETCH_NEWS_FEED_COMMENT_LIKES_SUCCESS = 'FETCH_NEWS_FEED_COMMENT_LIKES_SUCCESS';
export const FETCH_NEWS_FEED_COMMENT_LIKES_FAIL = 'FETCH_NEWS_FEED_COMMENT_LIKES_FAIL';
export const ADD_NEWS_FEED_COMMENT_LIKE = 'ADD_NEWS_FEED_COMMENT_LIKE';
export const ADD_NEWS_FEED_COMMENT_LIKE_START = 'ADD_NEWS_FEED_COMMENT_LIKE_START';
export const ADD_NEWS_FEED_COMMENT_LIKE_SUCCESS = 'ADD_NEWS_FEED_COMMENT_LIKE_SUCCESS';
export const ADD_NEWS_FEED_COMMENT_LIKE_FAIL = 'ADD_NEWS_FEED_COMMENT_LIKE_FAIL';
export const REMOVE_NEWS_FEED_COMMENT_LIKE = 'REMOVE_NEWS_FEED_COMMENT_LIKE';
export const REMOVE_NEWS_FEED_COMMENT_LIKE_START = 'REMOVE_NEWS_FEED_COMMENT_LIKE_START';
export const REMOVE_NEWS_FEED_COMMENT_LIKE_SUCCESS = 'REMOVE_NEWS_FEED_COMMENT_LIKE_SUCCESS';
export const REMOVE_NEWS_FEED_COMMENT_LIKE_FAIL = 'REMOVE_NEWS_FEED_COMMENT_LIKE_FAIL';
export const ADD_NEWS_FEED_CONVERSATION_LIKE = 'ADD_NEWS_FEED_CONVERSATION_LIKE';
export const ADD_NEWS_FEED_CONVERSATION_LIKE_START = 'ADD_NEWS_FEED_CONVERSATION_LIKE_START';
export const ADD_NEWS_FEED_CONVERSATION_LIKE_SUCCESS = 'ADD_NEWS_FEED_CONVERSATION_LIKE_SUCCESS';
export const ADD_NEWS_FEED_CONVERSATION_LIKE_FAIL = 'ADD_NEWS_FEED_CONVERSATION_LIKE_FAIL';
export const REMOVE_NEWS_FEED_CONVERSATION_LIKE = 'REMOVE_NEWS_FEED_CONVERSATION_LIKE';
export const REMOVE_NEWS_FEED_CONVERSATION_LIKE_START = 'REMOVE_NEWS_FEED_CONVERSATION_LIKE_START';
export const REMOVE_NEWS_FEED_CONVERSATION_LIKE_SUCCESS = 'REMOVE_NEWS_FEED_CONVERSATION_LIKE_SUCCESS';
export const REMOVE_NEWS_FEED_CONVERSATION_LIKE_FAIL = 'REMOVE_NEWS_FEED_CONVERSATION_LIKE_FAIL';

// news feed - conversation likes
export const FETCH_NEWS_FEED_CONVERSATION_LIKES = 'FETCH_NEWS_FEED_CONVERSATION_LIKES';
export const FETCH_NEWS_FEED_CONVERSATION_LIKES_START = 'FETCH_NEWS_FEED_CONVERSATION_LIKES_START';
export const FETCH_NEWS_FEED_CONVERSATION_LIKES_SUCCESS = 'FETCH_NEWS_FEED_CONVERSATION_LIKES_SUCCESS';
export const FETCH_NEWS_FEED_CONVERSATION_LIKES_FAIL = 'FETCH_NEWS_FEED_CONVERSATION_LIKES_FAIL';
export const UPDATE_NEWS_FEED_CONVERSATION_LIKES_PROFILE_IMAGE = 'UPDATE_NEWS_FEED_CONVERSATION_LIKES_PROFILE_IMAGE';

// news feed - leaderboard
export const FETCH_CONNECTIONS_LEADERBOARD = 'FETCH_CONNECTIONS_LEADERBOARD';
export const FETCH_CONNECTIONS_LEADERBOARD_START = 'FETCH_CONNECTIONS_LEADERBOARD_START';
export const FETCH_CONNECTIONS_LEADERBOARD_SUCCESS = 'FETCH_CONNECTIONS_LEADERBOARD_SUCCESS';
export const FETCH_CONNECTIONS_LEADERBOARD_FAIL = 'FETCH_CONNECTIONS_LEADERBOARD_FAIL';
export const REFETCH_CONNECTIONS_LEADERBOARD = 'REFETCH_CONNECTIONS_LEADERBOARD';

// news feed - remove connections
export const REMOVE_CONNECTION = 'REMOVE_CONNECTION';
export const REMOVE_CONNECTION_START = 'REMOVE_CONNECTION_START';
export const REMOVE_CONNECTION_SUCCESS = 'REMOVE_CONNECTION_SUCCESS';
export const REMOVE_CONNECTION_FAIL = 'REMOVE_CONNECTION_FAIL';

// news feed - mute/unmute connections
export const MUTE_CONNECTION = 'MUTE_CONNECTION';
export const MUTE_CONNECTION_START = 'MUTE_CONNECTION_START';
export const MUTE_CONNECTION_SUCCESS = 'MUTE_CONNECTION_SUCCESS';
export const MUTE_CONNECTION_FAIL = 'MUTE_CONNECTION_FAIL';
export const UNMUTE_CONNECTION = 'UNMUTE_CONNECTION';
export const UNMUTE_CONNECTION_START = 'UNMUTE_CONNECTION_START';
export const UNMUTE_CONNECTION_SUCCESS = 'UNMUTE_CONNECTION_SUCCESS';
export const UNMUTE_CONNECTION_FAIL = 'UNMUTE_CONNECTION_FAIL';
export const FETCH_MUTED_CONNECTION_LIST = 'FETCH_MUTED_CONNECTION_LIST';
export const FETCH_MUTED_CONNECTION_LIST_START = 'FETCH_MUTED_CONNECTION_LIST_START';
export const FETCH_MUTED_CONNECTION_LIST_SUCCESS = 'FETCH_MUTED_CONNECTION_LIST_SUCCESS';
export const FETCH_MUTED_CONNECTION_LIST_FAIL = 'FETCH_MUTED_CONNECTION_LIST_FAIL';

// news feed - connection count
export const FETCH_CONNECTION_COUNT = 'FETCH_CONNECTION_COUNT';
export const FETCH_CONNECTION_COUNT_SUCCESS = 'FETCH_CONNECTION_COUNT_SUCCESS';
export const FETCH_CONNECTION_COUNT_FAIL = 'FETCH_CONNECTION_COUNT_FAIL';

// news feed - suggested connections
export const FETCH_SUGGESTED_CONNECTION_LIST = 'FETCH_SUGGESTED_CONNECTION_LIST';
export const FETCH_SUGGESTED_CONNECTION_LIST_START = 'FETCH_SUGGESTED_CONNECTION_LIST_START';
export const FETCH_SUGGESTED_CONNECTION_LIST_SUCCESS = 'FETCH_SUGGESTED_CONNECTION_LIST_SUCCESS';
export const FETCH_SUGGESTED_CONNECTION_LIST_FAIL = 'FETCH_SUGGESTED_CONNECTION_LIST_FAIL';
export const FETCH_PAGED_SUGGESTED_CONNECTION_LIST = 'FETCH_PAGED_SUGGESTED_CONNECTION_LIST';
export const FETCH_PAGED_SUGGESTED_CONNECTION_LIST_START = 'FETCH_PAGED_SUGGESTED_CONNECTION_LIST_START';
export const FETCH_PAGED_SUGGESTED_CONNECTION_LIST_SUCCESS = 'FETCH_PAGED_SUGGESTED_CONNECTION_LIST_SUCCESS';
export const FETCH_PAGED_SUGGESTED_CONNECTION_LIST_FAIL = 'FETCH_PAGED_SUGGESTED_CONNECTION_LIST_FAIL';
export const UPDATE_PAGED_SUGGESTED_CONNECTION_DISMISSING = 'UPDATE_PAGED_SUGGESTED_CONNECTION_DISMISSING';
export const REMOVE_PAGED_SUGGESTED_CONNECTION = 'REMOVE_PAGED_SUGGESTED_CONNECTION';
export const CLEAR_PAGED_SUGGESTED_CONNECTION_LIST = 'CLEAR_PAGED_SUGGESTED_CONNECTION_LIST';
export const FETCH_SUGGESTED_CONNECTIONS_COUNT = 'FETCH_SUGGESTED_CONNECTIONS_COUNT';
export const FETCH_SUGGESTED_CONNECTIONS_COUNT_SUCCESS = 'FETCH_SUGGESTED_CONNECTIONS_COUNT_SUCCESS';
export const FETCH_SUGGESTED_CONNECTIONS_COUNT_FAIL = 'FETCH_SUGGESTED_CONNECTIONS_COUNT_FAIL';

// news feed - reporter
export const NEWS_FEED_OPEN_REPORT_PHOTO_DIALOG = 'NEWS_FEED_OPEN_REPORT_PHOTO_DIALOG';
export const NEWS_FEED_CLOSE_REPORT_PHOTO_DIALOG = 'NEWS_FEED_CLOSE_REPORT_PHOTO_DIALOG';
export const NEWS_FEED_SUMBIT_REPORT_PHOTO = 'NEWS_FEED_SUMBIT_REPORT_PHOTO';
export const NEWS_FEED_SUMBIT_REPORT_PHOTO_DONE = 'NEWS_FEED_SUMBIT_REPORT_PHOTO_DONE';
export const NEWS_FEED_REMOVE_IMAGE_FROM_FEED = 'NEWS_FEED_REMOVE_IMAGE_FROM_FEED';

// news feed - reset
export const RESET_NEWS_FEED_ACTIVITIES = 'RESET_NEWS_FEED_ACTIVITIES';
export const RESET_NEWS_FEED_COMMENTS = 'RESET_NEWS_FEED_COMMENTS';
export const RESET_NEWS_FEED_LIKES = 'RESET_NEWS_FEED_LIKES';
export const RESET_NEWS_FEED_CONNECTIONS = 'RESET_NEWS_FEED_CONNECTIONS';

export const FETCH_HRV_STATUS_DAILY_SUMMARY = 'FETCH_HRV_STATUS_DAILY_SUMMARY';
export const FETCH_HRV_STATUS_DAILY_SUMMARY_START = 'FETCH_HRV_STATUS_DAILY_SUMMARY_START';
export const FETCH_HRV_STATUS_DAILY_SUMMARY_SUCCESS = 'FETCH_HRV_STATUS_DAILY_SUMMARY_SUCCESS';
export const FETCH_HRV_STATUS_DAILY_SUMMARY_FAIL = 'FETCH_HRV_STATUS_DAILY_SUMMARY_FAIL';
export const FETCH_HRV_STATUS_DAILY = 'FETCH_HRV_STATUS_DAILY';
export const FETCH_HRV_STATUS_DAILY_START = 'FETCH_HRV_STATUS_DAILY_START';
export const FETCH_HRV_STATUS_DAILY_SUCCESS = 'FETCH_HRV_STATUS_DAILY_SUCCESS';
export const FETCH_HRV_STATUS_DAILY_FAIL = 'FETCH_HRV_STATUS_DAILY_FAIL';

// notification
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const DISMISS_NOTIFICATION_START = 'DISMISS_NOTIFICATION_START';
export const DISMISS_NOTIFICATION_SUCCESS = 'DISMISS_NOTIFICATION_SUCCESS';
export const DISMISS_NOTIFICATION_FAIL = 'DISMISS_NOTIFICATION_FAIL';

// multisport edit: sagas
export const FETCH_ACTIVITY_DATA = 'FETCH_ACTIVITY_DATA';
export const FETCH_ACTIVITY_DATA_USING_V1_ENDPOINT = 'FETCH_ACTIVITY_DATA_USING_V1_ENDPOINT';
export const FETCH_SINGLE_SPORT_ACTIVITY = 'FETCH_SINGLE_SPORT_ACTIVITY';
export const PUT_RECONSTRUCTED_ACTIVITY_DATA = 'PUT_RECONSTRUCTED_ACTIVITY_DATA';
export const SET_ACTIVE_LEG = 'SET_ACTIVE_LEG';
export const DELETE_LEG_SAGA = 'DELETE_LEG_SAGA';

// multisport edit: store action handlers
export const PUT_RECONSTRUCTED_ACTIVITY_DATA_START = 'PUT_RECONSTRUCTED_ACTIVITY_DATA_START';
export const PUT_RECONSTRUCTED_ACTIVITY_DATA_SUCCESS = 'PUT_RECONSTRUCTED_ACTIVITY_DATA_SUCCESS';
export const PUT_RECONSTRUCTED_ACTIVITY_DATA_FAIL = 'PUT_RECONSTRUCTED_ACTIVITY_DATA_FAIL';
export const FETCH_ACTIVITY_DATA_START = 'FETCH_ACTIVITY_DATA_START';
export const FETCH_ACTIVITY_DATA_SUCCESS = 'FETCH_ACTIVITY_DATA_SUCCESS';
export const FETCH_ACTIVITY_DATA_SUCCESS_V1 = 'FETCH_ACTIVITY_DATA_SUCCESS_V1';
export const FETCH_ACTIVITY_DATA_FAIL = 'FETCH_ACTIVITY_DATA_FAIL';
export const FETCH_CHILD_ACTIVITY_DATA_START = 'FETCH_CHILD_ACTIVITY_DATA_START';
export const FETCH_CHILD_ACTIVITY_DATA_SUCCESS = 'FETCH_CHILD_ACTIVITY_DATA_SUCCESS';
export const FETCH_CHILD_ACTIVITY_DATA_FAIL = 'FETCH_CHILD_ACTIVITY_DATA_FAIL';
export const FETCH_ACTIVITY_METRICS_DATA = 'FETCH_ACTIVITY_METRICS_DATA';
export const FETCH_ALL_CHILDS_METRICS_DATA_START = 'FETCH_ALL_CHILDS_METRICS_DATA_START';
export const FETCH_ALL_CHILDS_METRICS_DATA_SUCCESS = 'FETCH_ALL_CHILDS_METRICS_DATA_SUCCESS';
export const FETCH_ALL_CHILDS_METRICS_DATA_FAIL = 'FETCH_ALL_CHILDS_METRICS_DATA_FAIL';

export const TOGGLE_SELECT_LEG_MODAL = 'TOGGLE_SELECT_LEG_MODAL';
export const CLEAR_STATE = 'CLEAR_STATE';

export const SET_CURRENT_LEG_INDEX = 'SET_CURRENT_LEG_INDEX';
export const SET_START_TO_TIMESTAMP = 'SET_START_TO_TIMESTAMP';
export const INSERT_LEG = 'INSERT_LEG';
export const DELETE_LEG = 'DELETE_LEG';
export const MAKE_LEGS_SNAPSHOT = 'MAKE_LEGS_SNAPSHOT';
export const RESTORE_LEGS_SNAPSHOT = 'RESTORE_LEGS_SNAPSHOT';
export const ERASE_LEGS_SNAPSHOT = 'ERASE_LEGS_SNAPSHOT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SET_TRIM_START = 'SET_TRIM_START';
export const SET_TRIM_END = 'SET_TRIM_END';
export const MAKE_TRIM_SNAPSHOT = 'MAKE_TRIM_SNAPSHOT';
export const RESTORE_TRIM_SNAPSHOT = 'RESTORE_TRIM_SNAPSHOT';
export const RESET_TRIM = 'RESET_TRIM';
export const UPDATE_ACTIVITY_TYPE = 'UPDATE_ACTIVITY_TYPE';

// ECG Recordings
export const FETCH_ECG_RECORDING_LIST = 'FETCH_ECG_RECORDING_LIST';
export const FETCH_ECG_RECORDING_LIST_START = 'FETCH_ECG_RECORDING_LIST_START';
export const FETCH_ECG_RECORDING_LIST_SUCCESS = 'FETCH_ECG_RECORDING_LIST_SUCCESS';
export const FETCH_ECG_RECORDING_LIST_FAIL = 'FETCH_ECG_RECORDING_LIST_FAIL';
export const FETCH_MORE_ECG_RECORDING_LIST = 'FETCH_MORE_ECG_RECORDING_LIST';
export const FETCH_MORE_ECG_RECORDING_LIST_SUCCESS = 'FETCH_MORE_ECG_RECORDING_LIST_SUCCESS';

export const FETCH_ECG_RECORDING_DETAILS = 'FETCH_ECG_RECORDING_DETAILS';
export const FETCH_ECG_RECORDING_DETAILS_START = 'FETCH_ECG_RECORDING_DETAILS_START';
export const FETCH_ECG_RECORDING_DETAILS_SUCCESS = 'FETCH_ECG_RECORDING_DETAILS_SUCCESS';
export const FETCH_ECG_RECORDING_DETAILS_FAIL = 'FETCH_ECG_RECORDING_DETAILS_FAIL';

export const FETCH_ECG_RELATIVE_RECORDINGS = 'FETCH_ECG_RELATIVE_RECORDINGS';
export const FETCH_ECG_RELATIVE_RECORDINGS_START = 'FETCH_ECG_RELATIVE_RECORDINGS_START';
export const FETCH_ECG_RELATIVE_RECORDINGS_SUCCESS = 'FETCH_ECG_RELATIVE_RECORDINGS_SUCCESS';
export const FETCH_ECG_RELATIVE_RECORDINGS_FAIL = 'FETCH_ECG_RELATIVE_RECORDINGS_FAIL';

export const DELETE_ECG_RECORDING = 'DELETE_ECG_RECORDING';
export const DELETE_ECG_RECORDING_START = 'DELETE_ECG_RECORDING_START';
export const DELETE_ECG_RECORDING_SUCCESS = 'DELETE_ECG_RECORDING_SUCCESS';
export const DELETE_ECG_RECORDING_FAIL = 'DELETE_ECG_RECORDING_FAIL';

export const FETCH_ECG_RECORDINGS_FOR_CALENDAR = 'FETCH_ECG_RECORDINGS_FOR_CALENDAR';
export const FETCH_ECG_RECORDINGS_FOR_CALENDAR_START = 'FETCH_ECG_RECORDINGS_FOR_CALENDAR_START';
export const FETCH_ECG_RECORDINGS_FOR_CALENDAR_SUCCESS = 'FETCH_ECG_RECORDINGS_FOR_CALENDAR_SUCCESS';
export const FETCH_ECG_RECORDINGS_FOR_CALENDAR_FAIL = 'FETCH_ECG_RECORDINGS_FOR_CALENDAR_FAIL';

export const FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY = 'FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY';
export const FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_START = 'FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_START';
export const FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_SUCCESS = 'FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_SUCCESS';
export const FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_FAIL = 'FETCH_ECG_RECORDINGS_FOR_DAILY_SUMMARY_FAIL';

export const UPDATE_ECG_LIST_FILTERS = 'UPDATE_ECG_LIST_FILTERS';
export const RESET_ECG_LIST_FILTERS = 'RESET_ECG_LIST_FILTERS';

export const FETCH_ECG_VIDEO_TUTORIAL = 'FETCH_ECG_VIDEO_TUTORIAL';
export const FETCH_ECG_VIDEO_TUTORIAL_START = 'FETCH_ECG_VIDEO_TUTORIAL_START';
export const FETCH_ECG_VIDEO_TUTORIAL_SUCCESS = 'FETCH_ECG_VIDEO_TUTORIAL_SUCCESS';
export const FETCH_ECG_VIDEO_TUTORIAL_FAIL = 'FETCH_ECG_VIDEO_TUTORIAL_FAIL';

// blockUser
export const FETCH_BLOCKED_USER_LIST = 'FETCH_BLOCKED_USER_LIST';
export const FETCH_BLOCKED_USER_LIST_START = 'FETCH_BLOCKED_USER_LIST_START';
export const FETCH_BLOCKED_USER_LIST_SUCCESS = 'FETCH_BLOCKED_USER_LIST_SUCCESS';
export const FETCH_BLOCKED_USER_LIST_FAIL = 'FETCH_BLOCKED_USER_LIST_FAIL';
export const UNBLOCK_USER = 'UNBLOCK_USER';
export const UNBLOCK_USER_START = 'UNBLOCK_USER_START';
export const UNBLOCK_USER_SUCCESS = 'UNBLOCK_USER_SUCCESS';
export const UNBLOCK_USER_FAIL = 'UNBLOCK_USER_FAIL';

// floors report 4 weeks
export const FETCH_FLOORS_REPORT_CHART_DATA = 'FETCH_FLOORS_REPORT_CHART_DATA';
export const FETCH_FLOORS_REPORT_CHART_DATA_FETCHING = 'FETCH_FLOORS_REPORT_CHART_DATA_FETCHING';
export const FETCH_FLOORS_REPORT_CHART_DATA_FAIL = 'FETCH_FLOORS_REPORT_CHART_DATA_FAIL';
export const FETCH_FLOORS_REPORT_CHART_DATA_SUCCESS = 'FETCH_FLOORS_REPORT_CHART_DATA_SUCCESS';
// training readiness
export const FETCH_TRAINING_READINESS = 'FETCH_TRAINING_READINESS';
export const FETCH_TRAINING_READINESS_START = 'FETCH_TRAINING_READINESS_START';
export const FETCH_TRAINING_READINESS_SUCCESS = 'FETCH_TRAINING_READINESS_SUCCESS';
export const FETCH_TRAINING_READINESS_FAIL = 'FETCH_TRAINING_READINESS_FAIL';

// vo2Max metrics and ranges
export const FETCH_VO2MAX_METRICS = 'FETCH_VO2MAX_METRICS';
export const FETCH_VO2MAX_METRICS_START = 'FETCH_VO2MAX_METRICS_START';
export const FETCH_VO2MAX_METRICS_SUCCESS = 'FETCH_VO2MAX_METRICS_SUCCESS';
export const FETCH_VO2MAX_METRICS_FAIL = 'FETCH_VO2MAX_METRICS_FAIL';
export const FETCH_VO2MAX_RANGES = 'FETCH_VO2MAX_RANGES';
export const FETCH_VO2MAX_RANGES_START = 'FETCH_VO2MAX_RANGES_START';
export const FETCH_VO2MAX_RANGES_SUCCESS = 'FETCH_VO2MAX_RANGES_SUCCESS';
export const FETCH_VO2MAX_RANGES_FAIL = 'FETCH_VO2MAX_RANGES_FAIL';

// Events
export const REQUEST_PRIMARY_EVENT_METADATA = 'REQUEST_PRIMARY_EVENT_METADATA';
export const RECEIVE_PRIMARY_EVENT_METADATA = 'RECEIVE_PRIMARY_EVENT_METADATA';
export const RECEIVE_CALENDAR_UPCOMING_EVENTS = 'RECEIVE_CALENDAR_UPCOMING_EVENTS';
export const REQUEST_CALENDAR_UPCOMING_EVENTS = 'REQUEST_CALENDAR_UPCOMING_EVENTS';
export const UPDATE_CALENDAR_EVENT_CUSTOMIZATION = 'UPDATE_CALENDAR_EVENT_CUSTOMIZATION';

export const REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID = 'REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID';
export const REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID_SUCCESS =
    'REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID_SUCCESS';
export const REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID_ERROR =
    'REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID_ERROR';

export const SET_EVENT_FOR_POWER_GUIDE = 'SET_EVENT_FOR_POWER_GUIDE';
export const SET_POWER_GUIDE_FROM_EVENT = 'SET_POWER_GUIDE_FROM_EVENT';
export const SET_POWER_GUIDE_FROM_CREATE = 'SET_POWER_GUIDE_FROM_CREATE';

// Mutual Connections Modal
export const SHOW_MUTUAL_CONNECTIONS_MODAL = 'SHOW_MUTUAL_CONNECTIONS_MODAL';

// floors report one year
export const FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA = 'FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA';
export const FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FETCHING = 'FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FETCHING';
export const FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FAIL = 'FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_FAIL';
export const FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_SUCCESS = 'FETCH_FLOORS_REPORT_ONE_YEAR_CHART_DATA_SUCCESS';

// Connections
export const FETCH_CONNECTIONS = 'FETCH_CONNECTIONS';
export const FETCH_CONNECTIONS_START = 'FETCH_CONNECTIONS_START';
export const FETCH_CONNECTIONS_SUCCESS = 'FETCH_CONNECTIONS_SUCCESS';
export const FETCH_CONNECTIONS_FAIL = 'FETCH_CONNECTIONS_FAIL';
export const RESET_CONNECTIONS = 'RESET_CONNECTIONS';
// Connections - Pending Connections
export const FETCH_PENDING_CONNECTIONS = 'FETCH_PENDING_CONNECTIONS';
export const FETCH_PENDING_CONNECTIONS_START = 'FETCH_PENDING_CONNECTIONS_START';
export const FETCH_PENDING_CONNECTIONS_SUCCESS = 'FETCH_PENDING_CONNECTIONS_SUCCESS';
export const FETCH_PENDING_CONNECTIONS_FAIL = 'FETCH_PENDING_CONNECTIONS_FAIL';
export const UPDATE_PENDING_CONNECTION_DISMISSING_STATUS = 'UPDATE_PENDING_CONNECTION_DISMISSING_STATUS';
export const REMOVE_PENDING_CONNECTION = 'REMOVE_PENDING_CONNECTION';

// heart rate report daily format
export const FETCH_HEART_RATE_REPORT_DAILY = 'FETCH_HEART_RATE_REPORT_DAILY';
export const FETCH_HEART_RATE_REPORT_DAILY_FETCHING = 'FETCH_HEART_RATE_REPORT_DAILY_FETCHING';
export const FETCH_HEART_RATE_REPORT_DAILY_SUCCESS = 'FETCH_HEART_RATE_REPORT_DAILY_SUCCESS';
export const FETCH_HEART_RATE_REPORT_DAILY_ERROR = 'FETCH_HEART_RATE_REPORT_DAILY_ERROR';

// heart rate report year format
export const FETCH_HEART_RATE_REPORT_ONE_YEAR = 'FETCH_HEART_RATE_REPORT_ONE_YEAR';
export const FETCH_HEART_RATE_REPORT_ONE_YEAR_SUCCESS = 'FETCH_HEART_RATE_REPORT_ONE_YEAR_SUCCESS';
export const FETCH_HEART_RATE_REPORT_ONE_YEAR_ERROR = 'FETCH_HEART_RATE_REPORT_ONE_YEAR_ERROR';
export const FETCH_HEART_RATE_REPORT_ONE_YEAR_FETCHING = 'FETCH_HEART_RATE_REPORT_ONE_YEAR_FETCHING';

export const DELETE_ABNORMAL_HEART_RATE = 'DELETE_ABNORMAL_HEART_RATE';
export const DELETE_ABNORMAL_HEART_RATE_START = 'DELETE_ABNORMAL_HEART_RATE_START';
export const DELETE_ABNORMAL_HEART_RATE_SUCCESS = 'DELETE_ABNORMAL_HEART_RATE_SUCCESS';
export const DELETE_ABNORMAL_HEART_RATE_FAIL = 'DELETE_ABNORMAL_HEART_RATE_FAIL';

// Shareable Events
export const FETCH_EVENTS_BY_DATE = 'FETCH_EVENTS_BY_DATE';
export const FETCH_EVENTS_BY_DATE_SUCCESS = 'FETCH_EVENTS_BY_DATE_SUCCESS';
export const FETCH_EVENTS_BY_DATE_ERROR = 'FETCH_EVENTS_BY_DATE_ERROR';
export const FETCH_EVENTS_BY_DATE_FETCHING = 'FETCH_EVENTS_BY_DATE_FETCHING';
export const RESET_FETCH_EVENTS_BY_DATE = 'RESET_FETCH_EVENTS_BY_DATE';
export const ADD_EVENT_TO_DUPLICATE = 'ADD_EVENT_TO_DUPLICATE';
export const REMOVE_EVENT_TO_DUPLICATE = 'REMOVE_EVENT_TO_DUPLICATE';
export const ADD_EVENT_TO_EDIT = 'ADD_EVENT_TO_EDIT';
export const REMOVE_EVENT_TO_EDIT = 'REMOVE_EVENT_TO_EDIT';

// Gears tracking
export const FETCH_GEARS = 'FETCH_GEARS';
export const FETCH_GEARS_SUCCESS = 'FETCH_GEARS_SUCCESS';
export const FETCH_GEARS_FAIL = 'FETCH_GEARS_FAIL';
export const FETCH_GEARS_FECTHING = 'FETCH_GEARS_FECTHING';

// Jet Lag
export const ADD_FLIGHT_TO_JET_LAG_TRIP = 'ADD_FLIGHT_TO_JET_LAG_TRIP';
export const ADD_FLIGHT_TO_JET_LAG_TRIP_SUCCESS = 'ADD_FLIGHT_TO_JET_LAG_TRIP_SUCCESS';
export const ADD_FLIGHT_TO_JET_LAG_TRIP_FAILED = 'ADD_FLIGHT_TO_JET_LAG_TRIP_FAILED';
export const UPDATE_FLIGHT_TO_JET_LAG_TRIP = 'UPDATE_FLIGHT_TO_JET_LAG_TRIP';
export const REMOVE_FLIGHT_FROM_JET_LAG_TRIP = 'REMOVE_FLIGHT_FROM_JET_LAG_TRIP';
export const ADD_DATA_TO_FLIGHT = 'ADD_DATA_TO_FLIGHT';

export const SAVE_JET_LAG_TRIP = 'SAVE_JET_LAG_TRIP';
export const SAVE_JET_LAG_TRIP_START = 'SAVE_JET_LAG_TRIP_START';
export const SAVE_JET_LAG_TRIP_SUCCESS = 'SAVE_JET_LAG_TRIP_SUCCESS';
export const SAVE_JET_LAG_TRIP_FAIL = 'SAVE_JET_LAG_TRIP_FAIL';
export const FETCH_JET_LAG_TRIPS = 'FETCH_JET_LAG_TRIPS';
export const FETCH_JET_LAG_TRIPS_SUCCESS = 'FETCH_JET_LAG_TRIPS_SUCCESS';
export const FETCH_JET_LAG_TRIPS_FAIL = 'FETCH_JET_LAG_TRIPS_FAIL';
export const RESET_JET_LAG_TRIP = 'RESET_JET_LAG_TRIP';
export const FETCH_JET_LAG_TRIPS_FETCHING = 'FETCH_JET_LAG_TRIPS_FETCHING';

export const FETCH_DAILY_JET_LAG_STATUS = 'FETCH_DAILY_JET_LAG_STATUS';
export const FETCH_DAILY_JET_LAG_STATUS_START = 'FETCH_DAILY_JET_LAG_STATUS_START';
export const FETCH_DAILY_JET_LAG_STATUS_SUCCESS = 'FETCH_DAILY_JET_LAG_STATUS_SUCCESS';
export const FETCH_DAILY_JET_LAG_STATUS_FAIL = 'FETCH_DAILY_JET_LAG_STATUS_FAIL';

export const DELETE_JET_LAG_TRIP = 'DELETE_JET_LAG_TRIP';
export const DELETE_JET_LAG_TRIP_START = 'DELETE_JET_LAG_TRIP_START';
export const DELETE_JET_LAG_TRIP_SUCCESS = 'DELETE_JET_LAG_TRIP_SUCCESS';
export const DELETE_JET_LAG_TRIP_FAIL = 'DELETE_JET_LAG_TRIP_FAIL';

export const ADD_FLIGHTS_TO_STATE = 'ADD_FLIGHTS_TO_STATE';
export const UPDATE_JET_LAG_TRIP = 'UPDATE_JET_LAG_TRIP';
export const UPDATE_JET_LAG_TRIP_SUCCESS = 'UPDATE_JET_LAG_TRIP_SUCCESS';
export const UPDATE_JET_LAG_TRIP_FAIL = 'UPDATE_JET_LAG_TRIP_FAIL';

// Challenge Page
export const CHALLENGE_PAGE_INIT = 'CHALLENGE_PAGE_INIT';
export const CHALLENGE_PAGE_RESET = 'CHALLENGE_PAGE_RESET';
export const CHALLENGE_PAGE_SET_ROUTE = 'CHALLENGE_PAGE_SET_ROUTE';
export const CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES = 'CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES';
export const CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES_DONE =
    'CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES_DONE';
export const CHALLENGE_PAGE_UPDATE_AVAILABLE_BADGE_CHALLENGE = 'CHALLENGE_PAGE_UPDATE_AVAILABLE_BADGE_CHALLENGE';
export const CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE = 'CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE';
export const CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE_DONE = 'CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE_DONE';
export const CHALLENGE_PAGE_SET_BADGE_CHALLENGE_NOTIFICATION_STATUS =
    'CHALLENGE_PAGE_SET_BADGE_CHALLENGE_NOTIFICATION_STATUS';
export const CHALLENGE_PAGE_UNDO_JOIN_BADGE_CHALLENGE = 'CHALLENGE_PAGE_UNDO_JOIN_BADGE_CHALLENGE';
export const CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES = 'CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES';
export const CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES_DONE = 'CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES_DONE';
export const CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES = 'CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES';
export const CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES_DONE = 'CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES_DONE';
export const CHALLENGE_PAGE_OPT_OUT_AUTO_CHALLENGE = 'CHALLENGE_PAGE_OPT_OUT_AUTO_CHALLENGE';
export const CHALLENGE_PAGE_FETCH_AUTO_CHALLENGE_DONE = 'CHALLENGE_PAGE_FETCH_AUTO_CHALLENGE_DONE';
export const CHALLENGE_PAGE_SET_OPT_OUT_DIALOG = 'CHALLENGE_PAGE_SET_OPT_OUT_DIALOG';
export const CHALLENGE_PAGE_FETCH_PAST_CHALLENGES = 'CHALLENGE_PAGE_FETCH_PAST_CHALLENGES';
export const CHALLENGE_PAGE_FETCH_PAST_CHALLENGES_DONE = 'CHALLENGE_PAGE_FETCH_PAST_CHALLENGES_DONE';
export const CHALLENGE_PAGE_SET_PRE_JOIN_CONFIRM_DIALOG_STATE = 'CHALLENGE_PAGE_SET_PRE_JOIN_CONFIRM_DIALOG_STATE';
export const CHALLENGE_PAGE_PRE_JOIN_CONFIRM_DIALOG_ACTION = 'CHALLENGE_PAGE_PRE_JOIN_CONFIRM_DIALOG_ACTION';
export const CHALLENGE_PAGE_PREPARE_JOIN_CHALLENGE = 'CHALLENGE_PAGE_PREPARE_JOIN_CHALLENGE';

/** virtual challenge detail page */
export const CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT = 'CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT';
export const CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT_DONE = 'CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT_DONE';
export const CHALLENGE_PAGE_SET_BADGE_DETAIL_DIALOG_OPEN = 'CHALLENGE_PAGE_SHOW_BADGE_DETAIL_DIALOG';
export const CHALLENGE_PAGE_FETCH_BADGE_DETAIL = 'CHALLENGE_PAGE_FETCH_BADGE_DETAIL';
export const CHALLENGE_PAGE_FETCH_BADGE_DETAIL_DONE = 'CHALLENGE_PAGE_FETCH_BADGE_DETAIL_DONE';
export const CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE = 'CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE';
export const CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_DONE = 'CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_DONE';
export const CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_ERROR_ACK = 'CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_ERROR_ACK';
export const CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE = 'CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE';
export const CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE_DONE = 'CHALLENGE_PAGE_OPT_OUT_VIRTUAL_CHALLENGE_DONE';

/** Body Battery 3.0 */
export const FETCH_DAILY_BODY_BATTERY_REPORT = 'FETCH_DAILY_BODY_BATTERY_REPORT';
export const FETCH_BODY_BATTERY_REPORT_FETCHING = 'FETCH_BODY_BATTERY_REPORT_FETCHING';
export const FETCH_BODY_BATTERY_REPORT_SUCCESS = 'FETCH_BODY_BATTERY_REPORT_SUCCESS';
export const FETCH_BODY_BATTERY_REPORT_FAIL = 'FETCH_BODY_BATTERY_REPORT_FAIL';
export const FETCH_BODY_BATTERY_EVENTS = 'FETCH_BODY_BATTERY_EVENTS';
export const FETCH_BODY_BATTERY_EVENTS_FETCHING = 'FETCH_BODY_BATTERY_EVENTS_FETCHING';
export const FETCH_BODY_BATTERY_EVENTS_SUCCESS = 'FETCH_BODY_BATTERY_EVENTS_SUCCESS';
export const FETCH_BODY_BATTERY_EVENTS_FAIL = 'FETCH_BODY_BATTERY_EVENTS_FAIL';

/** inbox requests page */
export const INBOX_PAGE_INIT = 'INBOX_PAGE_INIT';
export const INBOX_PAGE_FETCH_REQUESTS = 'INBOX_PAGE_FETCH_REQUESTS';
export const INBOX_PAGE_FETCH_REQUESTS_DONE = 'INBOX_PAGE_FETCH_REQUESTS_DONE';
export const INBOX_PAGE_SET_CHALLENGE_DIALOG_OPEN = 'INBOX_PAGE_SET_CHALLENGE_DIALOG_OPEN';
export const INBOX_PAGE_CHALLENGE_DIALOG_ACTION = 'INBOX_PAGE_CHALLENGE_DIALOG_ACTION';
export const INBOX_PAGE_CHALLENGE_REQ_ACTION = 'INBOX_PAGE_CHALLENGE_REQ_ACTION';
export const INBOX_PAGE_CONNECTION_REQ_ACTION = 'INBOX_PAGE_CONNECTION_REQ_ACTION';
export const INBOX_PAGE_GROUP_REQ_ACTION = 'INBOX_PAGE_GROUP_REQ_ACTION';
export const INBOX_PAGE_SET_DELETE_GROUP_REQ_DIALOG_OPEN = 'INBOX_PAGE_SET_DELETE_GROUP_REQ_DIALOG_OPEN';
export const INBOX_PAGE_DELETE_GROUP_REQ_DIALOG_ACTION = 'INBOX_PAGE_DELETE_GROUP_REQ_DIALOG_ACTION';
export const INBOX_PAGE_DEVICE_REQ_ACTION = 'INBOX_PAGE_DEVICE_REQ_ACTION';
export const INBOX_PAGE_SET_REQ_STATUS = 'INBOX_PAGE_SET_REQ_STATUS';
export const INBOX_PAGE_SET_MUTUAL_CONNECTION_DIALOG_OPEN = 'INBOX_PAGE_SET_MUTUAL_CONNECTION_DIALOG_OPEN';
export const INBOX_PAGE_SET_JOIN_GROUP_CONSENT_DIALOG_OPEN = 'INBOX_PAGE_SET_JOIN_GROUP_CONSENT_DIALOG_OPEN';
export const INBOX_PAGE_JOIN_GROUP_CONSENT_DIALOG_ACTION = 'INBOX_PAGE_JOIN_GROUP_CONSENT_DIALOG_ACTION';
export const INBOX_PAGE_SET_DATA_PRIVACY_DIALOG_OPEN = 'INBOX_PAGE_SET_DATA_PRIVACY_DIALOG_OPEN';
export const INBOX_PAGE_SET_GROUP_ERROR_DIALOG_OPEN = 'INBOX_PAGE_SET_GROUP_ERROR_DIALOG_OPEN';
export const INBOX_PAGE_DATA_PRIVACY_DIALOG_ACTION = 'INBOX_PAGE_DATA_PRIVACY_DIALOG_ACTION';
export const INBOX_PAGE_RESET = 'INBOX_PAGE_RESET';

/** device migration page */
export const FETCH_ALL_AVAILABLE_DEVICE_BACKUPS = 'GET_ALL_AVAILABLE_DEVICE_BACKUPS';
export const FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_START = 'GET_ALL_AVAILABLE_DEVICE_BACKUPS_START';
export const FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_SUCCESS = 'GET_ALL_AVAILABLE_DEVICE_BACKUPS_SUCCESS';
export const FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_FAIL = 'GET_ALL_AVAILABLE_DEVICE_BACKUPS_FAIL';
export const FETCH_COMPATIBLE_DEVICE_BACKUPS = 'GET_COMPATIBLE_DEVICE_BACKUPS';
export const FETCH_COMPATIBLE_DEVICE_BACKUPS_START = 'GET_COMPATIBLE_DEVICE_BACKUPS_START';
export const FETCH_COMPATIBLE_DEVICE_BACKUPS_SUCCESS = 'GET_COMPATIBLE_DEVICE_BACKUPS_SUCCESS';
export const FETCH_COMPATIBLE_DEVICE_BACKUPS_FAIL = 'GET_COMPATIBLE_DEVICE_BACKUPS_FAIL';
export const RESTORE_DEVICE_BACKUP = 'RESTORE_DEVICE_BACKUP';
export const RESTORE_DEVICE_BACKUP_START = 'RESTORE_DEVICE_BACKUP_START';
export const RESTORE_DEVICE_BACKUP_SUCCESS = 'RESTORE_DEVICE_BACKUP_SUCCESS';
export const RESTORE_DEVICE_BACKUP_FAIL = 'RESTORE_DEVICE_BACKUP_FAIL';
export const REMOVE_DEVICE_BACKUP = 'REMOVE_DEVICE_BACKUP';
export const REMOVE_DEVICE_BACKUP_START = 'REMOVE_DEVICE_BACKUP_START';
export const REMOVE_DEVICE_BACKUP_SUCCESS = 'REMOVE_DEVICE_BACKUP_SUCCESS';
export const REMOVE_DEVICE_BACKUP_FAIL = 'REMOVE_DEVICE_BACKUP_FAIL';
export const SHOULD_LAUNCH_GARMIN_EXPRESS = 'SHOULD_LAUNCH_GARMIN_EXPRESS';
export const RESET_DEVICE_BACKUPS = 'RESET_DEVICE_BACKUPS';
export const RESET_DEVICE_BACKUPS_ERRORS = 'RESET_DEVICE_BACKUPS_ERRORS';
export const FETCH_PRIMARY_TRAINING_DEVICE = 'FETCH_PRIMARY_TRAINING_DEVICE';
export const FETCH_PRIMARY_TRAINING_DEVICE_START = 'FETCH_PRIMARY_TRAINING_DEVICE_START';
export const FETCH_PRIMARY_TRAINING_DEVICE_SUCCESS = 'FETCH_PRIMARY_TRAINING_DEVICE_SUCCESS';
export const FETCH_PRIMARY_TRAINING_DEVICE_FAIL = 'FETCH_PRIMARY_TRAINING_DEVICE_FAIL';

export const FETCH_DEVICE_BACKUPS_SUMMARY = 'FETCH_DEVICE_BACKUPS_SUMMARY';
export const FETCH_DEVICE_BACKUPS_SUMMARY_START = 'FETCH_DEVICE_BACKUPS_SUMMARY_START';
export const FETCH_DEVICE_BACKUPS_SUMMARY_SUCCESS = 'FETCH_DEVICE_BACKUPS_SUMMARY_SUCCESS';
export const FETCH_DEVICE_BACKUPS_SUMMARY_FAIL = 'FETCH_DEVICE_BACKUPS_SUMMARY_FAIL';

export const UPDATE_PRIMARY_TRAINING_DEVICE = 'UPDATE_PRIMARY_TRAINING_DEVICE';
export const UPDATE_PRIMARY_TRAINING_DEVICE_START = 'UPDATE_PRIMARY_TRAINING_DEVICE_START';
export const UPDATE_PRIMARY_TRAINING_DEVICE_SUCCESS = 'UPDATE_PRIMARY_TRAINING_DEVICE_SUCCESS';
export const UPDATE_PRIMARY_TRAINING_DEVICE_FAIL = 'UPDATE_PRIMARY_TRAINING_DEVICE_FAIL';

export const UPDATE_PRIMARY_ACTIVITY_TRACKER = 'UPDATE_PRIMARY_ACTIVITY_TRACKER';
export const UPDATE_PRIMARY_ACTIVITY_TRACKER_START = 'UPDATE_PRIMARY_ACTIVITY_TRACKER_START';
export const UPDATE_PRIMARY_ACTIVITY_TRACKER_SUCCESS = 'UPDATE_PRIMARY_ACTIVITY_TRACKER_SUCCESS';
export const UPDATE_PRIMARY_ACTIVITY_TRACKER_FAIL = 'UPDATE_PRIMARY_ACTIVITY_TRACKER_FAIL';

export const REMOVE_DEVICE = 'REMOVE_DEVICE';
export const REMOVE_DEVICE_START = 'REMOVE_DEVICE_START';
export const REMOVE_DEVICE_SUCCESS = 'REMOVE_DEVICE_SUCCESS';
export const REMOVE_DEVICE_FAIL = 'REMOVE_DEVICE_FAIL';

// daily sleep data - for sleep-service (not wellness-service)
export const FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS = 'FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS';
export const FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FETCHING = 'FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FETCHING';
export const FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_SUCCESS = 'FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_SUCCESS';
export const FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FAIL = 'FETCH_DAILY_SLEEP_DATA_WITH_EPOCHS_FAIL';

export const UPDATE_SLEEP_NOTE = 'UPDATE_SLEEP_NOTE';
export const UPDATE_SLEEP_NOTE_START = 'UPDATE_SLEEP_NOTE_START';
export const UPDATE_SLEEP_NOTE_SUCCESS = 'UPDATE_SLEEP_NOTE_SUCCESS';
export const UPDATE_SLEEP_NOTE_FAIL = 'UPDATE_SLEEP_NOTE_FAIL';

export const ADD_SLEEP = 'ADD_SLEEP';
export const ADD_SLEEP_START = 'ADD_SLEEP_START';
export const ADD_SLEEP_SUCCESS = 'ADD_SLEEP_SUCCESS';
export const ADD_SLEEP_FAIL = 'ADD_SLEEP_FAIL';

export const FETCH_HRV_DAILY = 'FETCH_HRV_DAILY';
export const FETCH_HRV_DAILY_FETCHING = 'FETCH_HRV_DAILY_FETCHING';
export const FETCH_HRV_DAILY_SUCCESS = 'FETCH_HRV_DAILY_SUCCESS';
export const FETCH_HRV_DAILY_FAIL = 'FETCH_HRV_DAILY_FAIL';

export const RESET_DAILY_SLEEP = 'RESET_DAILY_SLEEP';
export const SET_OPEN_TAB_ON_SLEEP_ONE_DAY_VIEW = 'SET_OPEN_TAB_ON_SLEEP_ONE_DAY_VIEW';

export const FETCH_NAP_BY_DATE = 'FETCH_NAP_BY_DATE';
export const FETCH_NAP_BY_DATE_FETCHING = 'FETCH_NAP_BY_DATE_FETCHING';
export const FETCH_NAP_BY_DATE_SUCCESS = 'FETCH_NAP_BY_DATE_SUCCESS';
export const FETCH_NAP_BY_DATE_FAIL = 'FETCH_NAP_BY_DATE_FAIL';

export const FETCH_DAILY_SLEEP_START = 'FETCH_DAILY_SLEEP_START';
export const FETCH_DAILY_SLEEP_SUCCESS = 'FETCH_DAILY_SLEEP_SUCCESS';
export const FETCH_DAILY_SLEEP_FAIL = 'FETCH_DAILY_SLEEP_FAIL';

export const ADD_NAP = 'ADD_NAP';
export const ADD_NAP_SUCCESS = 'ADD_NAP_SUCCESS';
export const ADD_NAP_FAIL = 'ADD_NAP_FAIL';
export const ADD_NAP_START = 'ADD_NAP_START';
export const DELETE_NAP = 'DELETE_NAP';
export const DELETE_NAP_START = 'DELETE_NAP_START';
export const DELETE_NAP_SUCCESS = 'DELETE_NAP_SUCCESS';
export const DELETE_NAP_FAIL = 'DELETE_NAP_FAIL';
export const UPDATE_NAP = 'UPDATE_NAP';

export const UPDATE_SLEEP_WINDOW = 'UPDATE_SLEEP_WINDOW';
export const UPDATE_SLEEP_WINDOW_START = 'UPDATE_SLEEP_WINDOW_START';
export const UPDATE_SLEEP_WINDOW_SUCCESS = 'UPDATE_SLEEP_WINDOW_SUCCESS';
export const UPDATE_SLEEP_WINDOW_FAIL = 'UPDATE_SLEEP_WINDOW_FAIL';

/*Sleep Reports Page*/
export const FETCH_DAILY_SLEEP_REPORT_DATA = 'FETCH_DAILY_SLEEP_REPORT_DATA';
export const FETCH_WEEKLY_SLEEP_REPORT_DATA = 'FETCH_WEEKLY_SLEEP_REPORT_DATA';
export const FETCH_SLEEP_REPORT_DATA_FETCHING = 'FETCH_SLEEP_REPORT_DATA_FETCHING';
export const FETCH_SLEEP_REPORT_DATA_SUCCESS = 'FETCH_SLEEP_REPORT_DATA_SUCCESS';
export const FETCH_SLEEP_REPORT_DATA_FAIL = 'FETCH_SLEEP_REPORT_DATA_FAIL';

export const FETCH_EMAIL_NOTIFICATIONS = 'FETCH_EMAIL_NOTIFICATIONS';
export const FETCH_EMAIL_NOTIFICATIONS_FETCHING = 'FETCH_EMAIL_NOTIFICATIONS_FETCHING';
export const FETCH_EMAIL_NOTIFICATIONS_SUCCESS = 'FETCH_EMAIL_NOTIFICATIONS_SUCCESS';
export const FETCH_EMAIL_NOTIFICATIONS_FAIL = 'FETCH_EMAIL_NOTIFICATIONS_FAIL';
export const UPDATE_EMAIL_NOTIFICATIONS = 'UPDATE_EMAIL_NOTIFICATIONS';
export const UPDATE_EMAIL_NOTIFICATIONS_UPDATING = 'UPDATE_EMAIL_NOTIFICATIONS_UPDATING';
export const UPDATE_EMAIL_NOTIFICATIONS_SUCCESS = 'UPDATE_EMAIL_NOTIFICATIONS_SUCCESS';
export const UPDATE_EMAIL_NOTIFICATIONS_FAIL = 'UPDATE_EMAIL_NOTIFICATIONS_FAIL';

// Garmin Coach enhancements
export const FETCH_PLAN_CONTENT = 'FETCH_PLAN_CONTENT';
export const FETCH_PLAN_CONTENT_SUCCESS = 'FETCH_PLAN_CONTENT_SUCCESS';
export const FETCH_PLAN_CONTENT_ERROR = 'FETCH_PLAN_CONTENT_ERROR';
export const PLAN_SETUP_RESET = 'PLAN_SETUP_RESET';
export const UPDATE_PLAN_SETUP = 'UPDATE_PLAN_SETUP';
export const FETCH_COACH_CAUTION = 'FETCH_COACH_CAUTION';
export const FETCH_COACH_CAUTION_SUCCESS = 'FETCH_COACH_CAUTION_SUCCESS';
export const FETCH_COACH_CAUTION_ERROR = 'FETCH_COACH_CAUTION_ERROR';
export const FETCH_PREPLAN_DISTANCE = 'FETCH_PREPLAN_DISTANCE';
export const FETCH_PREPLAN_DISTANCE_SUCCESS = 'FETCH_PREPLAN_DISTANCE_SUCCESS';
export const FETCH_PREPLAN_DISTANCE_ERROR = 'FETCH_PREPLAN_DISTANCE_ERROR';
export const RESET_PREPLAN_DISTANCE = 'RESET_PREPLAN_DISTANCE';
export const FETCH_PREPLAN_PACE = 'FETCH_PREPLAN_PACE';
export const FETCH_PREPLAN_PACE_SUCCESS = 'FETCH_PREPLAN_PACE_SUCCESS';
export const FETCH_PREPLAN_PACE_ERROR = 'FETCH_PREPLAN_PACE_ERROR';
export const FETCH_PREPLAN_GOALS = 'FETCH_PREPLAN_GOALS';
export const FETCH_PREPLAN_GOALS_SUCCESS = 'FETCH_PREPLAN_GOALS_SUCCESS';
export const FETCH_PREPLAN_GOALS_ERROR = 'FETCH_PREPLAN_GOALS_ERROR';
export const FETCH_PREPLAN_PACE_TIMES = 'FETCH_PREPLAN_PACE_TIMES';
export const FETCH_PREPLAN_PACE_TIMES_SUCCESS = 'FETCH_PREPLAN_PACE_TIMES_SUCCESS';
export const FETCH_PREPLAN_PACE_TIMES_ERROR = 'FETCH_PREPLAN_PACE_TIMES_ERROR';
export const FETCH_PREPLAN_COACHES = 'FETCH_PREPLAN_COACHES';
export const FETCH_PREPLAN_COACHES_SUCCESS = 'FETCH_PREPLAN_COACHES_SUCCESS';
export const FETCH_PREPLAN_COACHES_ERROR = 'FETCH_PREPLAN_COACHES_ERROR';
export const FETCH_PREPLAN_COACH_INFO = 'FETCH_PREPLAN_COACH_INFO';
export const FETCH_PREPLAN_COACH_INFO_SUCCESS = 'FETCH_PREPLAN_COACH_INFO_SUCCESS';
export const FETCH_PREPLAN_COACH_INFO_ERROR = 'FETCH_PREPLAN_COACH_INFO_ERROR';
export const FETCH_COACH_VIDEO = 'FETCH_COACH_VIDEO';
export const FETCH_COACH_VIDEO_SUCCESS = 'FETCH_COACH_VIDEO_SUCCESS';
export const FETCH_COACH_VIDEO_ERROR = 'FETCH_COACH_VIDEO_ERROR';
export const RESET_ATP_PLAN = 'RESET_ATP_PLAN';
export const RESET_PREPLAN_PACE_TIMES = 'RESET_PREPLAN_PACE_TIMES';
export const RESET_PREPLAN_PACE = 'RESET_PREPLAN_PACE';
export const RESET_COACH_VIDEO = 'RESET_COACH_VIDEO';

// lactate threshold actions
export const FETCH_LATEST_LACTATE_THRESHOLD = 'FETCH_LATEST_LACTATE_THRESHOLD';
export const FETCH_LATEST_LACTATE_THRESHOLD_START = 'FETCH_LATEST_LACTATE_THRESHOLD_START';
export const FETCH_LATEST_LACTATE_THRESHOLD_SUCCESS = 'FETCH_LATEST_LACTATE_THRESHOLD_SUCCESS';
export const FETCH_LATEST_LACTATE_THRESHOLD_FAIL = 'FETCH_LATEST_LACTATE_THRESHOLD_FAIL';

export const FETCH_RANGE_LACTATE_THRESHOLD_HR = 'FETCH_RANGE_LACTATE_THRESHOLD_HR';
export const FETCH_RANGE_LACTATE_THRESHOLD_HR_START = 'FETCH_RANGE_LACTATE_THRESHOLD_HR_START';
export const FETCH_RANGE_LACTATE_THRESHOLD_HR_SUCCESS = 'FETCH_RANGE_LACTATE_THRESHOLD_HR_SUCCESS';
export const FETCH_RANGE_LACTATE_THRESHOLD_HR_FAIL = 'FETCH_RANGE_LACTATE_THRESHOLD_HR_FAIL';

export const FETCH_RANGE_LACTATE_THRESHOLD_SPEED = 'FETCH_RANGE_LACTATE_THRESHOLD_SPEED';
export const FETCH_RANGE_LACTATE_THRESHOLD_SPEED_START = 'FETCH_RANGE_LACTATE_THRESHOLD_SPEED_START';
export const FETCH_RANGE_LACTATE_THRESHOLD_SPEED_SUCCESS = 'FETCH_RANGE_LACTATE_THRESHOLD_SPEED_SUCCESS';
export const FETCH_RANGE_LACTATE_THRESHOLD_SPEED_FAIL = 'FETCH_RANGE_LACTATE_THRESHOLD_SPEED_FAIL';
export const FETCH_CURRENT_USER_INFO = 'FETCH_CURRENT_USER_INFO';
export const FETCH_CURRENT_USER_INFO_FETCHING = 'FETCH_CURRENT_USER_INFO_FETCHING';
export const FETCH_CURRENT_USER_INFO_SUCCESS = 'FETCH_CURRENT_USER_INFO_SUCCESS';
export const FETCH_CURRENT_USER_INFO_FAIL = 'FETCH_CURRENT_USER_INFO_FAIL';

export const FETCH_THIRD_PARTY_APPS = 'FETCH_THIRD_PARTY_APPS';
export const FETCH_THIRD_PARTY_APPS_FETCHING = 'FETCH_THIRD_PARTY_APPS_FETCHING';
export const FETCH_THIRD_PARTY_APPS_SUCCESS = 'FETCH_THIRD_PARTY_APPS_SUCCESS';
export const FETCH_THIRD_PARTY_APPS_FAIL = 'FETCH_THIRD_PARTY_APPS_FAIL';
export const REMOVE_THIRD_PARTY_APP = 'REMOVE_THIRD_PARTY_APP';
export const DELETE_THIRD_PARTY_APP_DELETING = 'DELETE_THIRD_PARTY_APP_DELETING';
export const DELETE_THIRD_PARTY_APP_SUCCESS = 'DELETE_THIRD_PARTY_APP_SUCCESS';
export const DELETE_THIRD_PARTY_APP_FAIL = 'DELETE_THIRD_PARTY_APP_FAIL';
export const FETCH_THIRD_PARTY_APPS_PERMISSIONS = 'FETCH_THIRD_PARTY_APPS_PERMISSIONS';
export const FETCH_THIRD_PARTY_APPS_PERMISSIONS_FETCHING = 'FETCH_THIRD_PARTY_APPS_PERMISSIONS_FETCHING';
export const FETCH_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS = 'FETCH_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS';
export const FETCH_THIRD_PARTY_APPS_PERMISSIONS_FAIL = 'FETCH_THIRD_PARTY_APPS_PERMISSIONS_FAIL';
export const FETCH_THIRD_PARTY_APPS_CAPABILITIES = 'FETCH_THIRD_PARTY_APPS_CAPABILITIES';
export const FETCH_THIRD_PARTY_APPS_CAPABILITIES_FETCHING = 'FETCH_THIRD_PARTY_APPS_CAPABILITIES_FETCHING';
export const FETCH_THIRD_PARTY_APPS_CAPABILITIES_SUCCESS = 'FETCH_THIRD_PARTY_APPS_CAPABILITIES_SUCCESS';
export const FETCH_THIRD_PARTY_APPS_CAPABILITIES_FAIL = 'FETCH_THIRD_PARTY_APPS_CAPABILITIES_FAIL';

export const FETCH_THIRD_PARTY_APPS_AND_CAPABILITIES = 'FETCH_THIRD_PARTY_APPS_AND_CAPABILITIES';

export const UPDATE_THIRD_PARTY_APPS_PERMISSIONS = 'UPDATE_THIRD_PARTY_APPS_PERMISSIONS';
export const UPDATE_THIRD_PARTY_APPS_PERMISSIONS_UPDATING = 'UPDATE_THIRD_PARTY_APPS_PERMISSIONS_UPDATING';
export const UPDATE_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS = 'UPDATE_THIRD_PARTY_APPS_PERMISSIONS_SUCCESS';
export const UPDATE_THIRD_PARTY_APPS_PERMISSIONS_FAIL = 'UPDATE_THIRD_PARTY_APPS_PERMISSIONS_FAIL';

export const FETCH_OPTIONAL_FEATURE = 'FETCH_OPTIONAL_FEATURE';
export const FETCH_OPTIONAL_FEATURE_FETCHING = 'FETCH_OPTIONAL_FEATURE_FETCHING';
export const FETCH_OPTIONAL_FEATURE_SUCCESS = 'FETCH_OPTIONAL_FEATURE_SUCCESS';
export const FETCH_OPTIONAL_FEATURE_FAIL = 'FETCH_OPTIONAL_FEATURE_FAIL';
export const UPDATE_OPTIONAL_FEATURE = 'UPDATE_OPTIONAL_FEATURE';
export const UPDATE_OPTIONAL_FEATURE_UPDATING = 'UPDATE_OPTIONAL_FEATURE_UPDATING';
export const UPDATE_OPTIONAL_FEATURE_SUCCESS = 'UPDATE_OPTIONAL_FEATURE_SUCCESS';
export const UPDATE_OPTIONAL_FEATURE_FAIL = 'UPDATE_OPTIONAL_FEATURE_FAIL';

export const UPDATE_USER_BADGE_PRIVACY = 'UPDATE_USER_BADGE_PRIVACY';
export const UPDATE_USER_BADGE_PRIVACY_UPDATING = 'UPDATE_USER_BADGE_PRIVACY_UPDATING';
export const UPDATE_USER_BADGE_PRIVACY_UPDATE_SUCCESS = 'UPDATE_USER_BADGE_PRIVACY_UPDATE_SUCCESS';
export const UPDATE_USER_BADGE_PRIVACY_UPDATE_FAIL = 'UPDATE_USER_BADGE_PRIVACY_UPDATE_FAIL';

/** GC5 Dashboard */
export const FETCH_DASHBOARD_CONFIG = 'FETCH_DASHBOARD_CONFIG';
export const FETCH_DASHBOARD_CONFIG_FETCHING = 'FETCH_DASHBOARD_CONFIG_FETCHING';
export const FETCH_DASHBOARD_CONFIG_SUCCESS = 'FETCH_DASHBOARD_CONFIG_SUCCESS';
export const FETCH_DASHBOARD_CONFIG_FAIL = 'FETCH_DASHBOARD_CONFIG_FAIL';

export const UPDATE_DASHBOARD_CONFIG_DATA = 'UPDATE_DASHBOARD_CONFIG_DATA';
export const UPDATE_DASHBOARD_CONFIG_DATA_UPDATING = 'UPDATE_DASHBOARD_CONFIG_DATA_UPDATING';
export const UPDATE_DASHBOARD_CONFIG_DATA_SUCCESS = 'UPDATE_DASHBOARD_CONFIG_DATA_SUCCESS';
export const UPDATE_DASHBOARD_CONFIG_DATA_FAIL = 'UPDATE_DASHBOARD_CONFIG_DATA_FAIL';

export const FETCH_AVAILABLE_PRIMARY_STATS = 'FETCH_AVAILABLE_PRIMARY_STATS';
export const FETCH_AVAILABLE_PRIMARY_STATS_FETCHING = 'FETCH_AVAILABLE_PRIMARY_STATS_FETCHING';
export const FETCH_AVAILABLE_PRIMARY_STATS_SUCCESS = 'FETCH_AVAILABLE_PRIMARY_STATS_SUCCESS';
export const FETCH_AVAILABLE_PRIMARY_STATS_FAIL = 'FETCH_AVAILABLE_PRIMARY_STATS_FAIL';

export const FETCH_AVAILABLE_SECONDARY_STATS = 'FETCH_AVAILABLE_SECONDARY_STATS';
export const FETCH_AVAILABLE_SECONDARY_STATS_FETCHING = 'FETCH_AVAILABLE_SECONDARY_STATS_FETCHING';
export const FETCH_AVAILABLE_SECONDARY_STATS_SUCCESS = 'FETCH_AVAILABLE_SECONDARY_STATS_SUCCESS';
export const FETCH_AVAILABLE_SECONDARY_STATS_FAIL = 'FETCH_AVAILABLE_SECONDARY_STATS_FAIL';

export const SAVE_DASHBOARD_CONFIG = 'SAVE_DASHBOARD_CONFIG';
export const SAVE_DASHBOARD_CONFIG_SAVING = 'SAVE_DASHBOARD_CONFIG_SAVING';
export const SAVE_DASHBOARD_CONFIG_SUCCESS = 'SAVE_DASHBOARD_CONFIG_SUCCESS';
export const SAVE_DASHBOARD_CONFIG_FAIL = 'SAVE_DASHBOARD_CONFIG_FAIL';

export const FETCH_USER_FOCUS = 'FETCH_USER_FOCUS';
export const FETCH_USER_FOCUS_FETCHING = 'FETCH_USER_FOCUS_FETCHING';
export const FETCH_USER_FOCUS_SUCCESS = 'FETCH_USER_FOCUS_SUCCESS';
export const FETCH_USER_FOCUS_FAIL = 'FETCH_USER_FOCUS_FAIL';
export const UPDATE_USER_FOCUS = 'UPDATE_USER_FOCUS';
export const UPDATE_USER_FOCUS_UPDATING = 'UPDATE_USER_FOCUS_UPDATING';
export const UPDATE_USER_FOCUS_SUCCESS = 'UPDATE_USER_FOCUS_SUCCESS';
export const UPDATE_USER_FOCUS_FAIL = 'UPDATE_USER_FOCUS_FAIL';
export const FETCH_USER_FOCUSES_SUGGESTED = 'FETCH_USER_FOCUSES_SUGGESTED';
export const FETCH_USER_FOCUSES_SUGGESTED_FETCHING = 'FETCH_USER_FOCUSES_SUGGESTED_FETCHING';
export const FETCH_USER_FOCUSES_SUGGESTED_SUCCESS = 'FETCH_USER_FOCUSES_SUGGESTED_SUCCESS';
export const FETCH_USER_FOCUSES_SUGGESTED_FAIL = 'FETCH_USER_FOCUSES_SUGGESTED_FAIL';

export const SET_FOCUS_MODAL_OPEN = 'SET_FOCUS_MODAL_OPEN';

export const FETCH_RACE_EVENT_PROVIDERS = 'FETCH_RACE_EVENT_PROVIDERS';
export const FETCH_RACE_EVENT_PROVIDERS_FETCHING = 'FETCH_RACE_EVENT_PROVIDERS_FETCHING';
export const FETCH_RACE_EVENT_PROVIDERS_SUCCESS = 'FETCH_RACE_EVENT_PROVIDERS_SUCCESS';
export const FETCH_RACE_EVENT_PROVIDERS_FAIL = 'FETCH_RACE_EVENT_PROVIDERS_FAIL';

export const ADD_TEMPORARY_EVENT = 'ADD_TEMPORARY_EVENT';
export const REMOVE_TEMPORARY_EVENT = 'REMOVE_TEMPORARY_EVENT';

/** create challenge page */
export const CREATE_CHALLENGE_PAGE_INIT = 'CREATE_CHALLENGE_PAGE_INIT';
export const CREATE_CHALLENGE_PAGE_RESET = 'CREATE_CHALLENGE_PAGE_RESET';
export const CREATE_CHALLENGE_PAGE_SET_STEP = 'CREATE_CHALLENGE_PAGE_SET_STEP';
export const CREATE_CHALLENGE_PAGE_SET_CHALLENGE_TYPE = 'CREATE_CHALLENGE_PAGE_SET_CHALLENGE_TYPE';
export const CREATE_CHALLENGE_PAGE_SET_PARTICIPANT_TYPE = 'CREATE_CHALLENGE_PAGE_SET_PARTICIPANT_TYPE';
export const CREATE_CHALLENGE_PAGE_SET_DURATION_TYPE = 'CREATE_CHALLENGE_PAGE_SET_DURATION_TYPE';
export const CREATE_CHALLENGE_PAGE_SET_DURATION_START_DATE = 'CREATE_CHALLENGE_PAGE_SET_DURATION_START_DATE';
export const CREATE_CHALLENGE_PAGE_SET_DURATION_END_DATE = 'CREATE_CHALLENGE_PAGE_SET_DURATION_END_DATE';
export const CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS = 'CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS';
export const CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS_DONE = 'CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS_DONE';
export const CREATE_CHALLENGE_PAGE_CHECK_PARTICIPANT = 'CREATE_CHALLENGE_PAGE_CHECK_PARTICIPANT';
export const CREATE_CHALLENGE_PAGE_SUBMIT = 'CREATE_CHALLENGE_PAGE_SUBMIT';
export const CREATE_CHALLENGE_PAGE_SUBMIT_DONE = 'CREATE_CHALLENGE_PAGE_SUBMIT_DONE';
export const CREATE_CHALLENGE_PAGE_CLOSE_NOTIFICATION = 'CREATE_CHALLENGE_PAGE_CLOSE_NOTIFICATION';
export const CREATE_CHALLENGE_PAGE_SET_SUMMARY_DIALOG_STATE = 'CREATE_CHALLENGE_PAGE_SET_SUMMARY_DIALOG_STATE';
export const CREATE_CHALLENGE_PAGE_SET_DISCARD_DIALOG_STATE = 'CREATE_CHALLENGE_PAGE_SET_DISCARD_DIALOG_STATE';

/** Training plans */
export const FETCH_TRAINING_PLANS = 'FETCH_TRAINING_PLANS';
export const FETCH_TRAINING_PLANS_FETCHING = 'FETCH_TRAINING_PLANS_FETCHING';
export const FETCH_TRAINING_PLANS_SUCCESS = 'FETCH_TRAINING_PLANS_SUCCESS';
export const FETCH_TRAINING_PLANS_FAIL = 'FETCH_TRAINING_PLANS_FAIL';
export const FETCH_SELF_GUIDED_PLAN = 'FETCH_SELF_GUIDED_PLAN';
export const FETCH_SELF_GUIDED_PLAN_FETCHING = 'FETCH_SELF_GUIDED_PLAN_FETCHING';
export const FETCH_SELF_GUIDED_PLAN_SUCCESS = 'FETCH_SELF_GUIDED_PLAN_SUCCESS';
export const FETCH_SELF_GUIDED_PLAN_FAIL = 'FETCH_SELF_GUIDED_PLAN_FAIL';
export const FETCH_ALL_SELF_GUIDED_PLAN = 'FETCH_ALL_SELF_GUIDED_PLAN';
export const FETCH_ALL_SELF_GUIDED_PLAN_FETCHING = 'FETCH_ALL_SELF_GUIDED_PLAN_FETCHING';
export const FETCH_ALL_SELF_GUIDED_PLAN_SUCCESS = 'FETCH_ALL_SELF_GUIDED_PLAN_SUCCESS';
export const FETCH_ALL_SELF_GUIDED_PLAN_FAIL = 'FETCH_ALL_SELF_GUIDED_PLAN_FAIL';
export const FETCH_ACTIVE_PLANS = 'FETCH_ACTIVE_PLANS';
export const FETCH_ACTIVE_PLANS_FETCHING = 'FETCH_ACTIVE_PLANS_FETCHING';
export const FETCH_ACTIVE_PLANS_SUCCESS = 'FETCH_ACTIVE_PLANS_SUCCESS';
export const FETCH_ACTIVE_PLANS_FAIL = 'FETCH_ACTIVE_PLANS_FAIL';
export const RESET_ACTIVE_PLANS = 'RESET_ACTIVE_PLANS';
export const SET_TRAINING_PLAN_STATUS = 'SET_TRAINING_PLAN_STATUS';

/** Firstbeat Daily Suggested Workout (DSW) / Adaptive Coaching Training Plans */
export const FETCH_ADAPTIVE_COACHING_PLAN = 'FETCH_ADAPTIVE_COACHING_PLAN';
export const FETCH_ADAPTIVE_COACHING_PLAN_FETCHING = 'FETCH_ADAPTIVE_COACHING_PLAN_FETCHING';
export const FETCH_ADAPTIVE_COACHING_PLAN_SUCCESS = 'FETCH_ADAPTIVE_COACHING_PLAN_SUCCESS';
export const FETCH_ADAPTIVE_COACHING_PLAN_FAIL = 'FETCH_ADAPTIVE_COACHING_PLAN_FAIL';
export const FETCH_ADAPTIVE_COACHING_EVENTS = 'FETCH_ADAPTIVE_COACHING_EVENTS';
export const FETCH_ADAPTIVE_COACHING_EVENTS_FETCHING = 'FETCH_ADAPTIVE_COACHING_EVENTS_FETCHING';
export const FETCH_ADAPTIVE_COACHING_EVENTS_SUCCESS = 'FETCH_ADAPTIVE_COACHING_EVENTS_SUCCESS';
export const FETCH_ADAPTIVE_COACHING_EVENTS_FAIL = 'FETCH_ADAPTIVE_COACHING_EVENTS_FAIL';
export const UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION = 'UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION';
export const UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_UPDATING = 'UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_UPDATING';
export const UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_SUCCESS = 'UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_SUCCESS';
export const UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_FAIL = 'UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_FAIL';
export const DELETE_ADAPTIVE_COACHING_PLAN = 'DELETE_ADAPTIVE_COACHING_PLAN';
export const DELETING_ADAPTIVE_COACHING_PLAN = 'DELETING_ADAPTIVE_COACHING_PLAN';
export const DELETE_ADAPTIVE_COACHING_PLAN_SUCCESS = 'DELETE_ADAPTIVE_COACHING_PLAN_SUCCESS';
export const DELETE_ADAPTIVE_COACHING_PLAN_FAIL = 'DELETE_ADAPTIVE_COACHING_PLAN_FAIL';

/** Daily Suggested Workout (DSW) / Strength Training Plans (STP) */
export const FETCH_STRENGTH_TRAINING_PLAN = 'FETCH_STRENGTH_TRAINING_PLAN';
export const FETCH_STRENGTH_TRAINING_PLAN_FETCHING = 'FETCH_STRENGTH_TRAINING_PLAN_FETCHING';
export const FETCH_STRENGTH_TRAINING_PLAN_SUCCESS = 'FETCH_STRENGTH_TRAINING_PLAN_SUCCESS';
export const FETCH_STRENGTH_TRAINING_PLAN_FAIL = 'FETCH_STRENGTH_TRAINING_PLAN_FAIL';

export const FETCH_SOCIAL_GROUP_RIDE = 'FETCH_SOCIAL_GROUP_RIDE';
export const FETCH_SOCIAL_GROUP_RIDE_SUCCESS = 'FETCH_SOCIAL_GROUP_RIDE_SUCCESS';
export const FETCH_SOCIAL_GROUP_RIDE_FAIL = 'FETCH_SOCIAL_GROUP_RIDE_FAIL';
export const DELETE_SOCIAL_GROUP_RIDE_USER_DATA = 'DELETE_SOCIAL_GROUP_RIDE_DATA';
export const DELETE_SOCIAL_GROUP_RIDE_USER_DATA_SUCCESS = 'DELETE_SOCIAL_GROUP_RIDE_DATA_SUCCESS';
export const DELETE_SOCIAL_GROUP_RIDE_USER_DATA_ERROR = 'DELETE_SOCIAL_GROUP_RIDE_DATA_ERROR';
export const FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS = 'FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS';
export const FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS_SUCCESS = 'FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS_SUCCESS';
export const DISMISS_SOCIAL_GROUP_RIDE_DATA_DELETE_SUCCESS = 'DISMISS_SOCIAL_GROUP_RIDE_DATA_DELETE_SUCCESS';

/** Image paths */
export const FETCH_CROSS_SELL_AD_IMAGES = 'FETCH_CROSS_SELL_AD_IMAGES,';
export const FETCH_CROSS_SELL_AD_IMAGES_FETCHING = 'FETCH_CROSS_SELL_AD_IMAGES_FETCHING,';
export const FETCH_CROSS_SELL_AD_IMAGES_SUCCESS = 'FETCH_CROSS_SELL_AD_IMAGES_SUCCESS,';
export const FETCH_CROSS_SELL_AD_IMAGES_FAIL = 'FETCH_CROSS_SELL_AD_IMAGES_FAIL';

export const FETCH_FBT_WORKOUT = 'FETCH_FBT_WORKOUT';

/** china interpreter */
export const CHINA_INTERPRETER_SET_PACEPRO = 'CHINA_INTERPRETER_SET_PACEPRO';
export const CHINA_INTERPRETER_SET_PACEPROCREATE = 'CHINA_INTERPRETER_SET_PACEPROCREATE';
export const CHINA_INTERPRETER_SET_POWERGUIDANCE = 'CHINA_INTERPRETER_SET_POWERGUIDANCE';
export const CHINA_INTERPRETER_SET_POWERGUIDANCE_ALGO_DATA = 'CHINA_INTERPRETER_SET_POWERGUIDANCE_ALGO_DATA';
export const CHINA_INTERPRETER_RESET = 'CHINA_INTERPRETER_RESET';

/* Timing gates action types */
export const SET_PREVIEW_RUN = 'SET_PREVIEW_RUN';
export const SET_SELECTED_RUN = 'SET_SELECTED_RUN';
export const SET_TIMING_GATES = 'SET_TIMING_GATES';
export const SET_SELECTED_SPLIT = 'SET_SELECTED_SPLIT';
export const RESET_STATE = 'RESET_STATE';

/* Training Guidance */
export const SET_FROM_TRAINING_GUIDANCE = 'SET_FROM_TRAINING_GUIDANCE';
export const CLEAR_FROM_TRAINING_GUIDANCE = 'CLEAR_FROM_TRAINING_GUIDANCE';
